import type { Translations } from '../index';

export const fr: Translations = {
  errors: {
    generic: {
      unknownTitle: "L'action n'a pas abouti",
      unknownMessage: 'Votre travail est sauvegardé. Veuillez réessayer dans un instant.',
      badRequestTitle: "Nous n'avons pas pu traiter cette demande",
      badRequestMessage: 'Veuillez vérifier les informations indiquées et réessayer.',
      notFoundTitle: 'Introuvable',
      notFoundMessage: "Nous n'avons pas trouvé ce que vous cherchiez. Cela a peut-être été déplacé ou supprimé.",
      conflictTitle: 'Cela existe déjà',
      conflictMessage: 'Cet élément existe déjà ou a été modifié ailleurs. Actualisez et réessayez.',
      unsupportedFileTitle: 'Fichier non pris en charge',
      unsupportedFileMessage: "Ce type de fichier n'est pas pris en charge ici. Essayez un autre fichier.",
      fileTooLargeTitle: 'Fichier trop volumineux',
      fileTooLargeMessage: 'Ce fichier dépasse la taille autorisée. Essayez un fichier plus petit.',
      retry: 'Réessayer',
      dismiss: 'Fermer',
    },
    network: {
      offlineTitle: 'Vous semblez hors ligne',
      offlineMessage: 'Vérifiez votre connexion internet et réessayez.',
      timeoutTitle: 'Cela prend plus de temps que prévu',
      timeoutMessage: 'La demande a expiré. Votre travail est enregistré — veuillez réessayer.',
      serviceUnavailableTitle: 'Service temporairement indisponible',
      serviceUnavailableMessage: 'Nous sommes brièvement indisponibles. Réessayez dans quelques secondes.',
      serverErrorTitle: 'Notre service rencontre un problème',
      serverErrorMessage: 'Nous avons été informés et travaillons dessus. Veuillez réessayer sous peu.',
    },
    auth: {
      sessionExpiredTitle: 'Votre session a expiré',
      sessionExpiredMessage: 'Pour votre sécurité, veuillez vous reconnecter pour continuer.',
      signInCta: 'Se connecter',
      invalidCredentialsTitle: 'E-mail ou mot de passe incorrect',
      invalidCredentialsMessage: 'Vérifiez vos identifiants et réessayez.',
      accountLockedTitle: 'Compte temporairement verrouillé',
      accountLockedMessage: 'Trop de tentatives. Veuillez réessayer dans quelques minutes.',
      accountDeactivatedTitle: 'Compte désactivé',
      accountDeactivatedMessage: 'Ce compte est désactivé. Veuillez contacter votre administrateur.',
      forbiddenTitle: "Vous n'avez pas accès",
      forbiddenMessage: "Vous n'avez pas l'autorisation pour cette action.",
      invalidCodeTitle: "Ce code n'a pas fonctionné",
      invalidCodeMessage: 'Le code de vérification est invalide ou a expiré. Demandez-en un nouveau.',
      currentPasswordWrongTitle: 'Le mot de passe actuel est incorrect',
      currentPasswordWrongMessage: 'Saisissez à nouveau votre mot de passe actuel et réessayez.',
      userExistsTitle: 'Le compte existe déjà',
      userExistsMessage: 'Un compte avec cet e-mail existe déjà. Essayez de vous connecter.',
    },
    credits: {
      insufficientTitle: 'Crédits insuffisants',
      insufficientMessage: "Vous n'avez pas assez de crédits pour terminer. Ajoutez des crédits ou améliorez votre forfait pour continuer.",
      buyCreditsCta: 'Acheter des crédits',
      minAmountTitle: 'Montant trop faible',
      minAmountMessage: 'L’achat minimum est de 10 crédits.',
      invalidAmountTitle: 'Saisissez un montant valide',
      invalidAmountMessage: 'Veuillez saisir un nombre de crédits valide.',
      noPaymentMethodTitle: 'Ajoutez un moyen de paiement',
      noPaymentMethodMessage: 'Ajoutez un moyen de paiement avant de continuer.',
      checkoutFailedTitle: "Le paiement n'a pas pu démarrer",
      checkoutFailedMessage: "Nous n'avons pas pu ouvrir le paiement. Veuillez réessayer.",
      subscriptionRequiredTitle: 'Abonnement requis',
      subscriptionRequiredMessage: 'Vous devez avoir un forfait payant actif pour acheter des crédits. Souscrivez d’abord à un forfait.',
      subscribeCta: 'Voir les forfaits',
    },
    orders: {
      notFoundTitle: 'Commande introuvable',
      notFoundMessage: "Cette commande n'existe pas ou vous n'y avez pas accès.",
      accessDeniedTitle: 'Accès refusé',
      accessDeniedMessage: "Vous n'avez pas accès à cette commande.",
      readOnlyTitle: 'Accès en lecture seule',
      readOnlyMessage: 'Votre accès est en lecture seule : vous pouvez consulter la commande, mais pas la faire avancer',
      createFailedTitle: "Nous n'avons pas pu créer votre commande",
      createFailedMessage: 'Un problème a interrompu la création de la commande. Votre fichier est toujours là — veuillez réessayer.',
    },
    corpus: {
      notFoundTitle: 'Corpus introuvable',
      notFoundMessage: "Ce corpus n'existe pas ou a été supprimé.",
      duplicateTermTitle: 'Terme en double',
      duplicateTermMessage: 'Ce terme est déjà dans le glossaire.',
    },
    plan: {
      limitTitle: 'Limite de votre forfait atteinte',
      limitMessage: 'Vous avez atteint la limite de votre forfait actuel. Améliorez-le pour continuer.',
      upgradeCta: 'Améliorer le forfait',
      alreadyFreeTitle: 'Vous êtes sur le forfait Gratuit',
      alreadyFreeMessage: 'Vous êtes déjà sur le forfait Gratuit. Choisissez un forfait payant pour en débloquer plus.',
    },
    processing: {
      timeoutTitle: 'Le traitement prend trop de temps',
      timeoutMessage: 'Le service de documents a expiré. Votre fichier est en sécurité — veuillez réessayer.',
      failedTitle: "Nous n'avons pas pu terminer le traitement",
      failedMessage: 'Un problème a interrompu le traitement. Veuillez réessayer.',
    },
  },
  formatTemplates: {
    title: 'Modèles de format',
    subtitle: "Définissez la feuille, les marges, la police, l’en-tête, la numérotation, les tirets de remplissage et la formule de clôture. Le modèle s’applique à l’Option 4 lors de la révision d’une commande.",
    adminTitle: 'Modèles de format globaux',
    adminSubtitle: "Modèles EZDocu disponibles pour tous les comptes. Chaque compte choisit lequel activer (ou aucun) ; ils ne s’appliquent jamais automatiquement.",
    newTemplate: 'Nouveau modèle',
    newGlobalTemplate: 'Nouveau modèle global',
    duplicateBtn: 'Dupliquer',
    duplicateFromGlobalHint: 'Crée votre propre copie modifiable de ce modèle EZDocu',
    editBtn: 'Modifier',
    deleteBtn: 'Supprimer',
    confirmDeleteBtn: 'Supprimer ?',
    setDefaultBtn: 'Par défaut',
    defaultBadge: 'Par défaut',
    globalBadge: 'EZDocu',
    ownBadge: 'Personnel',
    myTemplates: 'Mes modèles',
    globalTemplates: 'Modèles EZDocu',
    filterAll: 'Tous',
    filterGlobal: 'Globaux',
    filterAccounts: 'Des comptes',
    loading: 'Chargement des modèles…',
    empty: 'Vous n’avez pas encore de modèle personnel. Dupliquez un modèle EZDocu ou créez-en un nouveau.',
    emptyAdmin: 'Aucun modèle.',
    copySuffix: '(copie)',
    errorGeneric: 'Le modèle n’a pas pu être enregistré',
    summaryHeader: 'En-tête',
    summaryNumbering: 'Numérotation',
    summaryFill: 'Tirets',
    summaryClosing: 'Clôture',
    yes: 'oui',
    off: 'non',
    sectionGeneral: 'Général',
    sectionPage: 'Feuille, marges et typographie',
    sectionTypography: 'Typographie',
    sectionHeaderFooter: 'En-tête et pied de page',
    sectionNumbering: 'Numérotation des pages',
    sectionFill: 'Remplissage des lignes courtes',
    sectionClosing: 'Formule de clôture',
    fieldName: 'Nom',
    fieldDescription: 'Description',
    fieldPageFormat: 'Format de feuille',
    fieldOrientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Paysage',
    a4: 'A4',
    letter: 'Lettre',
    legal: 'Légal',
    fieldMarginTop: 'Haut (mm)',
    fieldMarginBottom: 'Bas (mm)',
    fieldMarginLeft: 'Gauche (mm)',
    fieldMarginRight: 'Droite (mm)',
    fieldFontFamily: 'Police',
    fieldFontSize: 'Taille (pt)',
    fieldLineHeight: 'Interligne',
    fieldTextAlign: 'Alignement',
    alignJustify: 'Justifié',
    alignLeft: 'Gauche',
    alignCenter: 'Centre',
    alignRight: 'Droite',
    fieldParagraphSpaceAfter: 'Après paragraphe (pt)',
    fieldHeaderEnabled: 'En-tête sur les pages',
    fieldHeaderText: 'Texte de l’en-tête',
    fieldHeaderAlign: 'Alignement',
    fieldHeaderMode: 'Sur quelles pages',
    headerModeAll: 'Toutes',
    headerModeFirst: 'La première seulement',
    headerModeRest: 'Toutes sauf la première',
    fieldHeaderFontSize: 'Taille de police (pt)',
    fieldHeaderFontSizeHint: 'Comme le corps',
    fieldFooterEnabled: 'Pied de page',
    fieldFooterText: 'Texte du pied de page',
    fieldPageNumbering: 'Numéroter les pages',
    fieldPageNumberFormat: 'Format',
    numberFormatN: '1, 2, 3',
    numberFormatNdeM: 'Page 1 sur N',
    numberFormat00n: '001, 002',
    fieldPageNumberStart: 'Commencer à',
    fieldPageNumberPosition: 'Position',
    posFooterCenter: 'Pied de page, centré',
    posFooterRight: 'Pied de page, droite',
    posHeaderRight: 'En-tête, droite',
    fieldFillShortLines: 'Compléter les lignes courtes par des tirets',
    fieldFillChar: 'Caractère',
    fieldFillScope: 'Où',
    fillScopeParagraphEnd: 'Dernière ligne de chaque paragraphe',
    fillScopeLine: 'Toute ligne courte',
    fillScopeBlankOnly: 'Lignes vides seulement',
    fieldClosingEnabled: 'Ajouter la formule de clôture',
    fieldClosingHtml: 'Texte (HTML simple)',
    fieldClosingKeepTogether: 'La garder avec le dernier paragraphe (jamais seule sur une nouvelle page)',
    variablesHint: 'Variables disponibles (cliquer pour copier) :',
    previewTitle: "Aperçu en direct",
    previewDocxBtn: "Word d’exemple",
    previewDocxError: "Impossible de générer le Word d’exemple",
    mirrorMakeEditable: "Modifier comme format personnel",
    mirrorSheetNote: "Le document sort tel qu'il est aujourd'hui",
    verifiedBadge: "Vérifié",
    alreadyInMenu: "Déjà dans votre menu",
    detectSaveDirect: "Enregistrer tel quel",
    swipeForMore: "Faites défiler pour plus de formats →",
    orderFormatLabel: "Format de sortie",
    orderFormatHint: "Décide de la sortie de l'Option 4. Modifiable aussi en Révision, sans retraitement.",
    previewRealLoading: "Génération de l’aperçu réel…",
    closingLangLabel: "Langue de la formule de serment",
    closingLangEs: "Telle qu’écrite dans le modèle (non traduite)",
    closingLangTarget: "Traduite dans la langue cible de la commande",
    smallMarginWarn: "Une marge inférieure à 10 mm peut être coupée à l'impression.",
    colEmpty: "Vide",
    colText: "Texte",
    colPageNum: "Numéro de page",
    colTextPlaceholder: "Texte de la colonne",
    colRemove: "Retirer",
    colAdd: "Ajouter une colonne",
    colSwitchToColumns: "Construire par colonnes (jusqu'à 4)",
    fieldFooterRule: "Ligne imprimée au-dessus du pied",
    sectionRules: "Règles du document",
    fieldLineNumbering: "Numéroter les lignes (format judiciaire)",
    fieldLinesPerPage: "Lignes par page",
    fieldLineNumberRule: "Règle verticale",
    lineNumberingHint: "Les numéros se recalculent seuls dans Word : ils vivent dans la section, jamais écrits comme du texte.",
    pinBtn: "Épingler",
    pinnedBadge: "Épinglé",
    pinHint: "Les formats épinglés apparaissent lors de la préparation d'une commande",
    addToMenuBtn: "Ajouter à mon menu",
    deleteInUseConfirm: "Ce format a été utilisé dans {n} commande(s). Les commandes livrées ne changent pas. Le supprimer quand même ?",
    deleteInUseConfirmOne: "Ce format a été utilisé dans {n} commande. Les commandes livrées ne changent pas. Le supprimer quand même ?",
    deleteInUseConfirmOther: "Ce format a été utilisé dans {n} commandes. Les commandes livrées ne changent pas. Le supprimer quand même ?",
    searchPlaceholder: "Rechercher un format…",
    catAll: "Tous",
    catGeneral: "Général",
    catCertified: "Assermentée",
    catCourt: "Tribunaux",
    pickerNoPinned: "Aucun format épinglé. Épinglez ceux que vous utilisez dans Formats pour les voir ici.",
    uploadWordBtn: "Importer votre Word",
    detectTitle: "Voici ce que contient votre Word",
    detectReading: "Lecture du fichier…",
    detectIntro: "Ces propriétés ont été lues depuis {file}. Ce qui n'a pas été trouvé est indiqué tel quel — rien n'est rempli en douce.",
    detectNotFound: "Introuvable",
    detectYes: "Oui",
    detectNo: "Non",
    detectHint: "Dans l'éditeur, vous pourrez compléter ce qui manque et voir le résultat sur le papier, en direct.",
    detectOpenEditor: "Ouvrir dans l'éditeur",
    detectFailed: "Impossible de lire le fichier. Est-ce un .docx de 20 Mo max ?",
    previewPageOf: "Page {n} sur {m}",
    previewTabScreen: "Écran",
    previewTabWord: "Word",
    previewTabPdf: "PDF",
    previewAllMatch: "Écran, Word et PDF sont identiques",
    previewGuides: "Afficher les repères",
    previewGuideHeader: "En-tête",
    previewGuideFooter: "Pied de page",
    previewGuideContent: "Contenu",
    previewRuler: "Règle",
    previewRulerDrag: "Faites glisser pour modifier la marge",
    previewSample1: "ACTE DE NAISSANCE",
    previewSample2: "Je certifie que la présente est une traduction fidèle du document original que j'ai eu sous les yeux. L'intéressé est né dans la ville indiquée et ses données figurent au registre correspondant.",
    previewSample3: "Les données de l'acte concordent avec celles du document présenté, et l'original ne comporte ni ratures ni surcharges.",
    previewClosingSignature: "Signature et sceau du traducteur",
    previewPageBreak: "saut de page",
    mirrorNotice: "Miroir de l'original : ce format reproduit le document tel qu'il sort aujourd'hui. La page, la typographie et les règles ne s'appliquent pas.",
    saveBtn: 'Enregistrer',
    savingBtn: 'Enregistrement…',
    cancelBtn: 'Annuler',
    backBtn: 'Retour',
    unsavedConfirm: 'Vous avez des modifications non enregistrées. Quitter sans enregistrer ?',
    savedOk: 'Enregistré',
    unsavedTitle: 'Modifications non enregistrées',
    unsavedStay: 'Rester',
    unsavedLeave: 'Quitter sans enregistrer',
    variablesLangHint: "Les variables de langue, de mois et de date s'écrivent automatiquement dans la langue cible de la traduction.",
    closingSignatureToggle: "Ajouter signature et cachet (image)",
    closingSignatureUpload: "Téléverser l'image de signature/cachet",
    closingSignatureRemove: "Retirer l'image",
    createBtn: 'Créer',
    defaultCardLabel: 'Modèle de format par défaut',
    defaultCardHint: "Activez-le pour que vos commandes aient aussi l’Option 4 avec ce format",
    defaultNone: "Aucun modèle (l’Option 4 n’est pas générée)",
    defaultManageLink: 'Gérer les modèles',
    defaultSaved: 'Enregistré',
    pickerLabel: 'Modèle',
    pickerApplying: 'Application…',
    pickerError: 'Le modèle n’a pas pu être appliqué',
    pickerNone: "Original",
    wordOnly: "Le fichier doit être un document Word (.docx).",
    noMatches: "Aucun format ne correspond à « {q} ».",
    dropWordHere: "Déposez le .docx pour lire sa mise en forme",
    dragWordOrClick: "Glissez un fichier Word ici ou cliquez pour l’importer ({btn})",
    privacyNote: "Le fichier sert uniquement à lire la mise en forme : son contenu n’est pas conservé et il est supprimé à la fin.",
    fieldUnit: "Unité",
    unitCm: "Centimètres (cm)",
    unitIn: "Pouces (in)",
    ruleRepeatSeal: "Répéter le cachet et la signature sur chaque page",
    ruleDescribeIllegible: "Décrire les cachets/signatures illisibles",
    ruleInvalidateBack: "Annuler le verso",
    ruleSingleSided: "Impression recto seul",
    colImage: "Image",
    colImageLogo: "Logo",
    colImageSignature: "Signature",
    colImageSeal: "Cachet",
    colImageRemove: "Retirer l’image personnalisée",
    colImageUpload: "Téléverser une image",
    colImageUploading: "Téléversement…",
    colImageTooBig: "2 Mo max.",
    colImageUploadError: "Impossible de téléverser l’image",
    colSizeS: "Petite",
    colSizeM: "Moyenne",
    colSizeL: "Grande",
    colSizeCustom: "Personnalisée",
    detectHeaderImage: "Image de l’en-tête",
    detectFooterImage: "Image du pied de page",
    sampleFileName: "{name} (exemple {time})",
    sampleDefaultName: "format",
    errHeaderEmpty: "L’en-tête est activé mais n’a ni texte ni colonnes.",
    errClosingEmpty: "La formule de clôture est activée mais n’a pas de texte.",
    errNameRequired: "Le nom est obligatoire.",
    errInvalidValue: "Une valeur est hors limites. Vérifiez les marges, les tailles, l’interligne et la numérotation.",
    lockedNotice: "Ce format est vérifié : la norme ne permet pas de modifier ces champs. Dupliquez-le si vous avez besoin d’une autre configuration.",
    marginsBox: "Marges",
    marginsLink: "Identiques",
    marginsLinkHint: "Rend les quatre marges identiques ; tant qu’il est actif, en modifier une les modifie toutes",
    bandToolbarLabel: "Modifier les blocs",
    blockMoveLeft: "Déplacer vers la gauche",
    blockMoveRight: "Déplacer vers la droite",
    blockDelete: "Supprimer le bloc",
    blockDrag: "Faites glisser pour réordonner (ou appuyez sur Espace et utilisez les flèches)",
    blockDragInstructions: "Pour réordonner au clavier, appuyez sur Espace, déplacez le bloc avec les flèches et appuyez de nouveau sur Espace pour le déposer.",
    blockTextLabel: "Texte du bloc",
    blockTextPlaceholder: "Écrivez ici",
    blockTextEditorHint: "Échap pour terminer",
    blockImageHeight: "Hauteur (mm)",
    blockImageResize: "Hauteur de l’image",
    blockImageProfile: "{img} du profil",
    bandEmpty: "Aucun bloc pour l’instant. Ajoutez du texte, une image ou le numéro de page.",
    bandHeaderEmptyWarn: "L’en-tête est activé mais vide : écrivez quelque chose ou désactivez-le.",
    bandAutoPageNum: "Numéro de page automatique : à régler dans « Numérotation des pages »",
    bandOrderHint: "De gauche à droite, comme sur la feuille. Vous pouvez aussi les modifier dans l’aperçu.",
    bandClickToEdit: "Cliquez pour modifier",
    blocksHeader: "Blocs de l’en-tête",
    blocksFooter: "Blocs du pied de page",
    bandSheetHint: "Cliquez sur l’en-tête ou le pied de page de la feuille pour les modifier",
    blockMaxReached: "4 blocs maximum par bande",
    blockPageNumExists: "Cette bande a déjà le numéro de page",
    blockImageLocked: "La norme de ce format n’admet pas d’images ici",
    blockDeleted: "Bloc supprimé",
    blockUndo: "Annuler",
    blockImageChange: "Changer l’image…",
    blockImageUploadNew: "Importer une image…",
    previewEditingMockup: "Modification sur la maquette",
    previewShowReal: "Voir la feuille réelle",
    previewZoom: "Zoom de l’aperçu",
    previewZoomOut: "Zoom arrière",
    previewZoomIn: "Zoom avant",
    previewZoomActual: "Taille réelle (100 %)",
    previewZoomFit: "Ajuster à la largeur",
    fieldHeaderDistance: "Distance de l’en-tête au bord ({unit})",
    fieldFooterDistance: "Distance du pied de page au bord ({unit})",
    bandDistanceHint: "Comme dans Word : si l’en-tête ou le pied de page ne tient pas dans la marge, le texte se décale pour lui faire de la place. Dans les repères, la ligne pointillée indique cette distance.",
    bandDistanceTooBig: "La distance ne tient pas sur cette feuille : elle peut être au maximum de {max} depuis le bord.",
    bandHeaderPushes: "L’en-tête ne tient pas dans la marge : le texte commence à {x}, comme dans Word et en PDF.",
    bandFooterPushes: "Le pied de page ne tient pas dans la marge : le texte se termine à {x} du bord, comme dans Word et en PDF.",
    marginsTooBig: "Les marges ne tiennent pas sur cette feuille : laissez au moins {min} de zone de texte en largeur et en hauteur.",
    bandFieldPlaceholderHeader: "Saisissez l’en-tête…",
    bandFieldPlaceholderFooter: "Saisissez le pied de page…",
    bandFieldHint: "Ce que vous voyez ici est ce qui sort sur la feuille, dans le PDF et dans le Word. Cliquez sur la feuille pour revenir à ce champ.",
    bandAlignLeft: "Aligner à gauche",
    bandAlignCenter: "Centrer",
    bandAlignRight: "Aligner à droite",
    bandImage: "Image",
    bandImageHeightTitle: "Hauteur de l’image",
    bandImageHeightField: "Hauteur en mm (de 5 à 60)",
    bandImageSmaller: "Plus petite",
    bandImageBigger: "Plus grande",
    bandImageRemove: "Retirer l’image",
    bandImagesMax: "{n} images maximum par en-tête ou pied de page",
    bandImageNotAllowed: "Cette image ne peut pas être utilisée ici : importez-la depuis votre ordinateur.",
    bandPageNumber: "Numéro de page",
    bandColumns: "Colonnes",
    bandColumns2: "2 colonnes",
    bandColumns3: "3 colonnes",
    bandColumnsRemove: "Retirer les colonnes",
    bandColumnsOnlyOne: "Cet en-tête ou ce pied de page a déjà une rangée de colonnes",
    bandLinesMax: "L’en-tête ou le pied de page a déjà le nombre maximal de lignes",
    bandNumberOff: "La numérotation est désactivée : ce numéro ne sera pas imprimé.",
    bandNumberInBand: "Le numéro de page se place là où vous l’avez mis dans l’en-tête ou le pied de page.",
    bandNumberTwice: "Il y a un numéro de page dans l’en-tête et dans le pied de page.",
    bandEditorFailed: "L’éditeur ne s’est pas chargé. Rechargez la page pour modifier ; ce qui est enregistré ne change pas.",
    bandEditorRetry: "Réessayer",
    bandRichNotSaved: "Le serveur ne prend pas encore en charge cet en-tête ou ce pied de page : seul son texte a été enregistré. Enregistrez à nouveau dans quelques minutes.",
    bandDialogApply: "Appliquer",
    bandDialogCancel: "Annuler",
    bandTooLong: "Cet en-tête ou ce pied de page a trop de mise en forme : retirez un peu de gras, d’italique ou de soulignement.",
    bandImagesTooTall: "Les images occupent déjà la hauteur maximale ({mm} mm).",
    bandNumberNotAllPages: "L’en-tête ne figure pas sur toutes les pages : le numéro de page non plus.",
  },
  sidebar: {
    formatTemplates: 'Mise en forme',
    hubspot: 'HubSpot',
    payments: 'Paiements',
    aiCosts: 'Coûts IA',
    campaignCodes: 'Codes',
    ambassadorApplications: 'Candidatures d\'ambassadeurs',
    ambassadors: 'Ambassadeurs',
    applications: 'Candidatures',
    invite: 'Inviter',
    ambassadorAccount: 'Compte ambassadeur',
    adminAccount: 'Panneau d\'administration',
    ambassadorHome: 'Accueil',
    ambassadorReferrals: 'Mes parrainages',
    ambassadorCommissions: 'Commissions',
    ambassadorNetwork: 'Mon réseau',
    asistente: 'Assistant',
    overview: 'Vue d\'ensemble',
    accounts: 'Comptes',
    users: 'Utilisateurs',
    logs: 'Journaux',
    waitlist: 'Liste d\'attente',
    templates: 'Modèles',
    analytics: 'Analytique',
    dashboard: 'Tableau de bord',
    orders: 'Commandes',
    team: 'Équipe',
    credits: 'Crédits',
    certificate: 'Certificat',
    settings: 'Paramètres',
    myTasks: 'Mes tâches',
    myWorkspace: 'Mon espace de travail',
    account: 'Compte',
    activity: 'Activité',
    plans: 'Plans',
    features: 'Fonctionnalités',
    signOut: 'Se déconnecter',
    closeSidebar: 'Fermer la barre latérale',
    openSidebar: 'Ouvrir la barre latérale',
    accountMenu: 'Menu du compte',
    corpus: 'Glossaire',
    myTerms: 'Mes termes',
    companySettings: 'Entreprise',
    companyDataDesc: 'Informations sur l\'entreprise du compte',
    blog: 'Blog',
    landingPages: 'Pages d\'atterrissage',
    navMenu: 'Menu de navigation',
    glossary: 'Glossaires',
    siteCopy: 'Contenu du site',
    seo: 'SEO',
    apiKeys: 'Clés API',
    support: 'Support',
    knowledge: 'Connaissances',
    eventRegistrations: 'Tirages / Événements',
    content: 'Contenu',
    events: 'Événements',
  },
  dashboard: {
    welcome: 'Bon retour',
    subtitle: 'Voici l\'état actuel de vos commandes.',
    newOrder: 'Nouvelle commande',
    lowCredits: 'Crédits faibles : {n} restants',
    creditsBalance: 'Solde',
    ordersInProgress: 'Commandes en cours',
    completedOrders: 'Commandes terminées',
    teamMembers: 'Membres de l\'équipe',
    available: 'Disponible',
    low: 'Faible',
    active: 'Actif',
    recentOrders: 'Commandes récentes',
    viewAll: 'Voir tout',
    noOrdersYet: 'Aucune commande pour l\'instant',
    createFirstOrder: 'Créez votre première commande',
    quickActions: 'Actions rapides',
    uploadDocument: 'Téléverser un document',
    startNewTranslation: 'Démarrer une nouvelle traduction',
    buyCredits: 'Acheter des crédits',
    addToBalance: 'Alimenter votre solde',
    inviteTeam: 'Inviter l\'équipe',
    addTeamMembers: 'Ajouter des membres à l\'équipe',
    companyOverview: 'Vue d\'ensemble de l\'entreprise',
    thisMonth: 'Ce mois-ci',
    totalOrders: 'Total des commandes',
    inProgress: 'En cours',
    completed: 'Terminé',
    recentActivity: 'Activité récente',
    translation: 'Traduction',
    translationEdit: 'Modification de la traduction',
    lastActivity: 'Dernière activité',
    noActivityYet: 'Aucune activité pour l\'instant',
    pages: 'Pages',
    topLanguages: 'Langues principales',
    creditActivity: 'Activité des crédits',
    document: 'Document',
    languages: 'Langue',
    date: 'Date',
    ordersCount: 'commandes',
    archivedCount: '{n} archivées',
    prev: 'Précédent',
    next: 'Suivant',
    noTransactions: 'Aucune transaction pour l\'instant',
    status: 'Statut',
    ocrGenerated: 'OCR',
    ocrEdit: 'Modification OCR',
    download: 'Téléchargement',
    txTranslationCompleted: 'Commande {order} : Traduction terminée ({pages} pages)',
    txCreditsPurchased: 'Crédits achetés',
    txCreditsRefunded: 'Crédits remboursés',
    txCreditsAdjusted: 'Crédits ajustés',
    txAutoRecharge: 'Rechargement automatique',
    hideHeader: 'Masquer l’en-tête',
  },
  statuses: {
    uploaded: 'Téléversé',
    processing: 'En traitement',
    ocrreview: 'Révision OCR',
    translationreview: 'Révision de la traduction',
    completed: 'Terminé',
    cancelled: 'Annulé',
    unknown: 'Inconnu',
  },
  notifications: {
    title: 'Notifications',
    markAllRead: 'Tout marquer comme lu',
    noNotifications: 'Aucune notification pour l\'instant',
    dismiss: 'Ignorer',
    close: 'Fermer',
    orderAssignedTitle: 'Nouvelle commande assignée',
    orderAssignedMessage: '{by} vous a assigné « {doc} »',
    orderCompletedTitle: 'Commande terminée',
    orderCompletedMessage: '« {doc} » est terminée',
    orderReassignedTitle: 'Commande réassignée',
    orderReassignedMessage: '« {doc} » a été réassignée à {to}',
    projectCompletedTitle: 'Projet terminé',
    projectCompletedMessage: '« {project} » est terminé. Le téléchargement groupé est disponible.',
    finalizationRequestedTitle: 'Commande en attente de finalisation',
    finalizationRequestedMessage: '{by} a demandé de finaliser « {doc} »',
    finalizationReturnedTitle: 'Commande renvoyée',
    finalizationReturnedMessage: '{by} a renvoyé « {doc} » pour corrections',
  },
  time: {
    justNow: 'À l\'instant',
    minAgo: 'il y a {n} min',
    hourAgo: 'il y a {n} heure',
    hoursAgo: 'il y a {n} heures',
    yesterday: 'Hier',
    daysAgo: 'il y a {n} jours',
    mAgo: 'il y a {n}m',
    hAgo: 'il y a {n}h',
    dAgo: 'il y a {n}j',
  },
  orders: {
    title: 'Commandes',
    subtitle: 'Gérez vos commandes de traduction',
    newOrder: 'Nouvelle commande',
    total: 'Total',
    uploaded: 'Téléversé',
    inProgress: 'En cours',
    completed: 'Terminé',
    thisMonth: 'Ce mois-ci',
    noOrdersFound: 'Aucune commande trouvée',
    tryAdjusting: 'Essayez de modifier votre recherche ou vos filtres',
    createFirst: 'Créez votre première commande de traduction pour commencer',
    order: 'Commande',
    document: 'Document',
    type: 'Type',
    pagesCol: 'Pages',
    creditsCol: 'Crédits',
    qualityCol: 'Qualité',
    languageCol: 'Langue',
    status: 'Statut',
    createdBy: 'Créé par',
    assignedTo: 'Assigné à',
    client: 'Client',
    date: 'Date',
    actions: 'Actions',
    showing: 'Affichage de',
    of: 'sur',
    image: 'Image',
    text: 'Texte',
    handwritten: 'Manuscrit',
    modeTranslate: 'Traduction',
    modeLayout: 'Mise en page',
    searchPlaceholder: 'Rechercher par nom de document, créateur, client ou numéro de commande...',
    allStatus: 'Tous les statuts',
    allTypes: 'Tous les types',
    allDocTypes: 'Type de document',
    allWorkTypes: 'Type de travail',
    view: 'Voir',
    clearDates: 'Effacer les dates',
    verifiedBy: 'Vérifié par',
    due: 'Échéance',
    open: 'Ouvrir',
    filterProjects: 'Projets',
    filterSingle: 'Commandes simples',
    archived: 'Archivés',
    toSetUp: 'À configurer',
    cancelled: 'Annulée',
    completedOf: '{pct} % terminé · {done} sur {total}',
    moveToProject: 'Déplacer vers un projet…',
    removeFromProject: 'Retirer du projet',
    notAssigned: 'Non assigné',
    trash: 'Corbeille',
    trashAction: 'Supprimer',
    trashConfirmTitle: 'Mettre à la corbeille ?',
    trashConfirmMessage: "Elle disparaîtra des listes, du tableau de bord et des projets pour toute votre équipe. Vous pourrez la restaurer depuis la corbeille pendant 7 jours. Aucun fichier ni aucune donnée n'est supprimé.",
    trashConfirmButton: 'Mettre à la corbeille',
    restore: 'Restaurer',
    deletePermanently: 'Supprimer définitivement',
    deletePermanentlyConfirmTitle: 'Supprimer définitivement ?',
    deletePermanentlyConfirmMessage: 'Elle ne sera plus disponible pour personne dans votre équipe, même dans la corbeille. Cette action est irréversible.',
    emptyTrash: 'Vider la corbeille',
    emptyTrashConfirmTitle: 'Vider la corbeille ?',
    emptyTrashConfirmMessage: 'Toutes les commandes de la corbeille seront supprimées définitivement et ne seront plus disponibles pour votre équipe. Cette action est irréversible.',
    trashNotice: 'Les commandes de la corbeille sont supprimées définitivement après 7 jours.',
    trashEmpty: 'La corbeille est vide',
    trashDaysLeft: 'Encore {days} j',
    trashActionFailed: "L'action n'a pas pu être effectuée. Veuillez réessayer.",
    trashNoPermission: "Vous n'avez pas l'autorisation de supprimer des commandes.",
    readOnlyNotice: 'Votre accès est en lecture seule : vous pouvez consulter vos commandes et télécharger ce qui est prêt, mais pas les faire avancer ni les modifier',
    readOnlyActionHint: 'Lecture seule : vous ne pouvez pas modifier cette commande',
    working: 'Traitement en cours...',
    purgedBadge: 'Données supprimées',
    archiveAction: 'Archiver',
    unarchiveAction: 'Désarchiver',
    archivedEmpty: 'Aucune commande ni aucun projet archivé',
    archiveFailed: "Impossible d'archiver la commande. Veuillez réessayer.",
    archivedBadge: 'Archivée',
  },
  projects: {
    createOrder: 'Créer une commande',
    createOrderHint: 'Un seul document',
    createProject: 'Créer un projet',
    createProjectHint: 'Plusieurs documents du même dossier',
    newProject: 'Nouveau projet',
    name: 'Nom du projet',
    namePlaceholder: 'ex. Dossier Maria Roldan',
    client: 'Client',
    clientPlaceholder: 'Nom du client',
    reference: 'Reference #',
    referencePlaceholder: 'Votre propre numéro',
    dueDate: 'Date d’échéance',
    addNote: '+ Ajouter une note',
    notePlaceholder: 'Notes de ce dossier',
    defaults: 'Valeurs par défaut pour chaque document',
    task: 'De quoi avez-vous besoin ?',
    translation: 'Traduction',
    layout: 'Mise en page',
    decidePerDocument: 'Décider par document',
    assignProject: 'Assigner tout le projet à',
    dropFiles: 'Déposez des fichiers ici ou choisissez-les',
    chooseFiles: 'Choisir des fichiers',
    createCta: 'Créer le projet',
    creating: 'Création…',
    pastDate: 'Cette date est déjà passée.',
    afterProjectDue: 'Ceci est après la date du projet ({date}).',
    prepTitle: 'Préparation',
    addDocuments: 'Ajouter des documents',
    addNDocuments: 'Ajouter {n} documents',
    languages: 'Langues',
    assignTo: 'Assigner à',
    apply: 'Appliquer',
    statusReady: 'Prêt',
    statusToSetUp: 'À configurer',
    createNOrders: 'Créer {n} commandes',
    estimated: 'Estimé : {n} crédits',
    remainingPrep: '{n} documents resteront en préparation',
    archive: 'Archiver le projet',
    archiveConfirm: 'Archiver ce projet ? Vous pourrez le restaurer plus tard.',
    unarchive: 'Désarchiver',
    downloadZip: 'Tout télécharger',
    setTaskToContinue: 'Définissez la tâche de chaque document pour continuer',
    creditsForXN: 'Vous avez des crédits pour {x} commandes sur {n}.',
    createX: 'Créer {x}',
    recharge: 'Ajouter des crédits',
    position: '#',
    auto: 'Auto',
    removePrep: 'Retirer ce document de la préparation ?',
  },
  teamPage: {
    title: 'Équipe',
    subtitle: 'Gérez vos membres d\'équipe et vos invitations',
    inviteMember: 'Inviter un membre',
    teamMembers: 'Membres de l\'équipe',
    pendingInvites: 'Invitations en attente',
    noMembers: 'Aucun membre dans l\'équipe. Invitez quelqu\'un pour commencer.',
    owner: 'Propriétaire',
    active: 'Actif',
    inactive: 'Inactif',
    remove: 'Retirer',
    joined: 'Membre depuis',
    pendingInvitations: 'Invitations en attente',
    expires: 'Expire le',
    sent: 'Envoyé',
    link: 'Lien',
    copied: 'Copié',
    resend: 'Renvoyer',
    cancel: 'Annuler',
    teamRoles: 'Rôles dans l\'équipe',
    teamRolesDesc:
      'Les membres <strong>Équipe</strong> peuvent créer et gérer des commandes. Les <strong>Membres</strong> peuvent travailler sur les commandes qui leur sont assignées. Seuls les propriétaires de compte peuvent inviter de nouveaux membres et gérer la facturation.',
    inviteTeamMember: 'Inviter un membre de l\'équipe',
    invitationSent: 'Invitation envoyée',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    emailAddress: 'Adresse e-mail',
    sending: 'Envoi en cours...',
    sendInvitation: 'Envoyer l\'invitation',
    invitationSentTo: 'Invitation envoyée à',
    inviteLink: 'Lien d\'invitation',
    shareLinkDesc: 'Partagez ce lien avec la personne pour qu\'elle rejoigne votre équipe.',
    done: 'Terminé',
    copy: 'Copier',
    member: 'Membre',
    role: 'Rôle',
    status: 'Statut',
    email: 'E-mail',
    removeTeamMember: 'Retirer un membre de l\'équipe',
    removeConfirmMsg:
      'Êtes-vous sûr de vouloir retirer <strong>{name}</strong> de votre équipe ? Cette action est irréversible. Le membre perdra immédiatement l\'accès à toutes les ressources de l\'équipe.',
    removeMember: 'Retirer le membre',
    thisMonth: 'Ce mois-ci',
    roleOwner: 'Propriétaire',
    roleManager: 'Gestionnaire',
    roleReviewer: 'Réviseur',
    roleMember: 'Membre',
    roleManagerDesc: 'Gère le quotidien du compte',
    roleReviewerDesc: "Voit et approuve le travail de l'équipe",
    roleMemberDesc: 'Uniquement ses documents et ceux qui lui sont attribués',
    whatWillTheyDo: 'Que fera cette personne dans le compte ?',
    permissionsHint: 'Permissions sur TOUT le compte, pas seulement sur son propre travail : ce que cette personne modifie, toute l\'équipe le voit. Seul ce que vous ajustez est enregistré.',
    whatThisAllows: 'Ce que cette permission couvre',
    scopeDocsViewAll: 'Voit et attribue TOUTES les commandes de l\'entreprise, pas seulement les siennes.',
    scopeDocsApprove: 'Approuve et finalise les commandes du compte, y compris celles qu\'il n\'a pas traitées. Sans cette autorisation, la commande est envoyée en révision et les personnes autorisées sont prévenues.',
    scopeDocsDelete: 'Ouvre n\'importe quelle commande et supprime ses données et fichiers ; ils sont irrécupérables.',
    scopeCorpusEdit: 'Le corpus et les glossaires appartiennent à l\'entreprise : les changements affectent les traductions de toute l\'équipe.',
    scopeCertManage: 'Les modèles de certificat appartiennent à l\'entreprise : tous les membres les utilisent.',
    scopeBilling: 'Voit le solde et ACHÈTE des crédits avec le moyen de paiement de l\'entreprise.',
    scopeTeam: 'Invite, active/désactive et modifie les autres membres du compte.',
    scopeAccountEdit: 'Modifie les données de l\'entreprise (nom, raison sociale, n° fiscal, logo) pour tout le monde.',
    scopeLogs: 'Voit l\'activité de TOUS les utilisateurs du compte, pas seulement la sienne.',
    scopeDocsCreate: 'Crée de nouvelles commandes dans le compte ; leur traitement consomme les crédits de l\'entreprise.',
    scopeCertAttach: 'Joint le certificat de traduction de l\'entreprise au document final.',
    adjustedBadge: 'Ajusté',
    permDocsViewAll: 'Voir et attribuer tous les documents',
    permDocsApprove: 'Approuver et finaliser les commandes',
    permDocsDelete: 'Supprimer des documents',
    permCorpusEdit: 'Modifier le corpus et les glossaires',
    permCertManage: 'Modifier les modèles de certificat',
    permBilling: 'Voir et acheter des crédits',
    permTeam: 'Inviter et désactiver des membres',
    permAccountEdit: "Modifier les informations de l'entreprise",
    permLogs: "Voir le journal d'activité",
    permDocsCreate: 'Créer des commandes',
    permCertAttach: 'Ajouter le certificat à la finalisation',
    readOnlyBadge: 'Lecture seule',
    adjustedOne: 'ajusté',
    adjustedMany: 'ajustés',
    permCountOne: 'permission',
    permCountMany: 'permissions',
    edit: 'Modifier',
    editMemberTitle: 'Modifier le membre',
    saveChanges: 'Enregistrer les modifications',
    saving: 'Enregistrement...',
    readOnlyLabel: 'Lecture seule',
    readOnlyHint: "Peut voir le travail de l'équipe mais pas le modifier.",
    firstNamePlaceholder: 'Marie',
    lastNamePlaceholder: 'Dupont',
    emailPlaceholder: 'collegue@entreprise.com',
  },
  creditsPage: {
    title: 'Crédits',
    subtitle: 'Gérez vos crédits et votre facturation',
    availableBalance: 'Solde disponible',
    creditsInfo: 'crédits',
    usedThisMonth: 'Utilisés ce mois-ci',
    totalPurchased: 'Total acheté',
    yourSubscription: 'Votre abonnement',
    cancelSubscription: 'Annuler l\'abonnement',
    currentPlan: 'Plan actuel',
    unknown: 'Inconnu',
    subscriptionEnds: 'Fin de l\'abonnement',
    nextBillingDate: 'Prochaine date de facturation',
    willNotRenew: 'Ne sera pas renouvelé',
    paymentMethod: 'Moyen de paiement',
    change: 'Modifier',
    card: 'Carte',
    expiresDate: 'Expire le',
    autoRenew: 'Renouvellement automatique',
    on: 'Activé',
    off: 'Désactivé',
    updating: 'Mise à jour...',
    subscriptionEndingSoon: 'Abonnement arrivant bientôt à expiration',
    subscriptionEndingDesc:
      'Votre abonnement prendra fin le {date}. Réactivez-le pour conserver vos avantages.',
    reactivateNow: 'Réactiver maintenant',
    cancelSubscriptionQ: 'Annuler l\'abonnement ?',
    cancelSubscriptionDesc:
      'Êtes-vous sûr de vouloir annuler votre abonnement <strong>{plan}</strong> ? Vous conserverez l\'accès jusqu\'au <strong>{date}</strong>.',
    keepSubscription: 'Conserver l\'abonnement',
    yesCancel: 'Oui, annuler',
    changePlanQ: 'Changer de plan ?',
    newPlan: 'Nouveau plan',
    changePlanDesc:
      'Vous payez <strong>{new}</strong> aujourd\'hui et ses crédits sont ajoutés à votre solde dès le paiement, sans attendre le renouvellement. Votre forfait actuel <strong>{current}</strong> reste actif jusqu\'au paiement et est annulé une fois le paiement confirmé.',
    changePlan: 'Changer de plan',
    alreadySubscribed: 'Déjà abonné',
    alreadySubscribedDesc:
      'Vous êtes déjà abonné au plan <strong>{plan}</strong>.',
    gotIt: 'Compris',
    autoRechargeCredits: 'Rechargement automatique des crédits',
    whenBalanceBelow: 'Lorsque le solde est inférieur à',
    credits: 'crédits',
    rechargeAmount: 'Montant du rechargement',
    autoRecharge: 'Rechargement automatique',
    willAdd:
      'Ajoutera <strong>{amount} crédits</strong> lorsque le solde tombe en dessous de <strong>{threshold}</strong>',
    autoRechargeDisabled: 'Le rechargement automatique est désactivé',
    saveChanges: 'Enregistrer les modifications',
    saving: 'Enregistrement...',
    noPaymentMethod: 'Aucun moyen de paiement',
    addPaymentMethodFirst:
      'Vous devez d\'abord ajouter un moyen de paiement. Effectuez un achat ou souscrivez à un plan pour activer le rechargement automatique.',
    addPaymentMethodForRenewal: 'Ajouter un moyen de paiement pour renouveler',
    addPaymentMethodTitle: 'Ajoutez un moyen de paiement pour le renouvellement',
    addPaymentMethodForRenewalDesc:
      'Votre plan est actif pour cette période. Ajoutez une carte pour que le prochain cycle puisse être facturé — vous ne serez pas débité aujourd\'hui.',
    pendingPaymentMethodStatus: 'Actif — moyen de paiement requis',
    nextBillingAfterPaymentMethod: 'Après avoir ajouté une carte',
    buyCreditPackages: 'Acheter des packs de crédits',
    subscriptionRequiredToBuy: 'Un abonnement payant actif est requis pour acheter des crédits. Choisissez un forfait pour débloquer les achats.',
    noPackagesAvailable: 'Aucun pack de crédits disponible',
    mostPopular: 'Le plus populaire',
    pricingFrom: 'À partir de',
    contactSalesPrice: 'Sur mesure',
    buyNow: 'Acheter maintenant',
    buyCustomAmount: 'Acheter un montant personnalisé',
    buyCustomDesc:
      'Besoin d\'un montant spécifique ? Indiquez le nombre de crédits souhaités (1 crédit = 1 USD)',
    enterCreditsMin: 'Entrez le nombre de crédits (min. 10)',
    subscriptionPlans: 'Plans d\'abonnement',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    saveUpTo: 'Économisez jusqu\'à 20 %',
    noPlansAvailable: 'Aucun plan d\'abonnement disponible',
    year: 'an',
    month: 'mois',
    orMonthly: 'ou ${price}/mois facturé mensuellement',
    orYearly: 'ou ${price}/an (économisez {discount} %)',
    creditsIncluded: '{n} crédits',
    noCreditsIncluded: 'Aucun crédit inclus',
    imageBasedPages: 'Pages basées sur des images',
    creditPerPage: '1 crédit / page',
    imageBasedDesc: 'Documents numérisés, images, PDF nécessitant l\'OCR',
    textBasedPages: 'Pages basées sur du texte',
    textBasedDesc: 'PDF numériques et documents avec couches de texte',
    transactionHistory: 'Historique des transactions',
    noTransactions: 'Aucune transaction pour l\'instant',
    noTransactionsFilter: 'Aucune transaction sur cette période',
    showLess: 'Afficher moins',
    txFilterAll: 'Tout',
    txFilterToday: 'Aujourd\'hui',
    txFilterWeek: 'Cette semaine',
    txFilterMonth: 'Ce mois-ci',
    exportCSV: 'Exporter en CSV',
    txCount: 'transactions',
    txNet: 'Net',
    purchased: '{n} crédits achetés',
    used: '{n} crédits utilisés',
    subscriptionHelp: 'Les plans d\'abonnement fournissent un montant fixe de crédits mensuellement ou annuellement pour traiter vos documents. Ces crédits sont ajoutés à votre solde au début de chaque période de facturation.',
    subscriptionHelpTitle: 'À propos des abonnements',
    subscriptionHelpContent: 'Les plans d\'abonnement fournissent un montant fixe de crédits ajoutés à votre solde au début de chaque période de facturation (mensuelle ou annuelle). Ces crédits peuvent être utilisés pour traiter des documents via l\'OCR, la traduction et d\'autres services.\n\nVotre abonnement se renouvelle automatiquement à chaque date de facturation. Vous pouvez l\'annuler à tout moment et conserver l\'accès jusqu\'à la fin de votre période en cours. Si vous avez besoin de plus de crédits que ce que votre plan inclut, vous pouvez acheter des packs de crédits supplémentaires ou activer le rechargement automatique.',
    autoRechargeHelp: 'Le rechargement automatique ajoute des crédits à votre solde lorsqu\'il tombe en dessous d\'un seuil défini, vous garantissant de ne jamais manquer de crédits lors du traitement de documents. Vous pouvez personnaliser le seuil et le montant du rechargement.',
    autoRechargeHelpTitle: 'À propos du rechargement automatique',
    autoRechargeHelpContent: 'Le rechargement automatique surveille votre solde de crédits et achète automatiquement des crédits supplémentaires lorsqu\'il tombe en dessous du seuil que vous avez défini. Cela garantit un traitement continu des documents sans intervention manuelle.\n\nVous choisissez deux valeurs : le seuil de solde minimum (à quel moment recharger) et le montant du rechargement (combien de crédits ajouter). Votre moyen de paiement enregistré sera débité automatiquement à chaque rechargement.',
    viewPlans: 'Voir les plans d\'abonnement',
    close: 'Fermer',
    redeemCode: 'Code promo',
    redeemPlaceholder: 'Saisissez votre code',
    redeemApply: 'Appliquer',
    redeemApplying: 'Application…',
    redeemSuccess: 'Code appliqué',
    redeemError: 'Impossible d\'appliquer le code',
    redeemHint: 'Un code de campagne par compte, à vie. Utilisez-le ici pour le trial. Les avantages d’achat s’appliquent automatiquement au paiement.',
    redeemPreviewTrial: '{c} crédits bonus',
    redeemPreviewDiscount: '{p} % de réduction sur le prix du forfait sur Stripe',
    redeemPreviewDiscountMonths: ' pendant {n} mois',
    redeemPreviewPurchase: '{x}x crédits inclus avec le forfait',
    redeemApplied: 'Vous avez déjà utilisé {code}',
    redeemAppliedDiscount: 'La remise de {p}% est déjà incluse dans le prix des forfaits.',
    redeemAppliedMultiplier: 'Vous recevrez {x}x crédits inclus lorsque vous activerez un plan.',
    redeemAppliedPacks: 'packs de crédits',
    redeemAppliedPlans: 'forfaits {plans}',
    redeemAppliedNone: 'Vous avez déjà utilisé votre code. Un seul code par compte, à vie.',
    planCardCodeDiscount: 'Prix avec votre code {code} : {p}% de réduction',
    planCardCodeMultiplier: 'Votre code {code} multiplie les crédits du forfait par {x}x',
  },
  paywall: {
    teamTitle: 'L\'équipe est incluse dans le forfait Team',
    teamMessage: 'Vous devez activer un forfait Team pour inviter des membres et gérer votre équipe.',
    corpusTitle: 'Les glossaires sont inclus dans le forfait Team',
    corpusMessage: 'Vous devez activer un forfait Team pour créer des ensembles de termes et les utiliser dans les traductions.',
    cta: 'Activer un forfait Team',
    openingCheckout: 'Ouverture de Stripe…',
  },
  planGate: {
    teamTitle: 'Activez un forfait Team pour utiliser Équipe',
    teamBody: 'Le forfait Gratuit n\'inclut pas la gestion d\'équipe. Choisissez Team pour inviter des membres et collaborer.',
    activityTitle: 'Activez un forfait Team pour voir l\'activité de l\'équipe',
    activityBody: 'Le forfait Gratuit n\'inclut pas l\'historique d\'activité de l\'équipe. Activez Team pour le débloquer.',
    activateTeamCta: 'Activer le forfait Team',
    openingCheckout: 'Ouverture de Stripe…',
    memberTitle: 'Votre équipe a besoin d\'un forfait',
    memberBody: 'Ce compte est sur le forfait Gratuit. Demandez à l\'administrateur de l\'équipe d\'acheter un forfait pour que vous puissiez continuer à travailler.',
  },
  settingsPage: {
    unsavedTitle: "Vous avez des modifications non enregistrées",
    unsavedMessage: "Si vous partez maintenant, les modifications de cet écran seront perdues.",
    unsavedSaveAndLeave: "Enregistrer et quitter",
    unsavedLeave: "Quitter sans enregistrer",
    unsavedStay: "Rester ici",
    personalInfo: 'Informations personnelles',
    personalInfoDesc: 'Informations de base du compte',
    whatsappAvailable: 'Disponible sur WhatsApp',
    dateFormat: 'Format de date',
    dateFormatHint: "Pour l'interface. Les certifications utilisent le format du pays cible.",
    markerStyleLabel: 'Notation des éléments visuels',
    seccionEmpresa: 'Entreprise',
    correoEmpresa: 'E-mail de l’entreprise',
    telefonoEmpresa: 'Téléphone de l’entreprise',
    seccionEmpresaDesc: 'Données de l’entreprise, partagées par toute l’équipe',
    seccionPerfil: 'Profil',
    seccionPerfilDesc: 'Vos données personnelles et préférences',
    managedByAgency: 'Géré par votre agence',
    usarLaDeLaEmpresa: 'Utiliser celui de l’agence',
    perfilNoCargado: 'Votre profil n’a pas pu être chargé. Rechargez la page avant d’enregistrer.',
    markerStyleHint: 'Style du délimiteur pour les logos, sceaux et signatures dans vos traductions.',
    markerBrackets: 'Crochets',
    markerBraces: 'Accolades',
    interfaceLanguage: "Langue de l'interface",
    legalName: 'Raison sociale',
    legalNamePlaceholder: 'Raison sociale pour les factures',
    taxId: 'Identifiant fiscal',
    taxIdHint: "Pour les factures d'entreprise",
    website: 'Site web',
    jobTitle: 'Votre poste',
    jobTitlePlaceholder: 'PDG, Chef de projet...',
    linkedinCompanyPage: "Page LinkedIn de l'entreprise",
    preferredContactMethod: 'Méthode de contact préférée',
    preferredContactNone: 'Sans préférence',
    preferredContactCall: 'Appel',
    emailVerifyBannerTitle: 'Vérifiez votre adresse e-mail',
    emailVerifyBannerDesc: 'Confirmez qu’il s’agit de votre e-mail :',
    emailVerifySendCode: 'Envoyer le code',
    emailVerifySending: 'Envoi…',
    emailVerifyCta: 'Vérifier',
    emailVerifyVerifying: 'Vérification…',
    emailVerifyError: 'Impossible d’envoyer le code. Réessayez.',
    title: 'Paramètres',
    subtitle: 'Gérez votre compte et vos préférences',
    saveChanges: 'Enregistrer les modifications',
    saving: 'Enregistrement...',
    saved: 'Enregistré !',
    profile: 'Profil',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    email: 'E-mail',
    accountSection: 'Compte',
    companyName: 'Nom de l\'entreprise',
    changeLogo: 'Modifier le logo',
    uploadLogo: 'Téléverser un logo',
    uploading: 'Téléversement...',
    remove: 'Supprimer',
    notificationsSection: 'Notifications',
    orderStatusUpdates: 'Mises à jour du statut des commandes',
    orderStatusUpdatesDesc: 'Être notifié lorsque le statut d\'une commande change',
    teamActivity: 'Activité de l\'équipe',
    teamActivityDesc: 'Notifications concernant les actions des membres de l\'équipe',
    lowCreditAlerts: 'Alertes de crédits faibles',
    lowCreditAlertsDesc: 'Alerte lorsque les crédits tombent en dessous de 50',
    marketingEmails: 'E-mails marketing',
    marketingEmailsDesc: 'Conseils, mises à jour produit et offres',
    timezone: 'Fuseau horaire',
    timezoneDesc: 'Définissez votre fuseau horaire pour afficher les dates et heures correctement.',
    current: 'Actuel',
    security: 'Sécurité',
    changePassword: 'Modifier le mot de passe',
    sessions: 'Sessions',
    activeSession: '1 session active',
    signOutAllDevices: 'Se déconnecter de tous les appareils',
    billing: 'Facturation',
    currentPlan: 'Plan actuel',
    payAsYouGo: 'Paiement à l\'utilisation',
    noPlanActive: 'Aucun plan actif',
    noPlanDesc: 'Contactez l\'administrateur de votre entreprise pour accéder à un plan',
    noPlanDescFreelancer: 'Achetez des crédits pour commencer à traduire',
    viewInvoices: 'Voir les factures',
    changePasswordModal: 'Modifier le mot de passe',
    changePasswordDesc: 'Entrez votre mot de passe actuel et choisissez-en un nouveau.',
    currentPassword: 'Mot de passe actuel',
    enterCurrentPassword: 'Entrez le mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    minChars: 'Min. 8 caractères',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    confirmYourPassword: 'Confirmez votre mot de passe',
    changingPassword: 'Modification du mot de passe...',
    passwordChanged: 'Mot de passe modifié !',
    passwordChangedDesc: 'Votre mot de passe a été modifié avec succès.',
    done: 'Terminé',
    passwordsNoMatch: 'Les mots de passe ne correspondent pas',
    passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
    logoMaxSize: 'Le logo doit faire moins de 5 Mo',
    logoFormatHint: 'JPG, PNG ou WEBP. Max 5 Mo.',
    helpTitle: 'Besoin d\'aide ?',
    helpDesc: 'Notre équipe est là pour vous aider avec toutes vos questions.',
    helpEmail: 'Contacter le support',
    helpDocs: 'Documentation',
    privacyPolicy: 'Politique de confidentialité',
    termsConditions: 'Conditions générales d\'utilisation',
    allRightsReserved: 'Tous droits réservés.',
    privacyRetention: 'Confidentialité et conservation des données',
    privacyRetentionDesc: 'Configurez la suppression automatique des données des commandes terminées après une période de conservation.',
    retentionPolicy: 'Politique de conservation',
    retentionPolicyDesc: 'Les commandes terminées seront automatiquement supprimées après la période sélectionnée. Un certificat de suppression signé par KMS est généré pour chaque purge.',
    retentionDisabled: 'Désactivé',
    retentionDays: '{n} jours',
    retentionSaving: 'Enregistrement...',
    retentionSaved: 'Enregistré !',
    retentionNone: 'Pas de suppression automatique',
    retentionDay: '{n} jour',
    retentionDaysLabel: '{n} jours',
    retentionWarning: 'Modifier la conservation reprogrammera tous les minuteries de purge en attente pour les commandes terminées.',
    retentionImmediate: 'Immédiat',
    retentionImmediateWarning: 'Lorsqu\'une commande est terminée, toutes ses données et tous ses fichiers seront définitivement supprimés immédiatement. Un certificat de suppression sera généré comme preuve.',
    retentionActive: 'Actif',
    retentionInactive: 'Inactif',
    deletionCertificates: 'Certificats de suppression',
    deletionCertificatesDesc: 'Consultez les certificats cryptographiquement signés pour les commandes purgées.',
    viewCertificates: 'Voir les certificats',
    noCertificates: 'Aucun certificat de suppression pour l\'instant.',
    downloadCertificate: 'Télécharger le PDF',
    previewCertificate: 'Aperçu',
    // Timezone picker
    searchCity: 'Rechercher une ville...',
    noResults: 'Aucun résultat',
    // Deletion certificate detail modal
    certDetail: {
      certificateOne: 'certificat',
      certificateMany: 'certificats',
      backToList: 'Retour à la liste',
      order: 'Commande',
      document: 'Document',
      account: 'Compte',
      deletedAt: 'Supprimé le',
      method: 'Méthode',
      retention: 'Conservation',
      retentionDaysTpl: '{n} jours',
      integrity: 'Intégrité',
      valid: 'Valide',
      invalid: 'Invalide',
      deletedFilesTpl: 'Fichiers supprimés ({n})',
      purgedFieldsTpl: 'Champs supprimés ({n})',
      prev: 'Précédent',
      next: 'Suivant',
    },
    professionalProfile: 'Profil professionnel',
    professionalProfileDesc: 'Informations utilisées sur les certificats et les documents officiels',
    phone: 'Téléphone',
    phonePlaceholder: '+1234567890',
    phoneHint: 'Format international (E.164)',
    address: 'Adresse',
    addressPlaceholder: 'Ville, État, Pays',
    association: 'Association professionnelle',
    associationNoneOption: 'Aucune',
    associationOther: 'Autre',
    associationCustomLabel: 'Nom de l\'association',
    certificationNumber: 'Numéro de certification / d\'adhérent',
    languagePairs: 'Paires de langues',
    languagePairsDesc: 'Langues source et cible que vous traduisez',
    addLanguagePair: 'Ajouter une paire',
    sourceLanguage: 'Source',
    targetLanguage: 'Cible',
    noLanguagePairs: 'Ajoutez au moins une paire de langues',
    removePair: 'Supprimer',
    signatureImage: 'Image de signature',
    signatureHint: 'JPG ou PNG. Max 2 Mo.',
    signatureInvalidFormat: 'La signature doit être au format JPG ou PNG',
    signatureMaxSize: 'La signature doit faire moins de 2 Mo',
    uploadSignature: 'Téléverser une signature',
    changeSignature: 'Modifier',
    removeSignature: 'Supprimer',
    saveProfile: 'Enregistrer le profil',
    adminAccount: 'Administrateur du compte',
    adminAccountDesc: 'Coordonnées principales du compte',
    role: 'Rôle',
    subStatusActive: 'Active',
    subStatusTrialing: 'Essai',
    subStatusPastDue: 'Paiement en retard',
    subStatusUnpaid: 'Impayée',
    subStatusCanceled: 'Annulée',
    subStatusIncomplete: 'Incomplète',
    subStatusPaused: 'En pause',
    searchCountry: 'Rechercher un pays…',
    noCountriesFound: 'Aucun pays trouvé',
    companyWebsitePlaceholder: 'www.entreprise.com',
    companyEmailPlaceholder: 'contact@entreprise.com',
    personalWebsitePlaceholder: 'www.matraduction.com',
    linkedinProfilePlaceholder: 'votre-profil',
  },
  certificatePage: {
    title: 'Certificat',
    subtitle: 'Ce certificat est automatiquement ajouté en dernière page de chaque PDF traduit',
    uploadDocx: 'Téléverser un .docx',
    newTemplate: 'Nouveau modèle',
    editingTemplate: 'Modification du modèle de certificat',
    variables: 'Variables',
    saveAndClose: 'Enregistrer et fermer',
    saving: 'Enregistrement...',
    insertVariable: 'Insérer une variable :',
    dynamicVariables: 'Variables dynamiques',
    variablesDesc: 'Cliquez pour copier · Ces variables sont remplacées automatiquement dans le certificat final',
    clickToCopy: 'Cliquez sur une variable pour la copier dans le presse-papiers',
    hideExamples: 'Masquer les exemples',
    showExamples: 'Afficher les exemples',
    defaultTemplates: 'Modèles par défaut',
    myTemplates: 'Mes modèles',
    otherTemplates: 'Autres modèles',
    setActive: 'Définir comme actif',
    active: 'Actif',
    global: 'Global',
    noTemplate: 'Aucun modèle de certificat',
    noTemplateDesc: 'Créez-en un pour l\'ajouter automatiquement à vos PDF traduits',
    createTemplate: 'Créer un modèle',
    uploadTemplate: 'Téléverser un modèle',
    name: 'Nom',
    namePlaceholder: 'ex. : Certification d\'exactitude',
    descriptionOptional: 'Description (facultatif)',
    descriptionPlaceholder: 'Brève description de ce modèle...',
    category: 'Catégorie',
    general: 'Général',
    legal: 'Juridique',
    immigration: 'Immigration',
    academic: 'Académique',
    cancel: 'Annuler',
    creating: 'Création...',
    createAndEdit: 'Créer et modifier',
    opening: 'Ouverture...',
    editTemplate: 'Modifier le modèle',
    activateHint: 'Activez un modèle pour l\'ajouter à votre collection',
    templateLibrary: 'Bibliothèque de modèles',
    willBeAppended: 'Ce certificat sera annexé à toutes les commandes terminées',
    language: 'Langue',
    anyLanguage: 'Toute langue',
    english: 'Anglais',
    spanish: 'Espagnol',
    portuguese: 'Portugais',
    german: 'Allemand',
    french: 'Français',
    clickToRename: "Cliquez pour renommer",
    activeTemplate: "Modèle actif",
    copyHint: "Cliquez pour copier → Ctrl+V",
    copiedHint: "✓ Copié ! Appuyez maintenant sur Ctrl+V (ou Cmd+V) pour coller",
    copyVarTitle: "Cliquez pour copier → {desc}",
    view: "Voir",
    all: "Tous",
    close: "Fermer",
    deleteTemplate: "Supprimer le modèle",
  },
  orderDetail: {
    backToOrders: 'Retour aux commandes',
    continueOrder: 'Continuer la commande',
    error: 'Erreur',
    orderNotFound: 'Commande introuvable',
    failedToLoad: 'Échec du chargement de la commande',
    orderDetails: 'Détails de la commande',
    documentType: 'Type de document',
    category: 'Catégorie',
    sourceCountry: 'Pays source',
    targetCountry: 'Pays cible',
    sourceLanguage: 'Langue source',
    targetLanguage: 'Langue cible',
    totalPages: 'Nombre total de pages',
    formatTemplate: 'Modèle de format',
    noFormatTemplate: 'Original',
    credits: 'Crédits',
    consumed: 'consommés',
    estimated: 'estimés',
    created: 'Créé le',
    createdBy: 'Créé par',
    assignedTo: 'Assigné à',
    completed: 'Terminé le',
    exportFormat: 'Format d\'exportation',
    originalFile: 'Fichier original',
    view: 'Voir',
    openInNewTab: 'Ouvrir dans un nouvel onglet',
    download: 'Télécharger',
    close: 'Fermer',
    accessDenied: 'Accès refusé',
    adminNoAccess: 'Les administrateurs de la plateforme ne peuvent pas consulter le contenu des documents pour des raisons de sécurité et de confidentialité. Seuls les propriétaires de compte, les membres et les traducteurs indépendants peuvent accéder aux documents.',
    translatedDocument: 'Document traduit',
    finalDocument: 'Document mis en page',
    deletionCertificate: 'Certificat de suppression',
    translationCertificate: 'Certificat de traduction',
    fileDeleted: 'Ce fichier a été supprimé',
    sizeUnknown: 'Taille inconnue',
    uploadAndDetails: 'Téléversement et détails',
    ocr: 'OCR',
    review: 'Révision',
    final: 'Final',
    deleteData: 'Supprimer les données',
    deleteOrderData: 'Supprimer les données de la commande',
    deleteOrderDesc: 'Ceci supprimera définitivement tous les fichiers (téléversés et traités) pour :',
    deleteOrderPreserved: 'L\'enregistrement de la commande et le certificat de suppression seront conservés. Cette action est irréversible.',
    cancel: 'Annuler',
    dataDeletedSuccess: 'Données supprimées avec succès',
    dataDeletedFailed: 'Échec de la suppression des données',
    certificateLabel: 'Certificat',
    humanVerified: 'Vérifié par un humain',
    verify: 'Vérifier la traduction',
    verifyConfirmTitle: 'Vérifier la traduction',
    verifyConfirmDesc: 'Vous certifiez que cette traduction a été révisée et approuvée par un traducteur humain. Cette action ajoutera un sceau de vérification au document.',
    verifyNotes: 'Notes (facultatif)',
    verifySuccess: 'Traduction vérifiée avec succès',
    verifyFailed: 'Échec de la vérification de la traduction',
    verifiedBy: 'Vérifié par',
    verifiedOn: 'Vérifié le',
    viewVerification: 'Voir la vérification publique',
    // Data purged / deletion box
    dataPurged: 'Données supprimées',
    loadingCertificate: 'Chargement du certificat...',
    allDataDeleted: 'Tous les fichiers et données sensibles ont été définitivement supprimés.',
    filesDeletedTpl: '{n} fichiers supprimés',
    autoPurgeNoticeTpl: 'Suppression automatique activée — Les fichiers seront automatiquement supprimés {time} après la finalisation',
    retentionMin: 'min',
    retentionHour: 'heure',
    retentionHours: 'heures',
    retentionDay: 'jour',
    retentionDays: 'jours',
    inTrashBanner: 'Cette commande est dans la corbeille. Elle sera supprimée définitivement le {date}.',
    restoreOrder: 'Restaurer la commande',
    readOnlyNotice: 'Votre accès est en lecture seule : vous pouvez consulter la commande, mais pas la faire avancer',
    finalizationPendingApprover: '{name} a demandé de finaliser cette commande le {date}.',
    reviewAndFinalize: 'Vérifier et finaliser',
    returnToRequester: 'Renvoyer',
    returnNotePlaceholder: 'Ce qu’il faut corriger (facultatif)',
    returnConfirm: 'Renvoyer la commande',
    returnFailed: 'Impossible de renvoyer la commande. Veuillez réessayer.',
    finalizationPendingRequester: 'Envoyée en révision le {date}. Les personnes autorisées à la finaliser ont été prévenues.',
    finalizationReturned: '{name} a renvoyé la commande le {date}.',
    finalizationReturnedNote: 'Note : « {note} »',
    someoneFromTeam: 'Un membre de l’équipe',
    // Localized document type & category labels
    documentTypes: { image: 'Image', text: 'Texte', handwritten: 'Manuscrit' },
    categories: {
      birth_certificate: 'Acte de naissance',
      certificate: 'Certificat',
      diploma: 'Diplôme',
      passport: 'Passeport',
      marriage_license: 'Acte de mariage',
      medical: 'Dossier médical',
      legal: 'Document juridique',
      immigration: 'Formulaire d\'immigration',
      other: 'Autre',
      academic_transcript: 'Relevé de notes',
      civil_registry: 'Registre d\'état civil',
      death_certificate: 'Acte de décès',
      power_of_attorney: 'Procuration',
      general: 'Général',
    },
  },
  workspace: {
    title: 'Mon espace de travail',
    welcomeBack: 'Bon retour, {name}. Vous avez {n} tâches assignées.',
    welcomeBackOne: 'Bon retour, {name}. Vous avez {n} tâche assignée.',
    welcomeBackOther: 'Bon retour, {name}. Vous avez {n} tâches assignées.',
    assigned: 'Assigné',
    tasksToComplete: 'Tâches à effectuer',
    active: 'Actif',
    inProgress: 'En cours',
    completed: 'Terminé',
    thisMonth: 'Ce mois-ci',
    pendingTasks: 'Tâches en attente',
    pendingTasksDesc: 'Commandes en attente de révision et de traitement',
    noOrdersAssigned: 'Aucune commande ne vous est encore assignée',
    ordersWillAppear: 'Les commandes apparaîtront ici une fois qu\'elles vous seront assignées.',
    page: 'page',
    pages: 'pages',
    workflowTip: 'Conseil de flux de travail',
    workflowTipDesc: 'Chaque commande suit un flux de travail : <strong>Téléversement → Révision OCR → Traduction → Terminé</strong>. Vous devez vérifier et approuver chaque étape avant de passer à la suivante.',
    startOrder: 'Démarrer la commande',
    continueAction: 'Continuer',
    reviewAction: 'Réviser',
    viewAction: 'Voir',
    myOrders: 'Mes commandes',
    myOrdersSubtitle: 'Toutes les commandes qui vous sont assignées',
    searchPlaceholder: 'Rechercher des commandes...',
    totalAssigned: 'Total assigné',
    noOrdersFound: 'Aucune commande trouvée',
    ordersAssignedAppear: 'Les commandes qui vous sont assignées apparaîtront ici.',
    document: 'Document',
    pagesCol: 'Pages',
    languages: 'Langues',
    status: 'Statut',
    createdCol: 'Créé le',
    action: 'Action',
    pageOf: 'Page {p} sur {total}',
    orders: 'commandes',
    creditPackages: 'Packs de crédits',
    purchaseCreditsDesc: 'Achetez des crédits pour traiter vos documents',
    viewAll: 'Voir tout',
    uploadPhoto: 'Téléverser une photo',
    managePreferences: 'Gérez les préférences de votre compte',
    notifications: 'Notifications',
    newTaskAssignments: 'Nouvelles assignations de tâches',
    newTaskAssignmentsDesc: 'Être notifié lorsqu\'une nouvelle tâche vous est assignée',
    taskDeadlines: 'Échéances des tâches',
    taskDeadlinesDesc: 'Rappels pour les échéances à venir',
    commentsAndFeedback: 'Commentaires et retours',
    commentsAndFeedbackDesc: 'Notifications lorsque quelqu\'un commente votre travail',
    dailySummary: 'Résumé quotidien',
    dailySummaryDesc: 'Recevoir un résumé quotidien de vos tâches',
    account: 'Compte',
    organization: 'Organisation',
    role: 'Rôle',
    yourStats: 'Vos statistiques',
    tasksCompleted: 'Tâches terminées',
    pagesTranslated: 'Pages traduites',
    avgQualityScore: 'Score qualité moyen',
    loadError: 'Impossible de charger vos commandes. Réessayez dans quelques secondes.',
  },
  newOrder: {
    loadingOrder: 'Chargement de la commande...',
    restoreProgress: 'Veuillez patienter pendant que nous restaurons votre progression',
    stepProgress: 'Étape {step} sur {total}',
    stepUploadDetails: 'Téléversement et détails',
    stepProcessing: 'Traitement',
    stepReview: 'Révision',
    stepTranslation: 'Traduction',
    stepDownload: 'Télécharger',
    modeLabel: 'Mode',
    modeTranslate: 'Traduire',
    modeLayout: 'Mise en page',
    modeTranslateHint: 'Traduit le document dans une autre langue, avec certification.',
    modeLayoutHint: 'Mise en page uniquement : reconstruit le document dans sa langue d\'origine, sans traduction.',
    layoutReadyTitle: 'Document prêt',
    layoutReadyDesc: 'Votre document mis en page est prêt à télécharger dans sa langue d\'origine.',
    downloadDocument: 'Télécharger le document',
    preparingDownload: 'Préparation…',
    error: 'Erreur',
    uploadDocument: 'Téléverser un document',
    acceptedFileTypes: 'PDF, Word (DOC, DOCX), JPG, PNG, TIFF, WebP',
    analyzingDocument: 'Analyse du document...',
    classifyingDocument: 'Classification du document...',
    loadingPreview: 'Chargement de l\'aperçu...',
    fileTypePdf: 'PDF',
    fileTypeWord: 'Word',
    docxTooLargeToCount: 'Trop volumineux pour compter les pages — vérifiez',
    fileTypeImage: 'Image',
    page: 'page',
    pages: 'pages',
    hasText: 'Contient du texte',
    scanned: 'Numérisé',
    fileAnalysis: 'Analyse du fichier',
    complete: 'Terminé',
    textLabel: 'Texte :',
    selectable: 'Sélectionnable',
    methodLabel: 'Méthode :',
    ocrMethod: 'OCR (1 cr/p.)',
    directMethod: 'Direct (1 cr/p.)',
    paperLetter: "Lettre",
    paperA4: "A4",
    paperLegal: "Légal",
    paperPortrait: "portrait",
    paperLandscape: "paysage",
    handwritten: 'Manuscrit',
    mixedContent: 'Mixte (imprimé + manuscrit)',
    disableHandwritten: 'Cliquer pour traiter comme image numérisée',
    enableHandwritten: 'Cliquer pour restaurer le mode manuscrit',
    manuscriptSuggestionTitle: 'On dirait une image numérisée',
    manuscriptSuggestionBody: 'Pour un résultat optimal, utilisez le Mode Manuscrit. Il transforme votre document en texte clair et modifiable, avec une mise en page fidèle à l\'original. Si vous l\'ignorez, le texte est placé par-dessus l\'image numérisée, ce qui donne un rendu moins soigné et plus difficile à modifier.',
    manuscriptSuggestionConfirm: 'Utiliser le Mode Manuscrit',
    manuscriptSuggestionDismiss: 'Continuer sans l\'utiliser',
    manuscriptSuggestionBadge: 'Recommandé',
    pageFormat: 'Format de papier',
    pageFormatLetter: 'Lettre',
    pageFormatLegal: 'Légal',
    orientationLabel: 'Orientation',
    orientationPortrait: 'Portrait',
    orientationLandscape: 'Paysage',
    orientationSuggested: 'suggérée',
    readAloud: 'Lire',
    stopReading: 'Arrêter',
    loadingAudio: 'Chargement...',
    viewTranscript: 'Voir la transcription',
    transcriptTitle: 'Texte transcrit',
    copyText: 'Copier',
    transcribingHandwriting: 'Transcription du texte manuscrit...',
    readingHandwriting: 'Lecture du texte manuscrit par IA...',
    processingPages: 'Traitement des pages...',
    generatingDocument: 'Génération du document...',
    clientName: 'Nom du client',
    clientNamePlaceholder: 'ex. : Jean Dupont',
    reference: 'Reference #',
    dueDate: 'Date d’échéance',
    addInstructions: '+ Ajouter des instructions',
    detailsSection: 'Détails',
    languagesSection: 'Langues et localisation',
    teamSection: 'Équipe',
    documentName: 'Nom du document',
    documentNamePlaceholder: 'ex. : Acte de naissance - Garcia',
    documentCategory: 'Catégorie du document',
    sourceCountry: 'Pays source',
    targetCountry: 'Pays cible',
    sourceLanguage: 'Langue source',
    targetLanguage: 'Langue cible',
    chooseTargetLanguage: 'Choisir…',
    targetLanguageRequired: 'Choisissez la langue cible pour continuer',
    searchLanguage: 'Rechercher une langue…',
    searchCountry: 'Rechercher un pays…',
    noSearchResults: 'Aucun résultat',
    sameLanguageBlocked: 'La langue cible est la même que la langue source : il n\'y a rien à traduire. Vérifiez la langue cible de la commande.',
    autoDeleteLabel: 'Suppression automatique des fichiers après',
    autoDeleteAccountDefault: 'Utiliser la valeur par défaut du compte',
    autoDeleteImmediate: 'Immédiat',
    autoDelete20min: '20 minutes',
    autoDelete1h: '1 heure',
    autoDelete6h: '6 heures',
    autoDelete1d: '1 jour',
    autoDelete7d: '7 jours',
    autoDelete30d: '30 jours',
    autoDelete90d: '90 jours',
    estimatedCredits: 'Crédits estimés',
    creditCalculation: '1 crédit par page × {pages}',
    assignToTeamMember: 'Assigner à un membre de l\'équipe',
    notAssigned: 'Non assigné',
    notesInstructions: 'Notes / Instructions',
    teamNotesPlaceholder: 'Ajoutez des instructions pour le membre de l\'équipe assigné...',
    assigning: 'Assignation...',
    analyzing: 'Analyse...',
    assignNotify: 'Assigner et notifier',
    questionOnPage: 'Page',
    questionNoPosition: 'non localisé',
    fileTooLargeDetail: 'Le document fait {size} et la limite est de {max}. Divisez-le ou utilisez une version plus légère, puis réessayez.',
    unsupportedFileDetail: 'Formats acceptés : PDF, Word (.doc, .docx) et images (JPG, PNG, TIFF, WEBP).',
    uploadingOriginal: 'Envoi du document…',
    uploadFailedMessage: 'La commande a été créée et assignée, mais le document n\'a pas pu être envoyé. Réessayez ; si l\'erreur persiste, vérifiez votre connexion.',
    retryUpload: 'Réessayer l\'envoi',
    originalUploadFailed: 'Le fichier n\'a pas pu être envoyé. Vérifiez votre connexion et réessayez.',
    originalIncomplete: 'Le fichier n\'est pas arrivé complet. Envoyez-le à nouveau.',
    originalMissingTitle: 'Choisissez à nouveau le fichier',
    originalMissingMessage: 'Nous n\'avons pas trouvé le fichier de cette commande. Choisissez à nouveau « {name} » ({size}) pour continuer ; le reste de vos choix est conservé.',
    originalMissingShort: 'Cette commande n\'a pas son fichier. Choisissez-le à nouveau pour continuer.',
    originalDamaged: 'Impossible de lire le fichier : il semble endommagé ou protégé par un mot de passe. Enregistrez-le à nouveau sans mot de passe et renvoyez-le.',
    originalDifferentFile: 'Ce n\'est pas le fichier de cette commande : une nouvelle commande est créée avec lui.',
    originalCopyPendingTitle: 'Copie de l\'original en attente',
    originalCopyPending: 'Nous n\'avons pas pu enregistrer une copie de l\'original ; nous continuons avec votre document et réessaierons de l\'enregistrer.',
    startOrder: 'Démarrer la commande',
    analyzeContinue: 'Analyser et continuer',
    documentPreview: 'Aperçu du document',
    wordDocument: 'Document Word',
    contentPreview: 'Aperçu du contenu :',
    noPreviewAvailable: 'Aucun aperçu disponible',
    processing: 'Traitement...',
    resumingProcessing: 'Reprise du traitement...',
    convertingDocument: 'Conversion du document...',
    generatingPreview: 'Génération de l\'aperçu...',
    editDocument: 'Modifier le document',
    viewOriginal: 'Voir l\'original',
    saving: 'Enregistrement...',
    backToReview: 'Retour à la révision',
    originalDocument: 'Document original',
    back: 'Retour',
    exitOrderTitle: 'Quitter la commande ?',
    exitOrderMessage: 'Vous reviendrez à la liste des commandes. Votre progression est enregistrée — vous pouvez reprendre cette commande à tout moment.',
    exitOrderConfirm: 'Oui, quitter',
    exitOrderCancel: 'Rester sur la commande',
    documentReview: 'Révision du document',
    of: 'sur',
    stopAutoscroll: 'Arrêter le défilement automatique',
    autoscroll: 'Défilement automatique',
    translating: 'Traduction en cours...',
    loadingOriginal: 'Chargement de l\'original...',
    loadingShort: 'Chargement...',
    downloadDocx: 'Télécharger DOCX',
    closeOrderTitle: 'Terminer la commande ?',
    closeOrderDesc: 'Vous avez déjà téléchargé le document mis en page. Vous pouvez terminer la commande ici, sans passer à la traduction, pour qu\'elle ne reste pas ouverte.',
    closeOrderYes: 'Terminer la commande',
    closeOrderNo: 'Rester dans la commande',
    closeOrderFailed: 'La commande n\'a pas pu être terminée. Veuillez réessayer.',
    closeOrderSaving: 'Enregistrement du document…',
    reflowPagesBtn: 'Réorganiser les pages',
    reflowPagesError: 'Impossible de réorganiser les pages. Réessayez.',
    rotatePage: "Pivoter le document",
    prevPage: "Page précédente",
    nextPage: "Page suivante",
    dropHere: "Glissez-déposez votre document ici",
    clickBrowse: "ou cliquez pour parcourir votre ordinateur",
    selectFile: "Choisir un fichier",
    supportedLabel: "Formats pris en charge",
    progressMessages: {
      "Converting PDF to editable format...": "Conversion du PDF en format modifiable\u2026",
      "Creating order...": "Cr\u00e9ation de la commande\u2026",
      "Loading manuscript...": "Chargement du manuscrit\u2026",
      "Loading order...": "Chargement de la commande\u2026",
      "Loading preview...": "Chargement de l\u2019aper\u00e7u\u2026",
      "Resuming processing...": "Reprise du traitement\u2026",
      "Generating preview...": "G\u00e9n\u00e9ration de l\u2019aper\u00e7u\u2026",
      "Converting document...": "Conversion du document\u2026",
      "Preparing document...": "Pr\u00e9paration du document\u2026",
      "Converting document to base64...": "Pr\u00e9paration du fichier\u2026",
      "Applying crop...": "Application du recadrage\u2026",
      "Saving order details...": "Enregistrement des d\u00e9tails\u2026",
      "Uploading file to cloud storage...": "T\u00e9l\u00e9versement du fichier\u2026",
      "Analyzing document structure...": "Analyse de la structure\u2026",
      "Complete! Loading results...": "Termin\u00e9 ! Chargement des r\u00e9sultats\u2026",
      "Finalizing...": "Finalisation\u2026",
      "Almost ready...": "Presque pr\u00eat\u2026",
      "Exporting images and formats...": "Exportation des images et formats\u2026",
      "Analyzing document...": "Analyse du document\u2026",
      "OCR complete! Deducting credits...": "OCR termin\u00e9, d\u00e9duction des cr\u00e9dits\u2026",
      "Processing complete! Loading results...": "Traitement termin\u00e9, chargement\u2026",
      "Extracting text and formatting...": "Extraction du texte et de la mise en forme\u2026",
      "Detecting document styles...": "D\u00e9tection des styles\u2026",
      "Analyzing paragraphs...": "Analyse des paragraphes\u2026",
      "Merging text blocks...": "Fusion des blocs de texte\u2026",
      "Optimizing layout...": "Optimisation de la mise en page\u2026",
      "Finalizing document structure...": "Finalisation de la structure\u2026",
      "OCR complete, assembling result...": "OCR termin\u00e9, assemblage du r\u00e9sultat\u2026",
      "Deducting credits, almost ready...": "D\u00e9duction des cr\u00e9dits, presque pr\u00eat\u2026",
      "Converting to editable format...": "Conversion en format modifiable\u2026",
      "Processing document layout...": "Traitement de la mise en page\u2026",
      "Running OCR engines...": "Ex\u00e9cution des moteurs OCR\u2026",
      "Running text extraction...": "Extraction du texte\u2026",
      "Processing with OCR engines...": "Traitement par les moteurs OCR\u2026",
      "Detecting text styles...": "D\u00e9tection des styles du texte\u2026",
      "Finalizing results...": "Finalisation des r\u00e9sultats\u2026",
    } as Record<string, string>,
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    fitToWidth: 'Ajuster à la largeur',
    pdfPreviewError: 'Impossible de charger l\'aperçu du PDF',
    continueToTranslation: 'Continuer vers la traduction',
    panelOriginal: 'ORIGINAL',
    panelPreview: 'APERÇU',
    edit: 'Modifier',
    previewNotAvailable: 'Aperçu non disponible',
    ocrResultsComparison: 'Résultats OCR - Comparaison visuelle',
    textBlocksDetected: 'blocs de texte détectés',
    accuracy: 'précision',
    backToComparison: 'Retour à la comparaison',
    editTranslation: 'Modifier la traduction',
    translation: 'Traduction',
    panelTranslation: 'TRADUCTION',
    updatingPreview: 'Mise à jour de l\'aperçu...',
    translationPreviewNotAvailable: 'Aperçu de la traduction non disponible',
    finishOrder: 'Terminer la commande',
    orderCompleted: 'Commande terminée !',
    orderDownloaded: 'Votre document traduit a été téléchargé.',
    orderDownloadedLayout: 'Votre document mis en page a été téléchargé.',
    redirecting: 'Redirection...',
    finishOrderDesc: 'Télécharger et finaliser cette traduction',
    finishOrderDescLayout: 'Télécharger votre document mis en page',
    document: 'Document',
    exportFormat: 'Format d\'exportation',
    formatPdf: 'PDF',
    formatOdt: 'ODT (texte modifiable)',
    translationLabel: 'Traduction',
    autoLanguage: 'Auto',
    creditsToCharge: 'Crédits à débiter',
    creditsCharged: 'Crédits utilisés',
    currentBalanceLabel: 'Solde actuel : {balance} crédits. Débités à la relecture OCR.',
    credits: 'crédits',
    creditBalance: 'Votre solde : {balance} crédits. Après finalisation : {remaining} crédits.',
    cancel: 'Annuler',
    downloadComplete: 'Télécharger et finaliser',
    insufficientCredits: 'Crédits insuffisants',
    insufficientCreditsDesc: 'Cette commande nécessite {required} crédits et vous en avez actuellement {available}. Pour la finaliser, achetez plus de crédits ou améliorez votre forfait.',
    insufficientCreditsDescOne: 'Cette commande nécessite {required} crédit et vous en avez actuellement {available}. Pour la finaliser, achetez plus de crédits ou améliorez votre forfait.',
    creditsNeeded: 'Crédits nécessaires :',
    yourBalance: 'Votre solde :',
    shortfall: 'Déficit :',
    buyCredits: 'Acheter des crédits',
    upgradePlan: 'Améliorer le forfait',
    bestValue: 'Meilleure offre',
    contactOwner: 'Contactez le propriétaire de votre compte pour ajouter des crédits.',
    preparingTexts: 'Préparation des textes pour la traduction...',
    translatingBlocks: 'Traduction de {count} blocs...',
    translatingBlocksOne: 'Traduction de {count} bloc...',
    applyingTranslations: 'Application des traductions...',
    includeCertificate: 'Inclure le certificat',
    savingDocument: 'Enregistrement du document...',
    autosavePending: 'Modifications non enregistrées',
    autosaveSaving: 'Enregistrement…',
    autosaveSaved: 'Enregistré',
    autosaveError: 'Échec de l’enregistrement, nouvelle tentative',
    editorCountWord: 'mot',
    editorCountWords: 'mots',
    editorCountChar: 'caractère',
    editorCountChars: 'caractères',
    editorCountNoSpaces: 'caractères sans espaces',
    translatingProgress: 'Traduction en cours... ({completed}/{total})',
    generatingTranslatedPreview: 'Génération de l\'aperçu...',
    finalizingTranslation: 'Finalisation...',
    translationFailed: 'Le document n\'a pas pu être traduit. Réessayez dans quelques minutes.',
    wordSinTexto: 'Ce Word n\'a pas de texte modifiable (dessin ou polices sans table de caractères) : utilisez l\'Option 2.',
    translationPartialTitle: 'Certaines options n\'ont pas été traduites',
    translationPartialMessage: 'Voici les options qui ont bien été traduites.',
    yes: 'Oui',
    no: 'Non',
    protectPdf: 'Signature numérique et protection',
    protectPdfHint: 'Désactiver si vous signez avec votre propre jeton',
    outputOptions: 'Options de sortie',
    certificateTemplate: 'Certificat',
    selectTemplate: 'Sélectionner un modèle',
    noTemplates: 'Aucun modèle dans cette catégorie',
    addTemplate: 'Gérer les modèles',
    humanVerifiedSeal: 'Sceau Vérifié par un humain',
    attachOriginal: 'Joindre le document original',
    attachOriginalHint: 'Ajoute le fichier envoyé avant ou après la traduction',
    attachOriginalPosition: 'Position de l’original',
    attachOriginalAtStart: 'Au début',
    attachOriginalAtEnd: 'À la fin',
    downloadPdf: 'Télécharger le PDF',
    downloadDoc: 'Télécharger le DOC',
    reviewDocument: 'Réviser le document',
    chooseFormat: 'Choisissez le format',
    optionWord: 'Option 1',
    optionHtml: 'Option 2',
    optionMix: 'Option 3',
    optionFormat: 'Option 4',
    optionFormatHint: 'Option 2 avec le modèle de format de la commande',
    optionFormatImages: 'images',
    docHeaderLabel: 'EN-TÊTE DU DOCUMENT — répété sur chaque page du Word/PDF',
    docFooterLabel: 'PIED DE PAGE DU DOCUMENT — répété sur chaque page du Word/PDF',
    panelTranscription: 'TRANSCRIPTION',
    hideEditorToolbar: "Masquer la barre d'édition",
    showEditorToolbar: "Afficher la barre d'édition",
    verifyDocumentTitle: 'Vérifier le document',
    verifyDocumentDesc: 'Révisez le document original à gauche et confirmez les champs à droite',
    verificationLabel: 'Vérification',
    correctionPlaceholder: 'Saisissez la correction ici...',
    detectedLabel: 'Détecté',
    hidePin: 'Masquer le repère sur le document',
    showPin: 'Afficher le repère sur le document',
    editedIndicator: 'Modifié',
    skip: 'Ignorer',
    confirm: 'Confirmer',
    localizationNoticeTitle: 'Adapter les dates et les chiffres au pays cible',
    localizationNoticeIntro: 'Pays cible : {country}. Les dates et les chiffres s’y écrivent autrement ; nous pouvons les adapter pour qu’ils se lisent naturellement.',
    localizationNoticeSummaryTpl: 'Nous avons relevé {items}.',
    localizationNoticeSummaryAnd: 'et',
    localizationNoticeDatesOne: '1 date',
    localizationNoticeDatesMany: '{n} dates',
    localizationNoticeFiguresOne: '1 chiffre',
    localizationNoticeFiguresMany: '{n} chiffres',
    localizationNoticeExamplesTitle: 'Ce que cela donnerait',
    localizationNoticeChecking: 'Vérification du document…',
    localizationNoticeMoreTpl: 'et {n} autres occurrences',
    localizationNoticeTimesMany: '{n} fois',
    localizationNoticeTypeDate: 'Date',
    localizationNoticeTypeFigure: 'Chiffre',
    localizationNoticeSafeTitle: 'Rien de tout cela n’est modifié :',
    localizationNoticeSafeBody: 'les numéros de pièce d’identité, de loi, de dossier et de téléphone sont repris chiffre par chiffre, exactement comme dans l’original.',
    localizationNoticeAdapt: 'Adapter',
    localizationNoticeKeep: 'Conserver le format d’origine',
    localizationNoticeRemember: 'Ne plus demander pour ce compte',
    localizationNoticeRememberHint: 'Votre choix devient le réglage par défaut du compte.',
    localizationNoticeClose: 'Fermer',
    localizationNoticeIdsLabel: 'Identifiants',
    localizationNoticeIdsOne: '1 identifiant',
    localizationNoticeIdsMany: '{n} identifiants',
    localizationNoticeIdsUnchanged: 'Inchangés',
    localizationNoticeShowExamples: 'Voir des exemples',
    localizationNoticeHideExamples: 'Masquer les exemples',
    noCreatePermissionTitle: 'Vous ne pouvez pas créer de commandes',
    noCreatePermissionDesc: 'Votre rôle dans ce compte n\'inclut pas l\'autorisation « Créer des commandes ». Demandez au propriétaire ou à un gestionnaire de l\'activer. Vous pouvez continuer à travailler sur les commandes qui vous sont attribuées.',
    goToMyOrders: 'Aller à mes commandes',
    finishNoPermissionTitle: 'Vous n\'avez pas l\'autorisation de finaliser',
    finishNoPermissionDesc: 'L\'envoyer en révision ? Nous prévenons le propriétaire et les personnes autorisées à finaliser les commandes pour qu\'elles la vérifient et la terminent.',
    finishReadOnlyDesc: 'Votre accès à ce compte est en lecture seule : vous pouvez consulter la commande, mais pas la finaliser ni l’envoyer en révision.',
    sendForReview: 'Envoyer en révision',
    sendingForReview: 'Envoi…',
    reviewRequestSent: 'Commande envoyée en révision. Les personnes autorisées à la finaliser ont été prévenues.',
    reviewRequestSentNoNotice: 'Commande envoyée en révision. Les notifications n’ont pas pu être envoyées pour le moment ; les personnes autorisées le verront en ouvrant la commande.',
    reviewAlreadyPending: 'Cette commande attend une révision depuis le {date}.',
    reviewRequestFailed: 'Impossible d’envoyer la commande en révision. Veuillez réessayer.',
    certificateNoPermission: 'Votre rôle n\'inclut pas l\'autorisation « Ajouter le certificat à la finalisation ».',
  },
  certVars: {
    translatorName: 'Nom du traducteur',
    translatorNameDesc: 'Nom complet du traducteur / de la personne assignée',
    translatorEmail: 'E-mail du traducteur',
    translatorEmailDesc: 'E-mail du traducteur / de la personne assignée',
    requesterName: 'Nom du demandeur',
    requesterNameDesc: 'Nom de la personne ayant créé la commande',
    certificationDate: 'Date de certification',
    certificationDateDesc: 'Date de la certification',
    orderDate: 'Date de la commande',
    orderDateDesc: 'Date de création de la commande',
    completionDate: 'Date d\'achèvement',
    completionDateDesc: 'Date de finalisation de la commande',
    sourceLanguage: 'Langue source',
    sourceLanguageDesc: 'Langue du document original',
    targetLanguage: 'Langue cible',
    targetLanguageDesc: 'Langue cible de la traduction',
    sourceCountry: 'Pays source',
    sourceCountryDesc: 'Pays du document original',
    targetCountry: 'Pays cible',
    targetCountryDesc: 'Pays cible de la traduction',
    documentTitle: 'Titre du document',
    documentTitleDesc: 'Nom du document',
    documentType: 'Type de document',
    documentTypeDesc: 'Catégorie du document',
    originalFile: 'Fichier original',
    originalFileDesc: 'Nom du fichier original téléversé',
    pageCount: 'Nombre de pages',
    pageCountDesc: 'Nombre de pages traduites',
    orderNumber: 'Numéro de commande',
    orderNumberDesc: 'Uniquement l’id de la commande (ex. RR0124-1), pas combiné avec celui du projet.',
    projectNumber: 'Numéro de projet',
    projectNumberDesc: 'Référence personnalisée du projet si définie, sinon le nom du projet',
    companyName: 'Nom de l\'entreprise',
    companyNameDesc: 'Nom de l\'agence / entreprise de traduction',
    orderNotes: 'Notes de la commande',
    orderNotesDesc: 'Notes jointes à la commande',
    translatorPhone: 'Téléphone du traducteur',
    translatorPhoneDesc: 'Numéro de téléphone du profil du traducteur',
    associationName: 'Association',
    associationNameDesc: 'Association professionnelle (ATA, NAJIT, etc.)',
    certificationNumber: 'Numéro de certification',
    certificationNumberDesc: 'Numéro de certification professionnelle ou d\'adhérent',
    languagePairs: 'Paires de langues',
    languagePairsDesc: 'Paires de langues du traducteur (ex. : Anglais → Espagnol)',
    translatorAddress: 'Adresse du traducteur',
    translatorAddressDesc: 'Adresse complète du profil du traducteur',
    translatorCity: 'Ville',
    translatorCityDesc: 'Ville de l\'adresse du traducteur',
    translatorState: 'État',
    translatorStateDesc: 'État / province de l\'adresse du traducteur',
    translatorCountry: 'Pays',
    translatorCountryDesc: 'Pays de l\'adresse du traducteur',
    translatorZip: 'Code postal',
    translatorZipDesc: 'Code postal de l\'adresse du traducteur',
  },
  auth: {
    invalidCredentials: 'E-mail ou mot de passe incorrect',
    userExists: 'Un compte avec cet e-mail existe déjà',
    accountDeactivated: 'Votre compte a été désactivé. Contactez votre administrateur.',
    accountLocked: 'Compte temporairement verrouillé. Réessayez dans {n} minute(s).',
    accountLockedOne: 'Compte temporairement verrouillé. Réessayez dans {n} minute.',
    accountLockedOther: 'Compte temporairement verrouillé. Réessayez dans {n} minutes.',
    tooManyAttemptsLocked: 'Trop de tentatives échouées. Compte verrouillé pendant {n} minutes.',
    tooManyAttemptsLockedOne: 'Trop de tentatives échouées. Compte verrouillé pendant {n} minute.',
    tooManyAttemptsLockedOther: 'Trop de tentatives échouées. Compte verrouillé pendant {n} minutes.',
    verifyEmailTitle: 'Vérifiez votre e-mail',
    verifyEmailDesc: 'Nous avons envoyé un code à 6 chiffres à',
    verifyEmailCta: 'Vérifier et continuer',
    verifyEmailWrong: 'Mauvais e-mail ? Retour',
    welcomeBack: 'Bon retour',
    signInSubtitle: 'Connectez-vous pour accéder à votre tableau de bord',
    createAccount: 'Créez votre compte',
    startFreeTrial: 'Commencez votre essai gratuit dès aujourd\'hui',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Jane',
    lastName: 'Nom de famille',
    lastNamePlaceholder: 'Doe',
    registerAsCompany: 'S\'inscrire en tant qu\'entreprise',
    companyName: 'Nom de l\'entreprise',
    companyNamePlaceholder: 'Nom de votre entreprise',
    companyLogo: 'Logo de l\'entreprise',
    emailAddress: 'Adresse e-mail',
    emailPlaceholder: 'vous@exemple.com',
    password: 'Mot de passe',
    passwordPlaceholder: 'Min. 8 caractères',
    enterPassword: 'Entrez votre mot de passe',
    signIn: 'Se connecter',
    signingIn: 'Connexion en cours...',
    creatingAccount: 'Création du compte...',
    uploadingLogo: 'Téléversement du logo...',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: 'Vous n\'avez pas de compte ?',
    createAnAccount: 'Créer un compte',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signInLink: 'Se connecter',
    continueWithGoogle: 'Continuer avec Google',
    continueWithLinkedIn: 'Continuer avec LinkedIn',
    orEmailPassword: 'ou continuer avec',
    oauthFailed: 'Impossible de se connecter avec ce compte. Réessaie.',
    oauthGoogleOriginError: 'Google a rejeté cette origine ({origin}). Dans Google Cloud Console → Identifiants → client Web, ajoutez cette URL exacte aux origines JavaScript autorisées. Un Client ID non Web provoque aussi Error 401.',
    authFailed: 'Échec de l\'authentification',
    connectionError: 'Erreur de connexion. Veuillez réessayer.',
    tooManyRequests: 'Trop de tentatives. Veuillez patienter quelques minutes avant de réessayer.',
    sessionError: 'Échec de la création de la session',
    pwdMinLength: 'Minimum 8 caractères',
    pwdUppercase: 'Au moins une lettre majuscule',
    pwdLowercase: 'Au moins une lettre minuscule',
    pwdNumber: 'Au moins un chiffre',
    pwdSpecialChar: 'Au moins un caractère spécial (!@#$%^&*)',
    pwdStrengthWeak: 'Faible',
    pwdStrengthFair: 'Moyen',
    pwdStrengthGood: 'Bon',
    pwdStrengthStrong: 'Fort',
    forgotPasswordTitle: 'Réinitialiser votre mot de passe',
    forgotPasswordDesc: 'Entrez votre adresse e-mail et nous vous enverrons un code de vérification.',
    sendCode: 'Envoyer le code',
    sendingCode: 'Envoi en cours...',
    verificationCode: 'Entrez le code de vérification',
    verificationCodeDesc: 'Nous avons envoyé un code à 6 chiffres à',
    verifyCode: 'Vérifier le code',
    verifyingCode: 'Vérification...',
    resendCode: 'Renvoyer le code',
    resendIn: 'Renvoyer dans {n}s',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
    resetPassword: 'Définir le mot de passe',
    resettingPassword: 'Réinitialisation...',
    passwordResetSuccess: 'Mot de passe réinitialisé !',
    passwordResetSuccessDesc: 'Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    backToSignIn: 'Retour à la connexion',
    passwordsNoMatch: 'Les mots de passe ne correspondent pas',
    passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
    sessionExpired: 'Session expirée',
    sessionExpiredDesc: 'Vous avez été déconnecté en raison d\'une inactivité. Veuillez vous reconnecter.',
    accountCreatedSuccess: 'Compte créé avec succès ! Veuillez vous connecter.',
    // Auth page chrome + mockup
    backToHome: 'Retour à l\'accueil',
    mockupTitleOrders: 'Gérez toutes vos commandes',
    mockupDescOrders: 'Suivez documents, langues et statuts en un seul endroit.',
    mockupTitleEditor: 'Éditeur de traduction IA',
    mockupDescEditor: 'Revue OCR côte à côte avec traduction en temps réel.',
    mockupTitleTeam: 'Conçu pour équipes et entreprises',
    mockupDescTeam: 'Gérez traducteurs, relecteurs et admins ensemble.',
    mockupTitleCredits: 'Crédits et facturation d\'un coup d\'œil',
    mockupDescCredits: 'Surveillez l\'usage, achetez des crédits et suivez vos dépenses.',
    mockupTabOrders: 'Commandes',
    mockupTabEditor: 'Éditeur',
    mockupTabTeam: 'Équipe',
    mockupTabCredits: 'Crédits',
    mockupNavOrders: 'Commandes',
    mockupNavWorkspace: 'Espace',
    mockupNavTeam: 'Équipe',
    mockupNavCredits: 'Crédits',
    mockupNavSettings: 'Paramètres',
    mockupHeaderOrders: 'Commandes',
    mockupHeaderWorkspace: 'Espace de travail',
    mockupHeaderCompanyDashboard: 'Tableau de bord entreprise',
    mockupHeaderCreditsBilling: 'Crédits et facturation',
    mockupSearchOrders: 'Rechercher commandes...',
    mockupNewOrder: '+ Nouvelle commande',
    mockupColDocument: 'Document',
    mockupColLanguage: 'Langue',
    mockupColStatus: 'Statut',
    mockupColDate: 'Date',
    mockupStatusCompleted: 'Terminée',
    mockupStatusInReview: 'En revue',
    mockupStatusProcessing: 'En cours',
    mockupStatusPending: 'En attente',
    mockupStepUpload: 'Téléverser',
    mockupStepOcr: 'OCR',
    mockupStepReview: 'Vérifier',
    mockupStepExport: 'Exporter',
    mockupOriginalLabel: 'Original (ES)',
    mockupTranslationLabel: 'Traduction (EN)',
    mockupTotalOrders: 'Commandes totales',
    mockupTeamMembers: 'Membres de l\'équipe',
    mockupThisMonth: 'Ce mois',
    mockupTeamActivity: 'Activité de l\'équipe',
    mockupRoleTranslator: 'Traducteur',
    mockupRoleReviewer: 'Relecteur',
    mockupRoleAdmin: 'Admin',
    mockupRowOrders: 'commandes',
    mockupAvailableCredits: 'Crédits disponibles',
    mockupProPlan: 'Plan Pro',
    mockupBusinessPlan: 'Plan Entreprise',
    mockupRecentTransactions: 'Transactions récentes',
    mockupCredits: 'crédits',
    logoTooLarge: 'Le logo doit faire moins de 5 Mo.',
    mockupCompanyAdmin: 'Admin. entreprise',
    mockupDocBirthCertificate: 'Acte de naissance',
    mockupDocMarriageLicense: 'Acte de mariage',
    mockupDocDiploma: 'Diplôme',
    mockupDocMedicalRecord: 'Dossier médical',
    mockupDocPowerOfAttorney: 'Procuration',
    mockupTxBirthCertificate: 'Traduction d’acte de naissance',
    mockupTxCreditPurchase: 'Achat de crédits ({n})',
    mockupTxDiplomaOcr: 'OCR + traduction de diplôme',
  },
  activityPage: {
    title: 'Activité de l\'équipe',
    subtitle: 'Suivez les travaux en cours de vos membres d\'équipe',
    exportCSV: 'Exporter en CSV',
    totalActivities: 'Total des activités',
    clients: 'Clients',
    ocrOperations: 'Opérations OCR',
    translations: 'Traductions',
    searchPlaceholder: 'Rechercher par nom de membre, ID de commande, nom du client...',
    allActions: 'Toutes les actions',
    ocrGenerated: 'OCR généré',
    ocrEdited: 'OCR modifié',
    translationGenerated: 'Traduction générée',
    translationEdited: 'Traduction modifiée',
    downloadAction: 'Téléchargement',
    statusCompleted: 'Statut terminé',
    member: 'Membre',
    time: 'Heure',
    order: 'Commande',
    action: 'Action',
    details: 'Détails',
    loading: 'Chargement de l\'activité...',
    noActivity: 'Aucune activité trouvée',
    showing: 'Affichage de',
    of: 'sur',
    total: 'total',
    orderCreated: 'Commande créée',
    ocrCompleted: 'OCR terminé',
    translationGen: 'Traduction générée',
    translationEdit: 'Traduction modifiée',
    processing: 'En traitement',
    completed: 'Terminé',
    translationReview: 'Révision de la traduction',
    ocrReview: 'Révision OCR',
    orderAssigned: 'Tâche assignée',
    tasksAssigned: 'Tâches assignées',
    allMembers: 'Tous les membres',
    client: 'Client',
    noClient: 'N/A',
    clearDates: 'Effacer les dates',
    role: 'Rôle',
    orderTrashed: 'Mise à la corbeille',
    orderRestored: 'Restaurée depuis la corbeille',
    orderArchived: 'Archivée',
    orderUnarchived: 'Désarchivée',
    orderDeleted: 'Supprimée définitivement',
    orderDeletedAuto: 'Supprimée définitivement (automatique, 7 jours)',
    trashEmptied: 'Corbeille vidée',
    orderReassigned: 'Tâche réassignée',
    orderUnassigned: 'Assignation retirée',
    referenceChanged: 'Référence modifiée',
    orderCancelled: 'Commande annulée',
    humanVerification: 'Vérification humaine',
    projectCreated: 'Projet créé',
    otherAction: 'Autre action',
    loadError: 'Impossible de charger l’activité. Veuillez réessayer dans quelques minutes.',
    finalizationRequested: 'Envoyée en révision',
    finalizationReturned: 'Commande renvoyée',
    creditClaimSubmitted: 'A contesté les crédits',
    creditClaimFileOpened: 'Le support a ouvert un fichier de la contestation',
    creditClaimRefunded: 'Crédits remboursés',
    languagesConfirmed: 'Langues du document confirmées',
    languagesDecided: 'Options de langues pour la traduction',
  },
  corpus: {
    title: 'Mes termes',
    subtitle: 'Gérez vos termes de traduction par langue et par catégorie.',
    folders: 'Dossiers',
    createFolder: 'Nouveau dossier',
    createCorpus: 'Nouveau jeu de termes',
    createError: 'Impossible de créer le jeu de termes. Veuillez réessayer.',
    glossary: 'Termes',
    documents: 'Documents',
    style: 'Style',
    knowledge: 'Base de connaissances',
    sourceTerm: 'Terme source',
    targetTerm: 'Terme cible',
    context: 'Contexte / Notes',
    addTerm: 'Ajouter un terme',
    importCsv: 'Importer CSV',
    exportCsv: 'Exporter CSV',
    importPreview: 'Aperçu',
    importConfirm: 'Importer',
    importSuccess: 'importés',
    importDuplicates: 'doublons ignorés',
    importErrors: 'erreurs',
    importTotal: 'entrées au total',
    importDragOrClick: 'Faites glisser un fichier CSV ici ou cliquez pour parcourir',
    importCsvFormat: "Format : colonne A = terme source, B = terme cible, C = contexte (facultatif). La ligne d’en-tête est facultative.",
    importing: 'Importation...',
    export: 'Exporter',
    terms: 'termes',
    noCorpus: 'Aucun terme pour l\'instant',
    selectCorpus: 'Sélectionner un jeu de termes',
    formal: 'Formel',
    neutral: 'Neutre',
    plain: 'Simple',
    noFolders: 'Aucun dossier pour l\'instant. Créez-en un pour organiser vos termes.',
    noEntries: 'Aucun terme pour l\'instant. Ajoutez votre premier terme.',
    search: 'Rechercher...',
    name: 'Nom',
    description: 'Description',
    sourceLanguage: 'Langue source',
    targetLanguage: 'Langue cible',
    customInstructions: 'Instructions personnalisées',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    active: 'Actif',
    inactive: 'Inactif',
    corpora: 'Jeux de termes',
    folder: 'Dossier',
    back: 'Retour',
    create: 'Créer',
    showing: 'Affichage de',
    of: 'sur',
    noResults: 'Aucun résultat',
    confirmDeleteFolder: 'Supprimer ce dossier ? Les jeux de termes qu\'il contient seront déplacés vers « Sans dossier ».',
    confirmDeleteCorpus: 'Supprimer ce jeu de termes et toutes ses entrées ? Cette action est irréversible.',
    confirmDeleteTerm: 'Supprimer ce terme ?',
    prev: 'Précédent',
    next: 'Suivant',
    comingSoonMilestone: 'Bientôt disponible',
    folderPlaceholder: 'Juridique, Médical, Académique...',
    corpusNamePlaceholder: 'Certificats juridiques ES→EN',
    instructionsPlaceholder: 'Ex. : Utiliser le vouvoiement. Conserver le format de date JJ/MM/AAAA...',
    noFolder: 'Sans dossier',
    color: 'Couleur',
    whatIsCorpus: 'Que sont Mes termes ?',
    whatIsCorpusDesc: 'Votre bibliothèque de termes personnelle. Ajoutez des termes, des documents d\'exemple et des règles de style pour que l\'IA traduise en utilisant votre vocabulaire.',
    corpusInFolder: 'jeux de termes dans ce dossier',
    shared: 'Partagé',
    category: 'Catégorie',
    writingStyle: 'Style d\'écriture',
    formalDesc: 'Vocabulaire technique précis, phrases structurées.',
    neutralDesc: 'Équilibre entre formalité et accessibilité.',
    plainDesc: 'Phrases courtes, vocabulaire simple.',
    createNewCorpus: 'Créer un nouveau jeu de termes',
    configureDesc: 'Configurez votre bibliothèque de référence et ajoutez votre contenu.',
    corpusNameRequired: 'Nom du jeu de termes *',
    corpusNameExample: 'Ex. : Droit pénal, Cardiologie, Transcriptions...',
    corpusUseDesc: 'Pour quoi utiliserez-vous ce jeu de termes',
    exampleDocs: 'Documents d\'exemple',
    exampleDocsDesc: 'Téléversez des traductions précédentes comme référence de style et de format.',
    originalDoc: 'Original',
    translatedDoc: 'Traduction',
    docPairTip: 'Meilleurs résultats avec une paire complète (original + traduction). Vous pouvez n\'en téléverser qu\'un seul.',
    knowledgeDesc: 'Articles, guides ou documents de référence que l\'IA consulte lors de la traduction.',
    uploadArticle: 'Téléverser un article',
    acceptedFormats: 'Formats acceptés : PDF, DOCX, TXT. Max 10 Mo par fichier.',
    dragFileHere: 'Faites glisser votre fichier ici',
    tmxCsvFormat: 'TMX, CSV ou Excel (Col A = original, Col B = traduction)',
    addManually: 'ajouter des termes manuellement',
    generateAI: 'Générer avec l\'IA',
    share: 'Partager',
    viewTabs: 'Onglets',
    viewScroll: 'Défilement',
    unorganized: 'Sans dossier',
    add: 'Ajouter',
    styleExtracted: 'Style extrait',
    noDocuments: 'Aucun document d\'exemple pour l\'instant. Téléversez une paire pour améliorer la précision de la traduction.',
    noKnowledge: 'Aucun article pour l\'instant. Téléversez du matériel de référence pour que l\'IA puisse le consulter.',
    articles: 'articles',
    uploadPair: 'Téléverser une paire',
    notes: 'Notes',
    found: 'trouvés',
    sourceColumn: 'Source',
    targetColumn: 'Cible',
    removeFile: 'Retirer',
    glossaryFileError: 'Format non pris en charge. Importez votre glossaire au format Excel, CSV, TSV ou TMX.',
    glossarySpreadsheetError: 'Ce format de feuille de calcul ne peut pas être lu. Ouvrez-le et enregistrez-le au format .xlsx ou CSV, puis importez-le.',
    glossaryTooManyTerms: 'Ce fichier contient {count} termes et la limite par fichier est de 100 000. Divisez-le en plusieurs fichiers.',
    glossaryEmptyError: 'Aucune entrée valide trouvée dans le fichier.',
    docFileError: 'Veuillez téléverser un fichier texte (PDF, DOCX, TXT).',
    knowledgeFileError: 'Veuillez téléverser un fichier texte (PDF, DOCX, TXT).',
    fileTooLarge: 'Le fichier doit faire moins de 10 Mo.',
    uploadingGlossary: 'Importation du glossaire...',
    uploadingDocuments: 'Téléversement des documents...',
    uploadingKnowledge: 'Téléversement',
    quickStartTitle: 'Comment ça fonctionne',
    step1Title: '1. Créer un glossaire',
    step1Desc: 'Ajoutez vos termes de glossaire (CSV, TSV ou TMX) pour que l\'IA utilise vos traductions préférées.',
    step2Title: '2. Ajouter des documents d\'exemple',
    step2Desc: 'Téléversez des documents précédemment traduits pour que l\'IA apprenne votre style et ton.',
    step3Title: '3. Traduire',
    step3Desc: 'Sélectionnez votre glossaire lors de la création d\'une commande. Vos termes seront appliqués automatiquement.',
    termsTotal: "{terms} au total",
    pageRange: "{from}–{to} sur {total}",
    importConfirmTerms: "Importer {terms}",
    close: "Fermer",
    badgeAi: "IA",
    badgeLearned: "Appris",
    confirmDeleteDocument: "Supprimer ce document d’exemple ?",
    confirmDeleteKnowledge: "Supprimer ce fichier de la base de connaissances ?",
    loadError: "Impossible de charger ce jeu de termes. Il a peut-être été supprimé, ou vous n’y avez pas accès.",
    planLimitError: "Votre forfait ne permet pas de créer d’autres jeux de termes. Passez à un forfait supérieur pour en créer davantage.",
    uploadingFile: "Téléversement de {file}…",
    deleteFolder: "Supprimer le dossier",
  },
  admin: {
    asistente: {
      title: 'Assistant de données',
      subtitle: "Posez des questions en langage naturel sur les segments, l'usage et le risque d'attrition.",
      inputPlaceholder: 'Écrivez votre question...',
      send: 'Envoyer',
      thinking: 'Réflexion...',
      suggestedTitle: 'Questions suggérées',
      suggestion1: "Combien de nouveaux utilisateurs aujourd'hui ?",
      suggestion2: 'Donnez-moi le rapport du jour.',
      suggestion3: "Faites un rapport des utilisateurs inscrits qui n'ont pas consommé 10 % de leur forfait.",
      suggestion4: 'Quels clients payants sont inactifs depuis plus de 10 jours ?',
      suggestion5: 'Y a-t-il des comptes en double par nom ?',
      exportButton: 'Exporter en XLSX',
      emptyState: 'Posez une question sur vos clients pour commencer.',
      errorGeneric: "Je n'ai pas pu traiter cette question. Réessayez.",
      sendReportNow: "Envoyer le rapport maintenant",
      sendReportSending: 'Envoi en cours...',
      sendReportSuccess: 'Rapport envoyé.',
      sendReportError: "Impossible d'envoyer le rapport.",
      dashboardSegments: "Segments du jour",
      dashboardAlerts: 'Alertes et anomalies',
      dashboardLoadError: "Impossible de charger le résumé du jour.",
      chatSectionTitle: "Posez une question à l'assistant",
      segmentTrial: 'Essai actif',
      segmentNoUsage: 'Sans consommation',
      segmentPartial: 'Consommation partielle',
      segmentFull: 'Consommation totale',
      newAccountsToday: "Nouveaux comptes aujourd'hui",
      ambassadors: 'Ambassadeurs',
      suspendedAccounts: 'Suspendus',
      inactiveStatusAccounts: 'Inactifs (90+ jours)',
      alertInactive: 'Inactifs depuis 10+ jours',
      alertUsageDrop: 'Baisse de consommation',
      alertLowConsumption: 'Faible consommation',
      alertUncharged: 'Commandes non facturées',
      alertDuplicates: 'Inscriptions en double',
      alertScheduledCancellation: 'Annulation programmée',
      downloadReport: 'Télécharger le rapport',
      downloadingReport: 'Génération...',
      downloadReportError: "Impossible de générer le rapport.",
      promptSegmentListTpl: '{segment} : donnez-moi la liste des comptes.',
      promptNewAccounts: 'Combien de nouveaux comptes aujourd\'hui ? Donnez-moi la liste.',
      promptAmbassadors: 'Donnez-moi le résumé des ambassadeurs.',
      promptScheduledCancellation: 'Donnez-moi la liste des comptes avec une résiliation programmée.',
      promptInactive: 'Donnez-moi la liste des comptes payants inactifs depuis plus de 10 jours.',
      promptUsageDrop: 'Donnez-moi la liste des comptes dont la consommation a baissé ces 30 derniers jours.',
      promptLowConsumption: 'Donnez-moi la liste des comptes payants à faible consommation depuis leur dernier octroi de forfait.',
      promptUncharged: 'Donnez-moi la liste des commandes terminées sans débit de crédits.',
      promptDuplicates: 'Donnez-moi la liste des inscriptions potentiellement en double par nom.',
      activityTrendTitle: 'Activité (14 derniers jours)',
      newAccountsSeriesLabel: 'nouveaux comptes',
      ordersSeriesLabel: 'commandes créées',
      segmentsDistributionTitle: 'Répartition des segments',
      alertsOverviewTitle: 'Alertes par type',
      assistantCardTitle: 'Assistant IA',
      quickAction1: "Résumé du jour",
      quickAction2: 'Nouveaux utilisateurs',
      quickAction3: 'Faible consommation',
      quickAction4: 'Inactifs depuis 10+ jours',
      vsYesterday: 'vs. hier',
      openLauncher: "Demandez à l'assistant",
      usageRateTitle: "Taux d'utilisation active",
      usageRateCaption: 'Comptes avec consommation sur le total actif',
      atRiskTitle: 'Comptes payants à examiner (inactifs depuis 10+ jours)',
      colAccount: 'Compte',
      colPlan: 'Forfait',
      colInactive: 'Jours d’inactivité',
      colCredits: 'Crédits dispo. / utilisés',
      colStatus: 'Statut',
      viewHtmlReport: 'Voir le rapport HTML',
      alertShortCancellation: 'Annulation',
      alertShortInactive: 'Inactives',
      alertShortUsageDrop: 'Baisse d’usage',
      alertShortLowConsumption: 'Faible usage',
      alertShortUncharged: 'Non facturées',
      alertShortDuplicates: 'Doublons',
      assistantHeroTitle: 'Que voulez-vous savoir aujourd’hui ?',
      assistantHeroSubtitle: 'Répond avec les données de la période sélectionnée',
      assistantSendButton: 'Demander',
      agentSummaryTitle: 'Résumé de l’agent',
      agentSummarySubtitle: 'Généré par IA à partir des données du jour',
      agentSummaryEmpty: 'Résumé non disponible pour le moment.',
      todayActionsTitle: 'À faire aujourd’hui',
      todayActionsEmpty: 'Aucune action prioritaire aujourd’hui.',
      accountStateTitle: 'État des comptes',
      accountStateSubtitle: 'comptes selon leur niveau de consommation. Cliquez sur un statut pour voir ses comptes.',
      segmentDescTrial: 'Teste la plateforme',
      segmentDescNoUsage: 'Inscrits, aucun document traité',
      segmentDescPartial: 'Utilisent une partie de leurs crédits',
      segmentDescFull: 'Crédits épuisés : candidats à la mise à niveau',
      alertsOpenTitle: 'Alertes ouvertes',
      viewAllAlerts: 'Voir toutes les alertes',
      riskTableTitle: 'Comptes nécessitant une attention',
      riskTableSubtitle: 'Triés par priorité. Basé sur des signaux observés.',
      riskTableCaption: 'Affiche les cas les plus pertinents de chaque catégorie ({low} faible consommation · {noUsage} aucune consommation · {trial} essai bientôt expiré · {uncharged} non facturées). « Voir tout » télécharge l\'Excel complet avec le nom, l\'e-mail et les coordonnées de chaque compte.',
      viewAll: 'Voir tout',
      colEstado: 'Statut',
      colSignal: 'Signal',
      colLastActivity: 'Dernière activité',
      lastActivityToday: "Aujourd'hui",
      lastActivityYesterday: 'Hier',
      lastActivityDaysAgo: 'Il y a {n} jours',
      reportsHistoryTitle: 'Rapports quotidiens',
      configureSending: 'Configurer l’envoi',
      openReport: 'Ouvrir',
      chartReadingLabel: 'Lecture de l’agent',
      reportOpenError: "Impossible d'ouvrir le rapport de ce jour.",
      biBadge: 'Business Intelligence',
      statusSentToday: 'Rapport quotidien envoyé aujourd’hui à {time} à {n} destinataire(s).',
      statusNotSentYetAuto: 'L’envoi automatique est activé. Il n’a pas encore été envoyé aujourd’hui.',
      statusAutoOff: 'L’envoi automatique est désactivé — utilisez « Envoyer le rapport maintenant » pour l’envoyer manuellement.',
      nextSendLabel: 'Prochain envoi : {when}.',
      nextSendToday: 'aujourd’hui à {time}',
      nextSendTomorrow: 'demain à {time}',
    },
    translationEngines: {
      header: 'Moteurs de traduction',
      subtitle: "Contrôlez quels moteurs traduisent les documents. Appliqué côté serveur — le moteur est réellement changé/bloqué, pas seulement masqué dans l'interface.",
      tab: 'Traduction',
      deeplLabel: 'DeepL',
      deeplDesc: "Autoriser la traduction avec DeepL (traduction automatique rapide, sans glossaires de corpus). S'applique uniquement lorsque la commande n'a PAS de corpus.",
      claudeLabel: 'Claude',
      claudeDesc: 'Autoriser la traduction avec Claude pour les commandes SANS corpus (traduction contextuelle).',
      corpusLabel: 'Corpus → toujours Claude',
      corpusDesc: "Fixe (non configurable) : une commande avec corpus est toujours traduite via Claude — les glossaires de corpus ne fonctionnent qu'avec Claude.",
      alwaysOn: 'Toujours activé',
      bothDisabled: "Les deux moteurs sont désactivés — les commandes SANS corpus n'auront aucun moteur. (Les commandes avec corpus sont toujours traduites via Claude.)",
      effectiveTitle: 'Comportement effectif',
      effectiveWithCorpus: "Avec un corpus : Claude (corpus) uniquement — toujours, même si l'option Claude est désactivée.",
      effectiveWithoutCorpusPrefix: 'Sans corpus :',
      noneEnabled: 'aucun activé',
    },
    orderDetail: {
      back: 'Retour',
      documentInfo: 'Informations du document',
      category: 'Catégorie',
      type: 'Type',
      pages: 'Pages',
      step: 'Étape',
      exportFormat: 'Format d\'export',
      certificate: 'Certificat',
      digitalSignature: 'Signature numérique',
      humanVerified: 'Vérifié par un humain',
      attachOriginal: 'Joindre l\'original',
      originalFile: 'Fichier original',
      translation: 'Traduction',
      sourceLanguage: 'Langue source',
      targetLanguage: 'Langue cible',
      sourceCountry: 'Pays source',
      targetCountry: 'Pays cible',
      translationMethod: 'Méthode de traduction',
      people: 'Personnes',
      account: 'Compte',
      createdBy: 'Créé par',
      creditsAndDates: 'Crédits et dates',
      creditsEstimated: 'Crédits estimés',
      creditsConsumed: 'Crédits consommés',
      created: 'Créé',
      updated: 'Mis à jour',
      completed: 'Terminé',
      processingTime: 'Temps de traitement',
      platformCostBreakdown: 'Détail des coûts de la plateforme',
      service: 'Service',
      usage: 'Utilisation',
      costUsd: 'Coût (USD)',
      total: 'Total',
      yes: 'Oui',
      no: 'Non',
      mode: 'Mode',
      referenceNumber: 'Référence',
      clientName: 'Client',
      dueDate: 'Date d\'échéance',
      verificationId: 'ID de vérification',
      viewVerification: 'Voir la vérification publique',
      humanVerifiedBy: 'Vérifié par',
      translationApprovedBy: 'Traduction approuvée par',
      filesPurgedTpl: 'Fichiers purgés le {date}',
      deletionCertificateLink: 'Voir le certificat de suppression',
      notFound: 'Commande introuvable',
      fetchFailed: 'Impossible de charger la commande',
      formatTemplate: 'Modèle de format',
      assignedTo: 'Assignée à',
      notes: 'Notes',
      usagePagesTpl: '{n} pages',
      usageTokensTpl: '{n} tokens',
      usageCharsTpl: '{n} caractères',
      claudeOcr: 'Claude AI (OCR)',
      claudeTranslation: 'Claude AI (traduction)',
      claudeVision: 'Claude AI (vision)',
      modeDeeplClaude: 'Option 1 (DeepL + Claude AI)',
      modeGoogle: 'Option 1 (Google)',
      modeCorpus: 'Corpus',
    },
    common: {
      systemOnline: 'Système en ligne',
      allTime: 'Depuis toujours',
      realTime: 'En temps réel',
      search: 'Rechercher',
      save: 'Enregistrer',
      cancel: 'Annuler',
      create: 'Créer',
      edit: 'Modifier',
      delete: 'Supprimer',
      close: 'Fermer',
      done: 'Terminé',
      loading: 'Chargement...',
      saving: 'Enregistrement...',
      success: 'Succès',
      error: 'Erreur',
      confirmDelete: 'Supprimer cet élément ? Cette action est irréversible.',
      cannotBeUndone: 'Cette action est irréversible.',
      actions: 'Actions',
      status: 'Statut',
      name: 'Nom',
      description: 'Description',
      title: 'Titre',
      category: 'Catégorie',
      type: 'Type',
      date: 'Date',
      language: 'Langue',
      active: 'Actif',
      inactive: 'Inactif',
      draft: 'Brouillon',
      total: 'Total',
      page: 'Page',
      of: 'sur',
      previous: 'Précédent',
      next: 'Suivant',
      showing: 'Affichage',
      noResults: 'Aucun résultat',
      allStatus: 'Tous les statuts',
      exportCSV: 'Exporter CSV',
      view: 'Voir',
      add: 'Ajouter',
      remove: 'Retirer',
      refresh: 'Actualiser',
      copy: 'Copier',
      copied: 'Copié',
      select: 'Sélectionner',
      applying: 'Application...',
    },
    overview: {
      title: 'Tableau de bord administrateur',
      subtitle: 'Vue d\'ensemble et gestion du système',
      totalOrders: 'Commandes totales',
      activeAccounts: 'Comptes actifs',
      totalUsers: 'Utilisateurs totaux',
      creditsBalance: 'Solde de crédits',
      humanVerified: 'Vérifié par humain',
      totalRevenue: 'Revenu total',
      today: 'Aujourd\'hui',
      thisWeek: 'Cette semaine',
      thisMonth: 'Ce mois-ci',
      platformCostsAllTime: 'Coûts de plateforme (historique)',
      totalCost: 'Coût total',
      avgPerOrder: 'Moy. / commande',
      avgPerPage: 'Moy. / page',
      ordersProcessed: 'Commandes traitées',
      totalPages: 'Pages totales',
      costByService: 'Coût par service',
      awsTextract: 'AWS Textract',
      googleDocAI: 'Google Document AI',
      claudeAI: 'Claude AI',
      deepl: 'DeepL',
      ocrExtraction: 'Extraction OCR',
      ocrComplementary: 'OCR complémentaire',
      visionPostEdit: 'Vision + Post-édition',
      translation: 'Traduction',
      pages: 'Pages',
      costPerPage: 'Coût/page',
      ocrColor: 'OCR (couleur)',
      visionClass: 'Vision (class.)',
      postEdit: 'Post-édition',
      characters: 'Caractères',
      words: 'Mots',
      costPerMillion: 'Coût/1M caractères',
      detailedUsage: 'Détail d\'utilisation',
      service: 'Service',
      purpose: 'Objectif',
      usage: 'Utilisation',
      cost: 'Coût (USD)',
      ocrTextExtraction: 'OCR extraction de texte',
      ocrColorDetection: 'OCR détection de couleur',
      visionClassification: 'Classification par vision',
      translationPostEdit: 'Post-édition de traduction',
      totalPlatformCost: 'Coût total de plateforme',
      tokens: 'tokens',
      chars: 'caractères',
      topLanguagePairs: 'Paires de langues principales',
      ordersByStatus: 'Commandes par statut',
      noLanguagePairData: 'Aucune donnée de paire de langues disponible',
      percentOfOrders: '% du total des commandes',
      orders: 'commandes',
      noOrderData: 'Aucune donnée de commande disponible',
      totalOrdersLabel: 'Commandes totales',
      activitySummary: 'Résumé d\'activité',
      ordersToday: 'Commandes aujourd\'hui',
      creditsConsumed: 'Crédits consommés',
      completed: 'terminées',
      inProgress: 'en cours',
      totalAccounts: 'total',
      newThisWeek: 'cette semaine',
      newThisMonth: 'nouveaux ce mois',
      verified: 'vérifiées',
      ofCompleted: 'de',
      sold: 'vendus',
      consumed: 'consommés',
      creditsSold: 'Crédits vendus',
      totalPurchased: 'Total acheté par les clients',
      unusedAcrossAccounts: 'Crédits non utilisés sur tous les comptes',
      used: 'Utilisés',
      remaining: 'Restants',
      available: 'Disponibles',
      balance: 'Solde',
      imageBased: 'Basé sur image',
      textBased: 'Basé sur texte',
      documents: 'documents',
      documentsByType: 'Documents par type',
      pagesByType: 'Pages par type de document',
      imagePages: 'Pages d\'image',
      textPages: 'Pages de texte',
      noDocData: 'Aucune donnée de document disponible',
      noPageData: 'Aucune donnée de page disponible',
      activeUsers: 'actifs',
      teamUsers: 'équipe',
      memberUsers: 'membres',
      statusUploaded: 'Téléversé',
      statusProcessing: 'En traitement',
      statusOcrReview: 'Revue OCR',
      statusTranslationReview: 'Revue de traduction',
      statusCompleted: 'Terminé',
      plusTodayTpl: '+{n} aujourd\'hui',
      plusThisWeekTpl: '+{n} cette semaine',
      costEnvTitle: 'Environnement des dépenses Claude',
      apply: 'Appliquer',
      salesHint: 'Cliquez pour voir chaque vente : qui, quand, quoi et combien',
      salesTitle: 'Détail des ventes',
      salesModeAll: 'Toutes',
      salesModeLive: 'Réelles',
      salesModeTest: 'Test',
      opsOption1: 'Option 1 (DeepL)',
      opsOption2: 'Option 2 (Claude AI)',
      opsCorpus: 'Corpus (Claude AI + corpus)',
      envProduction: 'Production',
      claudeEnvErrorTpl: 'Impossible de lire les dépenses de {env} ({error}). Vérifiez que l’environnement a la clé et le secret de service configurés.',
      totalTokens: 'Tokens au total',
      vision: 'Vision',
      docClassification: 'Classification des documents',
      classifications: 'Classifications',
      tokensLabel: 'Tokens',
      costLabel: 'Coût',
      infraTitle: 'Infrastructure (Railway) — mois en cours',
      infraNote: 'Utilisation estimée depuis le début du mois d’après l’API Railway (CPU, mémoire, réseau, volumes).',
      infraNotConnectedTpl: 'Non connecté. Définissez {token} sur le service api-gateway pour voir les coûts d’infrastructure par environnement.',
      usersOverview: 'Aperçu des utilisateurs',
      activeCountTpl: '{n} actifs',
      usersUnit: 'utilisateurs',
      userTypeTeam: 'Équipe',
      userTypeMember: 'Membre',
      userTypeFreelance: 'Freelance',
      userTypeAdmin: 'Admin',
      docTypeTitle: 'Répartition par type de document',
      docTypeNote: 'Tous les types de document : 1 crédit/page',
      docsUnit: 'docs',
      pagesUnit: 'pages',
      documentsLabel: 'Documents',
      pagesProcessed: 'Pages traitées',
      docTypeCountsTpl: '({docs} docs, {pages} pages)',
    },
    accounts: {
      title: 'Comptes',
      subtitle: 'Gérer tous les comptes enregistrés',
      searchPlaceholder: 'Rechercher comptes...',
      noAccountsFound: 'Aucun compte trouvé',
      account: 'Compte',
      owner: 'Propriétaire',
      members: 'Membres',
      plan: 'Plan',
      credits: 'Crédits',
      created: 'Créé',
      payAsYouGo: 'Paiement à l\'usage',
      activate: 'Activer',
      suspend: 'Suspendre',
      viewDetails: 'Voir détails',
      addCredits: 'Ajouter crédits',
      statusActive: 'Actif',
      statusTrial: 'En essai',
      statusSuspended: 'Suspendu',
      statusInactive: 'Inactif',
      adjustCredits: 'Ajuster crédits',
      currentBalance: 'Solde actuel',
      creditsAmount: 'Quantité de crédits',
      amountPlaceholder: 'Ex. 100 (utiliser négatif pour déduire)',
      amountHint: 'Positif pour ajouter, négatif pour déduire',
      reason: 'Raison',
      reasonPlaceholder: 'Ex. Crédits de courtoisie, correction facturation...',
      newBalance: 'Nouveau solde',
      creditsAppliedSuccess: 'crédits appliqués avec succès',
      failedToAdjust: 'Échec de l\'ajustement des crédits',
      networkError: 'Erreur réseau. Veuillez réessayer.',
      applyCredits: 'Appliquer crédits',
      applying: 'Application...',
      showing: 'Affichage',
      accountsLabel: 'comptes',
      changePlan: 'Changer le plan',
      noPlan: 'Aucun plan',
      assignPlan: 'Assigner un plan',
      selectPlan: 'Sélectionner un plan',
      billingCycle: 'Cycle de facturation',
      monthly: 'Mensuel',
      yearly: 'Annuel',
      applyCreditsLabel: 'Ajouter les crédits du plan au solde actuel',
      currentPlan: 'Plan actuel',
      newPlan: 'Nouveau plan',
      planChangedSuccess: 'Plan mis à jour avec succès',
      failedToChangePlan: 'Échec du changement de plan',
      freelanceOnly: 'Freelance uniquement (1 membre)',
      companyPlan: 'Plan entreprise',
      removePlan: 'Retirer le plan',
      memberLimitExceeded: 'Le compte a plus de membres que ce plan ne permet',
      freeMembersKeepHint: 'Les membres restent sur le compte. Équipe reste bloqué jusqu\'à l\'achat d\'un forfait payant.',
      freeCreditModeLabel: 'Crédits lors du passage à Free',
      freeCreditKeepPlus5: 'Solde actuel + 5',
      freeCreditOnly5: 'Seulement 5 (supprimer le reste)',
      removePlanWarning: 'Annule l\'abonnement Stripe immédiatement et met le solde à 0.',
      ownerViewHint: 'Le forfait ajuste aussi la vue du propriétaire : un forfait équipe passe en vue équipe. Appliqué à la prochaine connexion.',
      lastActive: 'Dernière activité',
      never: 'Jamais',
      trialColumn: 'Essai',
      trialExpired: 'Expiré',
      trialOneDay: '1 jour',
      trialDays: n => `${n} jours`,
      planPriceLineTpl: '{monthly}/mois · {yearly}/an · {credits} crédits/mois',
    },
    users: {
      title: 'Utilisateurs',
      subtitle: 'Gérer tous les utilisateurs de la plateforme',
      searchPlaceholder: 'Rechercher utilisateurs par nom ou email...',
      user: 'Utilisateur',
      email: 'Email',
      accountLabel: 'Compte',
      userType: 'Type',
      role: 'Rôle',
      lastLogin: 'Dernière connexion',
      status: 'Statut',
      noUsersFound: 'Aucun utilisateur trouvé',
      allTypes: 'Tous les types',
      allRoles: 'Tous les rôles',
      typeAdmin: 'Admin',
      typeTeam: 'Équipe',
      typeMember: 'Membre',
      typeUser: 'Utilisateur',
      roleOwner: 'Propriétaire',
      roleAdmin: 'Admin',
      roleManager: 'Gestionnaire',
      roleMember: 'Membre',
      roleFreelancer: 'Indépendant',
      activate: 'Activer',
      deactivate: 'Désactiver',
      impersonate: 'Impersonnifier',
      viewActivity: 'Voir activité',
      never: 'Jamais',
      showing: 'Affichage',
      usersLabel: 'utilisateurs',
      subtitleActivity: 'Suivez l\'activité et l\'engagement des utilisateurs',
      exportExcel: 'Exporter vers Excel',
      exportEmail: 'E-mail',
      exportPlan: 'Forfait',
      exportCreditsAvailable: 'Crédits disponibles',
      exportConsumedAccount: 'Consommés (compte)',
      exportConsumedUser: 'Consommés (utilisateur)',
      onlineNow: 'En ligne maintenant',
      activeToday: 'Actifs aujourd\'hui',
      byRole: 'Par rôle',
      teamShort: 'équipe',
      memberShort: 'membre',
      userShort: 'utilisateur',
      allActivity: 'Toute l\'activité',
      filterOnline: 'En ligne maintenant',
      filterRecent: 'Actif récemment',
      filterActiveStatus: 'Statut : actif',
      filterSuspendedStatus: 'Statut : suspendu',
      statusOnline: 'En ligne',
      statusRecently: 'Récemment',
      statusOffline: 'Hors ligne',
      statusSuspendedBadge: 'Suspendu',
      lastActive: 'Dernière activité',
      lastPage: 'Dernière page',
      joined: 'Inscrit le',
      noAccount: 'Aucun compte',
      moreAccountsTpl: '+{n} de plus',
      showingRangeTpl: 'Affichage {from}-{to} sur {total} utilisateurs',
      timeJustNow: 'à l\'instant',
      timeMinAgoTpl: 'il y a {n}m',
      timeHourAgoTpl: 'il y a {n}h',
      timeDayAgoTpl: 'il y a {n}j',
      timeWeekAgoTpl: 'il y a {n}sem',
      platformAdminLabel: 'Admin plateforme',
      platformAdminBadge: 'Admin plateforme',
      platformAdminDescription: 'Donne accès à /admin sans changer le rôle d\'équipe ou de plan. Ils peuvent changer de vue comme les ambassadeurs.',
      platformAdminReloginHint: 'Ils doivent se déconnecter et se reconnecter pour que le changement prenne effet.',
      platformAdminGrant: 'Nommer admin plateforme',
      platformAdminRevoke: 'Retirer admin plateforme',
      platformAdminGranted: 'Admin plateforme accordé',
      platformAdminRevoked: 'Admin plateforme retiré',
      platformAdminFailed: 'Impossible de mettre à jour l\'admin plateforme',
      platformAdminConfirmGrant: 'Accorder l\'admin plateforme à cet utilisateur ? Il conserve la vue équipe/plan et doit se reconnecter.',
      platformAdminConfirmRevoke: 'Retirer l\'admin plateforme de cet utilisateur ? Il doit se reconnecter.',
      deleteUser: 'Supprimer l\'utilisateur…',
      deleteTitle: 'Supprimer définitivement l\'utilisateur',
      deleteWarningTpl: 'Cette action {strong}. Pour continuer, un code de confirmation de 6 caractères sera envoyé à l\'e-mail d\'administration configuré dans les Paramètres.',
      deleteWarningStrong: 'est irréversible',
      sendCode: 'Envoyer le code',
      enterCodeTpl: 'Saisissez le code envoyé à {email} (expire dans 10 minutes).',
      adminEmailFallback: 'l\'e-mail d\'administration',
      deletePermanently: 'Supprimer définitivement',
      codeSendFailed: 'Impossible d\'envoyer le code',
      invalidCode: 'Code invalide',
      somethingWrong: 'Une erreur est survenue. Réessayez.',
      userDeleted: 'Utilisateur supprimé',
      userDeletedTpl: '{name} a été supprimé définitivement.',
      exportSheet: 'Utilisateurs et crédits',
    },
    orders: {
      title: 'Toutes les commandes',
      subtitle: 'Voir et gérer toutes les commandes de tous les comptes',
      searchPlaceholder: 'Rechercher commandes par numéro ou nom de document...',
      totalOrders: 'Commandes totales',
      completed: 'Terminées',
      inProgress: 'En cours',
      totalPlatformCost: 'Coût total de plateforme',
      orderNum: 'Commande N°',
      document: 'Document',
      account: 'Compte',
      pages: 'Pages',
      credits: 'Crédits',
      quality: 'Qualité',
      cost: 'Coût (USD)',
      status: 'Statut',
      date: 'Date',
      actions: 'Actions',
      viewBtn: 'Voir',
      logsBtn: 'Logs',
      noOrdersFound: 'Aucune commande trouvée.',
      platformCostBreakdown: 'Détail du coût de plateforme',
      awsTextract: 'AWS Textract',
      googleDocAI: 'Google Doc AI',
      claudeAI: 'Claude AI',
      deepl: 'DeepL',
      grandTotal: 'Grand total',
      allServicesCombined: 'tous les services combinés',
      detailedUsageBreakdown: 'Détail d\'utilisation',
      allTimeAggregated: 'Utilisation agrégée historique de toutes les commandes',
      service: 'Service',
      purpose: 'Objectif',
      usage: 'Utilisation',
      costUsd: 'Coût (USD)',
      ocrTextExtraction: 'OCR (extraction de texte)',
      ocrComplementary: 'OCR (complémentaire)',
      visionClassification: 'Vision (classification)',
      translationClaude: 'Traduction (Claude)',
      translation: 'Traduction',
      totalLbl: 'Total',
      orderLogsTitle: 'Logs de la commande',
      loadingLogs: 'Chargement des logs...',
      noLogsFound: 'Aucun log trouvé pour cette commande.',
      timestamp: 'Horodatage',
      action: 'Action',
      creditsCol: 'Crédits',
      pagesLower: 'pages',
      charsLower: 'caractères',
      tokensLower: 'tokens',
      statusUploaded: 'Téléversée',
      statusProcessing: 'En traitement',
      statusOcrReview: 'Revue OCR',
      statusTranslationReview: 'Revue de traduction',
      statusCompleted: 'Terminée',
      allStatus: 'Tous les statuts',
      actionOrderCreated: 'Commande créée',
      actionOcrCompleted: 'OCR terminé',
      actionOcrGenerated: 'OCR généré',
      actionOcrEdited: 'OCR édité',
      actionTranslationGen: 'Trad. générée',
      actionTranslationEdit: 'Trad. éditée',
      actionDownload: 'Téléchargement',
      actionProcessing: 'En traitement',
      actionCompleted: 'Terminée',
      actionTranslationReview: 'Revue de traduction',
      actionOcrReview: 'Revue OCR',
      exportCSV: 'Exporter CSV',
      wordsLower: 'mots',
      ordersLower: 'commandes',
      showingRangeTpl: 'Affichage {from}-{to} sur {total} commandes',
      orderLogsForTpl: 'Logs de la commande — {orderNumber}',
      visibilityAll: 'Visibilité : toutes',
      visibilityActive: 'Actives',
      visibilityTrash: 'Dans la corbeille',
      visibilityDeleted: 'Supprimées définitivement',
      visibilityArchived: 'Archivées',
      badgeInTrash: 'Dans la corbeille',
      badgeDeleted: 'Supprimée définitivement',
      deletedAuto: 'Automatique (7 jours dans la corbeille)',
      byTpl: '{date} · par {name}',
      inTrashSince: 'Dans la corbeille depuis',
      statusCancelled: 'Annulée',
      actorAuto: 'Automatique',
      userCol: 'Utilisateur',
      csvOrderNumber: 'Numéro de commande',
      csvDocumentName: 'Nom du document',
      csvAccount: 'Compte',
      csvStatus: 'Statut',
      csvPages: 'Pages',
      csvCreditsEstimated: 'Crédits estimés',
      csvCreditsConsumed: 'Crédits consommés',
      csvSourceLanguage: 'Langue source',
      csvTargetLanguage: 'Langue cible',
      csvOrderDate: 'Date de la commande',
      csvLogTimestamp: 'Horodatage du journal',
      csvLogAction: 'Action',
      csvLogCredits: 'Crédits du journal',
      csvLogUser: 'Utilisateur du journal',
      csvTrashedAt: 'À la corbeille depuis',
      csvDeletedAt: 'Supprimée le',
      csvDeletedReason: 'Motif de suppression',
    },
    waitlist: {
      title: 'Liste d\'attente',
      subtitle: 'Inscriptions Founding User depuis la landing page',
      totalSignups: 'Inscriptions totales',
      companies: 'Entreprises',
      wantBetaAccess: 'Veulent accès bêta',
      latestSignup: 'Dernière inscription',
      searchPlaceholder: 'Rechercher par nom, email, entreprise ou rôle...',
      noEntriesFound: 'Aucune inscription trouvée',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      company: 'Entreprise',
      role: 'Rôle',
      pagesPerWeek: 'Pag./sem.',
      biggestPain: 'Plus gros problème',
      priceWillingness: 'Disposition au paiement',
      betaInterest: 'Intérêt bêta',
      language: 'Langue',
      signedUp: 'Inscrit',
      signedUpAt: 'Inscrit le',
      deleteEntry: 'Supprimer l\'inscription',
      viewDetails: 'Voir détails',
      deleteConfirm: 'Supprimer cette inscription ?',
      csvName: 'Nom',
      csvEmail: 'E-mail',
      csvPhone: 'Téléphone',
      csvCompany: 'Entreprise',
      csvRole: 'Rôle',
      csvPagesWeek: 'Pages/semaine',
      csvBiggestPain: 'Principale difficulté',
      csvPriceWillingness: 'Disposition à payer',
      csvBetaInterest: 'Intérêt bêta',
      csvLanguage: 'Langue',
      csvDate: 'Date',
    },
    analytics: {
      title: 'Analytique',
      subtitle: 'Performances et perspectives de la plateforme',
      totalOrders: 'Commandes totales',
      activeAccounts: 'Comptes actifs',
      ordersProcessed: 'Commandes traitées',
      creditsConsumed: 'Crédits consommés',
      ordersByStatus: 'Commandes par statut',
      topLanguagePairs: 'Paires de langues principales',
      documentsByType: 'Documents par type',
      pagesByDocType: 'Pages par type de document',
      imageBased: 'Basé sur image',
      textBased: 'Basé sur texte',
      imagePages: 'Pages d\'image',
      textPages: 'Pages de texte',
      documents: 'documents',
      pages: 'pages',
      noOrderData: 'Aucune donnée de commande disponible',
      noLanguagePairData: 'Aucune donnée de paire de langues disponible',
      noDocData: 'Aucune donnée de document disponible',
      noPageData: 'Aucune donnée de page disponible',
      statusUploaded: 'Téléversé',
      statusProcessing: 'En traitement',
      statusOcrReview: 'Revue OCR',
      statusTranslationReview: 'Revue de traduction',
      statusCompleted: 'Terminé',
      manuscript: 'Manuscrit',
    },
    blog: {
      title: 'Blog · Articles Ranqio',
      subtitle: 'Contenu ingéré via API + édition de SEO, OG, JSON-LD et statut.',
      searchPlaceholder: 'Rechercher par titre...',
      allStatuses: 'Tous les statuts',
      statusDraft: 'Brouillon',
      statusScheduled: 'Programmé',
      statusPublished: 'Publié',
      statusArchived: 'Archivé',
      noArticles: 'Aucun article.',
      titleCol: 'Titre',
      status: 'Statut',
      locale: 'Locale',
      author: 'Auteur',
      publishedAt: 'Publié',
      actions: 'Actions',
      viewOnSite: 'Voir sur le site',
      editSeo: 'Modifier SEO',
      deleteArticle: 'Supprimer',
      deleteConfirm: 'Supprimer cet article ? Cette action est irréversible.',
      articles: 'articles',
      pageOf: 'Page {p} sur {t}',
      errorSave: 'Erreur d\'enregistrement.',
      loadFailed: 'Impossible de charger l\'article.',
      savedOk: 'Modifications enregistrées.',
      notFound: 'Article introuvable.',
      back: 'Retour',
      backToArticles: 'Retour aux articles',
      sectionBasic: 'Informations de base',
      slugHint: 'Définit l\'URL finale /blog/[slug].',
      fieldExcerpt: 'Extrait',
      excerptHint: 'Texte court pour les listes et la meta description par défaut.',
      sectionSeo: 'SEO · Recherche',
      schemasHint: 'Tableau d\'objets { type, jsonLd }. Injecté dans <head>.',
      sectionFeaturedImage: 'Image mise en avant',
      altText: 'Texte alternatif',
      sectionPublication: 'Publication',
      fieldPublishDate: 'Date de publication',
      sectionInfo: 'Informations',
      viewPublished: 'Voir l\'article publié →',
    },
    copy: {
      title: 'Textes du site',
      subtitle: 'Modifiez les textes de la landing principale dans toutes les langues. Les changements restent en brouillon jusqu\'à la publication.',
      discardDraft: 'Rejeter brouillon',
      saveDraft: 'Enregistrer brouillon',
      publish: 'Publier',
      publishing: 'Publication',
      draftSaved: '✓ Brouillon enregistré. Pas encore visible au public.',
      publishedMsg: '🚀 Publié. Les visiteurs voient les changements.',
      errorSaveDraft: 'Erreur enregistrement brouillon',
      errorPublish: 'Erreur publication',
      discardConfirm: 'Rejeter le brouillon et revenir à la version publiée ?',
      draftDiscarded: 'Brouillon rejeté',
      loadingError: 'Erreur chargement copy',
      unpublishedChanges: 'Modifications non publiées dans',
      pressPublish: 'Cliquez Publier pour que les visiteurs les voient.',
      unsaved: 'non enregistré',
      draftBadge: 'brouillon',
      pendingChanges: 'Modifications non publiées',
    },
    nav: {
      title: 'Menu de navigation',
      subtitle: 'Configurez les items de l\'en-tête. Créez des liens vers des pages, dropdowns avec sous-items ou liens externes.',
      newItem: 'Nouvel item',
      noItems: 'Aucun item pour l\'instant. Créez le premier pour qu\'il apparaisse dans l\'en-tête du site.',
      dragHint: '💡 Faites glisser les items par la poignée à gauche pour les réordonner.',
      itemCreated: 'Item créé',
      itemUpdated: 'Item mis à jour',
      saveError: 'Erreur d\'enregistrement',
      deleteConfirm: 'Supprimer cet item ? Ses enfants seront également supprimés.',
      newItemTitle: 'Nouvel item',
      editItemTitle: 'Modifier item',
      kind: 'Type',
      kindLink: 'Lien externe (URL)',
      kindLanding: 'Landing page (créée dans EZDocuAI)',
      kindDropdown: 'Dropdown (avec sous-items)',
      url: 'URL',
      urlHint: 'Ex : https://docs.exemple.com ou /pricing',
      landingPage: 'Landing page',
      landingHint: 'Si la landing est renommée ou supprimée, le lien est mis à jour/désactivé automatiquement.',
      selectPlaceholder: '— Sélectionner —',
      parentItem: 'Item parent (optionnel)',
      parentHint: 'Pour imbriquer dans un dropdown',
      noParent: '— Sans parent (top-level) —',
      activeLabel: 'Actif (visible dans l\'en-tête)',
      addSubItem: 'Ajouter sous-item',
      dragReorder: 'Glisser pour réordonner',
      deleteItem: 'Supprimer',
      inactive: 'inactif',
      items: 'items',
      kindLinkShort: 'Lien',
      kindLandingShort: 'Landing',
      kindDropdownShort: 'Menu déroulant',
      itemsOne: '{n} élément',
      itemsOther: '{n} éléments',
    },
    seo: {
      title: 'SEO et Métadonnées',
      subtitle: 'Optimisez votre site pour les moteurs de recherche et réseaux sociaux.',
      tabGeneral: 'Général',
      tabRobots: 'Robots',
      tabSitemap: 'Sitemap',
      tabPages: 'Pages',
      errorLoading: 'Erreur chargement configuration',
      settingsSaved: 'Configuration enregistrée',
      errorSaving: 'Erreur d\'enregistrement',
      saveChanges: 'Enregistrer les changements',
      addSocialProfile: 'Ajouter profil social',
      generalSection: 'Configuration générale',
      siteName: 'Nom du site',
      siteNamePlaceholder: 'EZDocuAI',
      siteUrl: 'URL du site',
      siteUrlPlaceholder: 'https://www.ezdocu.ai',
      titleTemplate: 'Modèle de titre',
      titleTemplateHint: 'Utilisez %s là où ira le titre de chaque page',
      titleTemplatePlaceholder: '%s | EZDocuAI',
      defaultTitle: 'Titre par défaut',
      titleCounterLabel: 'Titre',
      defaultDescription: 'Description par défaut',
      descriptionCounterLabel: 'Description',
      ogImage: 'Image pour réseaux sociaux (OG)',
      ogImageHint: 'Taille recommandée : 1200×630px. Téléversez-la ou collez une URL.',
      ogImagePlaceholder: 'https://… ou téléversez une image',
      googleVerification: 'Code de vérification Google',
      googleVerificationPlaceholder: 'google-site-verification=...',
      socialProfiles: 'Profils sociaux',
      socialProfilePlaceholder: 'https://www.instagram.com/ezdocu',
      googlePreview: 'Aperçu Google',
      socialPreview: 'Aperçu réseaux sociaux',
      indexingSection: 'Indexation du site',
      allowGoogleIndex: 'Autoriser Google à indexer le site',
      allowGoogleIndexHint: 'Si désactivé, le site n\'apparaîtra pas dans les moteurs de recherche.',
      blockedPathsSection: 'Chemins bloqués pour les crawlers',
      blockedPathsHint: 'Ces chemins ne seront pas explorés par Google ni par les autres moteurs.',
      blockedPathPlaceholder: '/chemin-a-bloquer/',
      aiPolicySection: 'Politique des crawlers IA',
      aiPolicyAllowAll: 'Autoriser tous',
      aiPolicyAllowAllDesc: 'Google, Bing, ChatGPT, Claude peuvent accéder',
      aiPolicyBlockTraining: 'Bloquer l\'entraînement',
      aiPolicyBlockTrainingDesc: 'Autorise la recherche IA, bloque l\'entraînement (GPTBot, CCBot)',
      aiPolicyBlockAll: 'Bloquer tous les bots IA',
      aiPolicyBlockAllDesc: 'N\'autorise que les moteurs de recherche traditionnels',
      robotsPreviewSection: 'Aperçu du robots.txt',
      sitemapSection: 'Configuration du sitemap',
      autoGenerateSitemap: 'Générer le sitemap automatiquement',
      autoGenerateSitemapHint: 'Inclut les pages statiques, landing pages actives et contenu du CMS.',
      sitemapUpdated: 'Sitemap mis à jour',
      sitemapUrlCopied: 'URL copiée',
      includedContentSection: 'Contenu inclus',
      includedStaticPages: 'Pages statiques (accueil, pricing, blog)',
      includedLandingPages: 'Landing pages dynamiques actives',
      includedBlogArticles: 'Articles de blog publiés',
      excludedHint: 'Les pages privées (dashboard, workspace) sont exclues automatiquement.',
      metaBasicSection: 'Méta basique',
      metaTitleLabelTpl: 'Meta title ({n}/60 recommandé)',
      metaDescriptionLabelTpl: 'Meta description ({n}/155 recommandé)',
      focusKeyword: 'Focus keyword',
      canonicalUrl: 'URL canonique',
      canonicalPlaceholder: 'https://www.ezdocu.ai/...',
      noindexLabel: 'noindex',
      nofollowLabel: 'nofollow',
      openGraphSection: 'Open Graph',
      ogTitle: 'OG title',
      ogDescription: 'OG description',
      ogImageUrl: 'OG image URL',
      ogImageUrlPlaceholder: 'https://...',
      twitterSection: 'Twitter Cards',
      twitterCard: 'Twitter card',
      twitterSite: 'Twitter @site',
      twitterSitePlaceholder: '@ezdocuai',
      twitterTitle: 'Twitter title',
      twitterDescription: 'Twitter description',
      twitterImage: 'Twitter image URL',
      jsonLdSection: 'JSON-LD',
      jsonLdLabel: 'Schemas (tableau de { type, jsonLd })',
      jsonLdHint: 'Injecté dans <head> au rendu de la page.',
      jsonLdInvalid: 'JSON-LD invalide',
      changesPublished: 'Modifications publiées',
      previewGoogle: 'Aperçu Google',
      previewOg: 'Aperçu OG',
      infoSection: 'Info',
      pageKeyLabel: 'Clé de la page',
      lastEdited: 'Dernière édition',
    },
    apiKeys: {
      title: 'Clés API',
      subtitle: 'Gérez les clés d\'accès des intégrations externes (Ranqio, etc.). Configurez un webhook pour recevoir une confirmation lorsqu\'EZDocuAI traite un article.',
      noKeys: 'Aucune clé API créée pour l\'instant.',
      webhookDeleted: 'Webhook supprimé',
      webhookSaved: 'Webhook enregistré',
      saveError: 'Erreur d\'enregistrement',
      copiedToClipboard: '✓ Copié dans le presse-papier',
      statusActive: 'active',
      statusRevoked: 'révoquée',
      webhookBadge: 'webhook',
      rateLimitTpl: '{n}/min',
      lastUsedTpl: 'dernière utilisation : {when}',
      lastUsedNever: 'jamais',
      lastDeliveryTpl: 'dernière livraison : HTTP {status}',
      noDeliveriesYet: 'aucune livraison pour l\'instant',
      editWebhook: 'Modifier le webhook',
      configureWebhook: 'Configurer le webhook',
      webhookUrlLabel: 'URL du webhook',
      webhookUrlPlaceholder: 'https://votre-domaine.com/webhooks/ezdocu',
      webhookUrlHint: 'EZDocuAI enverra ici un POST signé lorsqu\'un article est créé, mis à jour ou supprimé depuis cette clé API.',
      secretLabel: 'Secret (optionnel)',
      secretPlaceholder: 'Généré automatiquement si laissé vide',
      secretHint: 'Utilisé pour signer chaque requête (HMAC-SHA256) dans l\'en-tête X-EZDocu-Signature.',
      showSecret: 'Afficher',
      hideSecret: 'Masquer',
      saveSecretWarning: '⚠ Enregistrez ce secret — il ne sera plus affiché',
      deleteWebhook: 'Supprimer le webhook',
      cancel: 'Annuler',
      save: 'Enregistrer',
      payloadExample: 'Payload du webhook (exemple)',
    },
    landingPages: {
      title: 'Landing Pages',
      subtitle: 'Gérez les landing pages dynamiques : offres, promotions, événements.',
      newPage: 'Nouvelle page',
      noPages: 'Aucune landing page pour l\'instant',
      createFirst: 'Créer la première',
      deleteConfirm: 'Supprimer cette landing page ? Cette action est irréversible.',
      totalLbl: 'Total',
      activeLbl: 'Actives',
      draftsLbl: 'Brouillons',
      titleCol: 'Titre',
      slug: 'Slug',
      status: 'Statut',
      updated: 'Mise à jour',
      actions: 'Actions',
      activeBadge: 'Active',
      draftBadge: 'Brouillon',
      viewSite: 'Voir',
      editPage: 'Modifier',
      deletePage: 'Supprimer',
      slugTitleRequired: 'Slug et titre sont obligatoires',
      errorCreate: 'Erreur de création',
      errorSave: 'Erreur d\'enregistrement',
      errorPublish: 'Erreur de publication',
      draftSavedMsg: '✓ Brouillon enregistré. Pas encore visible par le public.',
      publishedMsg: '🚀 Publié. Les visiteurs voient les modifications.',
      draftDiscarded: 'Brouillon supprimé',
      draftUnpublished: 'Brouillon non publié',
      errorCreatePage: 'Erreur lors de la création de la page',
      errorSaveDraft: 'Erreur lors de l\'enregistrement du brouillon',
      notFound: 'Page introuvable',
      discardConfirm: 'Abandonner toutes les modifications du brouillon ? Vous reviendrez à la version publiée.',
      confirmUnpublish: 'Dépublier cette page ?\n\nLes visiteurs ne la verront plus et elle renverra une 404.',
      confirmPublishTpl: 'Publier cette page ?\n\nElle sera visible publiquement sur /{slug}.',
      unpublishedMsg: 'Page dépubliée (404 pour le public)',
      visibleMsg: 'Page visible publiquement',
      newTitle: 'Nouvelle landing page',
      editTitle: 'Modifier la landing page',
      badgePublished: 'Publiée',
      badgeUnpublished: 'Dépubliée (404 pour le public)',
      publicUrl: 'URL publique :',
      toggleTitleUnpublish: 'La page ne sera plus visible publiquement',
      toggleTitlePublish: 'La rend de nouveau visible publiquement',
      unpublish: 'Dépublier',
      publishPage: 'Publier la page',
      discardDraft: 'Abandonner le brouillon',
      preview: 'Aperçu',
      createPage: 'Créer la page',
      saveDraft: 'Enregistrer le brouillon',
      publish: 'Publier',
      editingDraftTpl: 'Vous modifiez un brouillon. Cliquez sur {publish} pour que les visiteurs voient les changements, ou sur {preview} pour les vérifier d\'abord.',
      sectionBasic: 'Informations de base',
      slugLockedHint: '🔒 Non modifiable. L\'URL ne peut pas changer après la création de la page (cela casserait les liens externes).',
      slugUrlHintTpl: 'URL : /{slug}',
      fieldTitle: 'Titre *',
      fieldPublishedFrom: 'Publiée depuis',
      publishedFromHint: 'À titre indicatif. La visibilité réelle dépend du bouton Publier/Dépublier.',
      fieldExpires: 'Expire le',
      expiresHint: 'À titre indicatif.',
      sectionContent: 'Contenu',
      sectionSeo: 'SEO',
      fieldOgImage: 'Image OG (réseaux sociaux)',
      ogImageHint: '1200×630 px recommandé. Téléversez-la depuis votre ordinateur ou collez une URL.',
      ogImagePlaceholder: 'https://… ou téléversez une image',
      previewGoogle: 'Aperçu Google',
      previewOg: 'Aperçu OG',
    },
    templates: {
      title: 'Modèles de certificat',
      subtitle: 'Gérez les modèles de certificat globaux disponibles pour tous les comptes.',
      noTemplates: 'Aucun modèle pour l\'instant',
      uploadTemplate: 'Téléverser modèle',
      newTemplate: 'Nouveau modèle',
      editTemplate: 'Modifier modèle',
      activateTemplate: 'Activer',
      deactivateTemplate: 'Désactiver',
      default: 'Par défaut',
      global: 'Global',
      custom: 'Personnalisé',
      uploadDocx: 'Téléverser DOCX',
      globalTemplatesStat: 'Modèles globaux',
      activeStat: 'Actifs',
      defaultStat: 'Par défaut',
      inactiveStat: 'Inactifs',
      categoryGeneral: 'Général',
      categoryLegal: 'Juridique',
      categoryImmigration: 'Immigration',
      categoryAcademic: 'Académique',
      allTemplatesFilter: 'Tous les modèles',
      colTemplate: 'Modèle',
      colCategory: 'Catégorie',
      colAccount: 'Compte',
      colFlags: 'Flags',
      colCreated: 'Créé',
      colActions: 'Actions',
      colActive: 'Actif',
      loadingTemplates: 'Chargement des modèles...',
      noTemplatesFound: 'Aucun modèle trouvé.',
      flagDefault: 'Par défaut',
      flagGlobal: 'Global',
      editBtn: 'Modifier',
      newGlobalTemplate: 'Nouveau modèle global',
      uploadTemplateDialog: 'Téléverser un modèle',
      nameLabel: 'Nom',
      namePlaceholder: 'Ex. : Certificat de traduction',
      descriptionLabel: 'Description (optionnelle)',
      descriptionPlaceholder: 'Brève description de ce modèle',
      categoryLabel: 'Catégorie',
      languageLabel: 'Langue',
      anyLanguage: 'Toute langue',
      languageEnglish: 'Anglais',
      languageSpanish: 'Espagnol',
      languagePortuguese: 'Portugais',
      cancelBtn: 'Annuler',
      createAndEdit: 'Créer et modifier',
      creatingBtn: 'Création...',
      editingGlobalTemplate: 'Modification du modèle global',
      variablesBtn: 'Variables',
      clickToCopyHint: 'Cliquez pour copier → Ctrl+V',
      copiedTooltip: '✓ Copié !',
      clickToCopyTooltip: 'Cliquez pour copier → {description}',
      saveAndClose: 'Enregistrer et fermer',
      savingBtn: 'Enregistrement...',
      variableTranslatorName: 'Nom complet du traducteur',
      variableTranslatorEmail: 'Adresse e-mail du traducteur',
      variableCertificationDate: 'Date de certification',
      variableOrderDate: 'Date de création de la commande',
      variableCompletionDate: 'Date de finalisation de la commande',
      variableSourceLanguage: 'Langue originale du document',
      variableTargetLanguage: 'Langue de traduction',
      variableSourceCountry: 'Pays d\'origine',
      variableTargetCountry: 'Pays de destination',
      variableDocumentTitle: 'Titre du document',
      variableDocumentType: 'Catégorie/type de document',
      variablePageCount: 'Nombre de pages',
      variableOrderNumber: 'Numéro de référence de la commande',
      variableProjectNumber: 'Numéro de référence du projet',
      failedToPrepareTpl: 'Impossible de préparer le modèle : {message}',
      failedToSaveTpl: 'Impossible d\'enregistrer le modèle : {message}',
      failedToSaveGeneric: 'Impossible d\'enregistrer le modèle. Consultez la console pour plus de détails.',
      failedToCreate: 'Impossible de créer le modèle',
    },
    accountDetail: {
      loadFailed: 'Impossible de charger le compte',
      loadDetailsFailed: 'Impossible de charger les détails du compte',
      notFound: 'Compte introuvable',
      backToAccounts: 'Retour aux comptes',
      subtitle: 'Détails du compte',
      typeFreelance: 'Freelance',
      typeCompany: 'Entreprise',
      trialEndsTpl: 'L\'essai se termine le {date}',
      legalName: 'Raison sociale',
      taxId: 'Identifiant fiscal',
      website: 'Site web',
      yes: 'Oui',
      no: 'Non',
      dateFormat: 'Format de date',
      retention: 'Conservation',
      noAutoPurge: 'Pas de purge automatique',
      retentionDaysTpl: '{n} jours',
      orders: 'Commandes',
      completed: 'Terminées',
      inProgress: 'En cours',
      withFormat: 'Avec format',
      recentOrders: 'Commandes récentes',
      colOrder: 'Commande',
      colDocument: 'Document',
      colLanguages: 'Langues',
      colFormat: 'Format',
      colPages: 'Pages',
      colCredits: 'Crédits',
      colStatus: 'Statut',
      colCreated: 'Créée',
      noOrders: 'Ce compte n\'a pas encore de commandes.',
      ordersUnavailable: 'L\'activité des commandes est indisponible pour le moment.',
      spentToday: 'Dépensés aujourd\'hui',
      spentThisMonth: 'Dépensés ce mois-ci',
      recentTransactions: 'Transactions récentes',
      balanceAfterTpl: 'Solde {n}',
      noTransactions: 'Aucune transaction de crédits pour l\'instant.',
      txPurchase: 'Achat',
      txConsumption: 'Consommation',
      txRefund: 'Remboursement',
      txAdjustment: 'Ajustement',
      txAutoRecharge: 'Recharge automatique',
      txSubscription: 'Abonnement',
      txCampaignBonus: 'Bonus de campagne',
      txReferral: 'Parrainage',
      txClawback: 'Récupération',
      teamMembers: 'Membres de l\'équipe',
      firstName: 'Prénom',
      lastName: 'Nom',
      activeRelTpl: 'Actif {time}',
      lastLoginRelTpl: 'Dernière connexion {time}',
      neverLoggedIn: 'Jamais connecté',
      pendingInvitations: 'Invitations en attente',
      pending: 'En attente',
      expiresTpl: 'Expire le {date}',
    },
    userDetail: {
      loadFailed: 'Impossible de charger l\'utilisateur',
      loadDetailsFailed: 'Impossible de charger les détails de l\'utilisateur',
      notFound: 'Utilisateur introuvable',
      backToUsers: 'Retour aux utilisateurs',
      noAccounts: 'Cet utilisateur n\'appartient à aucun compte.',
      ordersOne: '{n} commande',
      ordersOther: '{n} commandes',
      noOrders: 'Cet utilisateur n\'a pas encore de commandes.',
    },
    plans: {
      title: 'Gestion des forfaits',
      popular: 'Populaire',
      saved: 'Enregistré',
      monthlyPrice: 'Prix mensuel',
      yearlyPrice: 'Prix annuel',
      creditsMonth: 'Crédits/mois',
      creditsYear: 'Crédits/an',
      yearlyDiscount: 'Remise annuelle %',
      buttonText: 'Texte du bouton',
      yes: 'Oui',
      no: 'Non',
      active: 'Actif',
      inactive: 'Inactif',
      description: 'Description',
      descriptionPlaceholder: 'Description du forfait...',
      limitsTitle: 'Limites (vide = illimité)',
      limitMaxCorpora: 'Corpus max.',
      limitMaxMembers: 'Membres max.',
      limitHistoryDays: 'Historique (jours)',
      limitRetentionDays: 'Conservation max. (jours)',
      featuresTitle: 'Fonctionnalités',
      featureHumanVerifiedSeal: 'Sceau Human Verified',
      featureManuscripts: 'Manuscrits',
      featureConfidential: 'Mode confidentiel',
      featurePostEdit: 'Assistant de post-édition',
      featureOtp: 'Vérification OTP',
      featureApi: 'Accès à l\'API',
      featureSso: 'SSO / SAML',
      featureWhiteLabel: 'Marque blanche',
      benefits: 'Avantages',
      moreTpl: '+{n} de plus',
    },
    settingsBcc: {
      supportPlaceholder: 'ops@entreprise.fr, support@entreprise.fr',
      eventPlaceholder: 'ventes@entreprise.fr, finances@entreprise.fr',
      salesPlaceholder: 'ventes@entreprise.fr, direction@entreprise.fr',
    },
    features: {
      title: 'Activation des fonctionnalités',
      subtitle: 'Activez ou désactivez les fonctionnalités de la plateforme',
      loadFailed: 'Impossible de charger les fonctionnalités',
      retry: 'Réessayer',
      totalFeatures: 'Fonctionnalités au total',
      enabled: 'Activées',
      disabled: 'Désactivées',
      categories: 'Catégories',
      searchPlaceholder: 'Rechercher des fonctionnalités...',
      all: 'Toutes',
      catCore: 'Cœur',
      catTranslation: 'Traduction',
      catBilling: 'Facturation',
      catNotifications: 'Notifications',
      catIntegrations: 'Intégrations',
      warning: 'Désactiver des fonctionnalités essentielles peut affecter le système. Les changements s\'appliquent immédiatement.',
      empty: 'Aucune fonctionnalité configurée. Chargez celles par défaut pour commencer.',
      seed: 'Charger les fonctionnalités par défaut',
      noMatch: 'Aucune fonctionnalité ne correspond à votre recherche.',
    },
    hubspot: {
      subtitle: 'Synchronisation EZDocu → HubSpot (contacts, entreprises et associations)',
      loadFailed: 'Impossible de charger l\'état de la synchronisation.',
      actionFailed: 'L\'action a échoué. Consultez les journaux d\'auth-ms.',
      retryFailed: 'Relancer les échecs',
      syncAll: 'Tout synchroniser',
      confirmSyncAll: 'Remettre en file d\'attente TOUS les utilisateurs et comptes pour HubSpot ?',
      notConfiguredTpl: 'La synchronisation est inactive : {token} n\'est pas configuré dans auth-ms.',
      pending: 'En attente',
      processing: 'En cours',
      done: 'Terminés',
      failed: 'En échec',
      contactsSynced: 'Contacts synchronisés',
      companiesSynced: 'Entreprises synchronisées',
      recentFailures: 'Échecs récents',
      colObject: 'Objet',
      colId: 'ID',
      colAttempts: 'Tentatives',
      colLastError: 'Dernière erreur',
      colDate: 'Date',
      noFailures: 'Aucun échec : tout se synchronise normalement.',
    },
    knowledge: {
      title: 'Centre d\'aide',
      subtitleTpl: 'Les articles publiés apparaissent sur {path} et alimentent l\'assistant IA du widget d\'assistance.',
      newArticle: '+ Nouvel article',
      loadFailed: 'Impossible de charger les articles.',
      searchPlaceholder: 'Rechercher par titre, identifiant ou section…',
      emptyNone: 'Aucun article pour l\'instant.',
      emptyNoMatch: 'Aucun article ne correspond.',
      createFirst: 'Créer le premier →',
      colArticle: 'Article',
      colKey: 'Identifiant',
      colSection: 'Section',
      colLanguages: 'Langues',
      colStatus: 'Statut',
      colUpdated: 'Mis à jour',
      colActions: 'Actions',
      edit: 'Modifier',
      deleteAll: 'Supprimer toutes les langues',
      confirmDeleteTpl: 'Supprimer « {title} » dans TOUTES les langues ({n}) ? Cette action est définitive et le retire aussi de la base de connaissances de l\'assistant.',
      published: 'Publié',
      draft: 'Brouillon',
      missingTranslation: 'Pas encore traduit',
      allPublished: 'Tous publiés',
      publishedCountTpl: '{pub}/{total} publiés',
      titleRequired: 'Le titre et le slug sont obligatoires.',
      saveFailed: 'Impossible d\'enregistrer l\'article.',
      publishFailed: 'Impossible de modifier la publication de l\'article.',
      confirmUnpublish: 'Dépublier l\'article ? Il est retiré de l\'assistant et de /help/.',
      back: 'Retour au centre d\'aide',
      titlePlaceholder: 'Titre de l\'article…',
      titleShortPlaceholder: 'Titre…',
      savedTpl: 'Enregistré {time}',
      view: 'Voir',
      saveDraft: 'Enregistrer le brouillon',
      unpublish: 'Dépublier',
      republish: 'Republier',
      publish: 'Publier',
      fieldSection: 'Section',
      noSection: '— Aucune section —',
      fieldCategory: 'Catégorie',
      categoryPlaceholder: 'Ex. : Facturation, Premiers pas…',
      fieldLanguage: 'Langue',
      editorPlaceholder: 'Commencez à écrire…',
      editorTipTpl: 'Astuce : tapez {key} pour voir les blocs disponibles (titres, listes, images, tableaux, code…).',
      featureOrderCreate: 'Créer une commande',
      featureOrderDetail: 'Détail de la commande',
      featureOrderList: 'Liste des commandes',
      featureCreditsBilling: 'Crédits et facturation',
      featureTeamManagement: 'Gestion de l\'équipe',
      featureCertificate: 'Certificat',
      featureGlossary: 'Glossaire',
      featureAccountSettings: 'Paramètres du compte',
      featureFaq: 'Questions fréquentes',
      groupLabel: 'Groupe de traductions',
      keyLabel: 'Identifiant :',
      publishedWithDraft: 'Publié avec un brouillon en attente',
      missingShort: 'Manquant',
      missingVersionTpl: 'Cet article n\'a pas encore de version en {lang}.',
      creating: 'Création…',
      createTranslationTpl: 'Créer la traduction en {lang}',
      createFailed: 'Impossible de créer la traduction.',
      featureReleaseNotes: 'Nouveautés',
      articleLoadFailed: 'Impossible de charger l\'article.',
    },
    marketingUi: {
      charsTpl: '{n} caractères',
      idealTpl: '(idéal {min}-{max})',
      noOgImage: 'Pas d\'image OG',
      noTitle: 'Sans titre',
      noDescription: 'Sans description',
      previewTitle: 'Aperçu : voici à quoi ressemblera la page publiée',
      noContentYet: 'Pas encore de contenu.',
      previewFooter: 'C\'est exactement ce que verront les visiteurs une fois la page publiée.',
      close: 'Fermer',
      imageTooLargeTpl: 'L\'image ne peut pas dépasser {n} Mo.',
      uploadFailedTpl: 'Erreur {status} lors du téléversement de l\'image.',
      uploadTimeout: 'Le téléversement a pris plus de 30 s. Vérifiez votre connexion.',
      uploadError: 'Erreur lors du téléversement de l\'image. Réessayez.',
      uploadImageTpl: 'Téléverser une image (max. {n} Mo)',
      upload: 'Téléverser',
      uploading: 'Téléversement…',
      clear: 'Effacer',
      imageLoaded: 'Image chargée',
      previewAlt: 'Aperçu',
      editorPlaceholder: 'Commencez à écrire le contenu de la landing page…',
      loadingEditor: 'Chargement de l\'éditeur…',
      linkPrompt: 'URL du lien',
      youtubePrompt: 'URL de la vidéo YouTube (https://youtube.com/watch?v=...)',
      editorUploadFailedTpl: 'Erreur {status} : le serveur d\'images n\'a pas répondu correctement.',
      editorUploadTimeout: 'Le téléversement a pris plus de 30 secondes. Vérifiez votre connexion ou le service d\'images.',
      bold: 'Gras',
      italic: 'Italique',
      strike: 'Barré',
      inlineCode: 'Code en ligne',
      heading1: 'Titre 1',
      heading2: 'Titre 2',
      heading3: 'Titre 3',
      bulletList: 'Liste à puces',
      orderedList: 'Liste numérotée',
      quote: 'Citation',
      divider: 'Séparateur',
      link: 'Lien',
      uploadImageCloud: 'Téléverser une image (Cloudinary, max. 5 Mo)',
      insertYoutube: 'Insérer une vidéo YouTube',
      imageLabel: 'Image :',
      alignLeft: 'Aligner à gauche',
      alignCenter: 'Centrer',
      alignRight: 'Aligner à droite',
      uploadingImage: 'Téléversement de l\'image…',
      undo: 'Annuler',
      redo: 'Rétablir',
    },
    apiErrors: {
      fieldNotAllowedTpl: 'Le champ « {field} » ne peut pas être envoyé dans cette opération.',
      mustBeTextTpl: '{field} doit être du texte.',
      mustBeBooleanTpl: '{field} doit être vrai ou faux.',
      mustBeTypeTpl: '{field} a un format non valide.',
      requiredTpl: '{field} est obligatoire.',
      minLengthTpl: '{field} doit contenir au moins {n} caractères.',
      maxLengthTpl: '{field} doit contenir au plus {n} caractères.',
      upstream: 'Le service marketing ne répond pas. Réessayez dans quelques secondes.',
      notFound: 'Introuvable.',
      tooLarge: 'L\'image ou le contenu est trop volumineux.',
      unauthorized: 'Votre session a expiré. Reconnectez-vous.',
      forbidden: 'Vous n\'avez pas l\'autorisation pour cette action.',
      invalidLocale: 'Langue non valide.',
      fieldSlug: 'Slug',
      fieldTitle: 'Titre',
      fieldContent: 'Contenu',
      fieldOgImage: 'Image OG',
      fieldPublishedAt: 'Date de publication',
      fieldExpiresAt: 'Date d\'expiration',
      fieldIsActive: 'Statut',
      fieldKind: 'Type',
      fieldLabelTpl: 'Libellé ({lang})',
      slugTaken: 'Une landing page avec ce slug existe déjà. Choisissez-en un autre.',
      slugReserved: 'Ce slug est réservé : une page de l’application utilise déjà cette URL. Choisissez-en un autre.',
    },
    copyFields: {
      secHero: 'Hero (bannière)',
      secFeatures: 'Fonctionnalités — section',
      secFeatureCardTpl: 'Fonctionnalités — carte {n}',
      secFaq: 'FAQ — section',
      secFaqItemTpl: 'FAQ — question {n}',
      secPricing: 'Tarifs',
      secCtaFinal: 'Appel à l\'action final',
      secFooter: 'Pied de page',
      titleLine1: 'Titre — ligne 1 (noir)',
      titleLine2: 'Titre — ligne 2 (violet)',
      titleSizeDesktop: 'Taille du titre — ordinateur (px)',
      titleSizeMobile: 'Taille du titre — mobile (px)',
      titleSizeDesktopHint: 'Plafond pour grands écrans. Vide = taille adaptative par défaut. Recommandé 48–80.',
      titleSizeMobileHint: 'Minimum sur mobile. Vide = 55 % de la valeur ordinateur. Recommandé 28–44.',
      subtitleSentence1: 'Sous-titre — phrase 1',
      subtitleSentence2: 'Sous-titre — phrase 2',
      ctaPrimary: 'Bouton principal',
      ctaSecondary: 'Bouton secondaire',
      ctaDemo: 'Bouton réserver une démo',
      ctaDemoUrl: 'URL de réservation de démo',
      title: 'Titre',
      subtitle: 'Sous-titre',
      name: 'Nom',
      description: 'Description',
      descriptionHover: 'Description étendue (au survol)',
      question: 'Question',
      answer: 'Réponse',
      titlePart1: 'Titre — partie 1 (blanc)',
      titlePart2: 'Titre — partie 2 (violet clair)',
      button: 'Bouton',
      tagline: 'Slogan',
      auto: 'Auto',
    },
    logs: {
      title: 'Journal d\'activité',
      subtitle: 'Journal détaillé de toutes les activités qui consomment des crédits',
      totalLogs: 'Entrées au total',
      documents: 'Documents',
      translations: 'Traductions',
      searchPlaceholder: 'Rechercher par commande, compte ou utilisateur...',
      allActions: 'Toutes les actions',
      filterStatusCompleted: 'Statut : terminée',
      actionAccountStatus: 'Statut du compte',
      actionAccountStatusChange: 'Changement de statut du compte',
      actionMemberUpdate: 'Membre mis à jour',
      actionFeatureToggle: 'Fonctionnalité activée/désactivée',
      actionSettingsUpdate: 'Paramètres mis à jour',
      colOrder: 'Commande',
      colDetails: 'Détails',
      noLogs: 'Aucune entrée trouvée',
      loadFailed: 'Impossible de charger les entrées.',
      pageOfTpl: 'Page {page} sur {pages}',
      totalTpl: '({n} au total)',
      csvDate: 'Horodatage',
    },
    webinar: {
      titleTpl: 'Inscriptions · {slug}',
      subtitleTpl: 'Inscriptions reçues via {endpoint} avec {field}.',
      reload: 'Recharger',
      totalParticipants: 'Participants au total',
      language: 'Langue',
      latestSignup: 'Dernière inscription',
      searchPlaceholder: 'Rechercher par e-mail ou pseudo…',
      empty: 'Aucun participant pour l\'instant.',
      loadFailed: 'Impossible de charger les inscriptions.',
      colEmail: 'E-mail',
      colSource: 'Source',
      colDate: 'Date',
      csvCreatedAt: 'Créé le',
    },
    support: {
      title: 'Support',
      subtitle: 'Boîte de réception de toute la plateforme EZDocuAI',
      searchPlaceholder: 'Rechercher par objet ou résumé…',
      anyPriority: 'Toute priorité',
      statusOpen: 'Ouvert',
      statusPending: 'En attente',
      statusSolved: 'Résolu',
      statusSnoozed: 'Reporté',
      statusSpam: 'Spam',
      priorityLow: 'Basse',
      priorityNormal: 'Normale',
      priorityHigh: 'Haute',
      priorityUrgent: 'Urgente',
      channelEmail: 'E-mail',
      channelChat: 'Chat',
      channelApi: 'API',
      channelForm: 'Formulaire',
      channelSlack: 'Slack',
      sentimentPositive: 'Positif',
      sentimentNegative: 'Négatif',
      sentimentNeutral: 'Neutre',
      sentimentAngry: 'Mécontent',
      noTickets: 'Aucun ticket ne correspond aux filtres.',
      colSubject: 'Objet',
      colChannel: 'Canal',
      colPriority: 'Priorité',
      colStatus: 'Statut',
      colSentiment: 'Sentiment',
      colCreated: 'Créé',
      noSubject: '(sans objet)',
      pageTpl: 'Page {n}',
      connectError: 'Impossible de se connecter à la boîte de réception du support.',
      backToInbox: 'Retour à la boîte de réception',
      ticketNotFound: 'Ticket introuvable',
      ticketLoadError: 'Impossible de charger le ticket.',
      timeNow: 'maintenant',
      timeMinTpl: 'il y a {n} min',
      timeHourTpl: 'il y a {n} h',
      timeDayTpl: 'il y a {n} j',
      createdTpl: 'Créé {time}',
      hideContext: 'Masquer le panneau de contexte',
      showContext: 'Afficher le panneau de contexte',
      aiSummary: 'Résumé de l\'IA',
      internalNotePlaceholder: 'Note interne (visible seulement par les agents)…',
      replyPlaceholder: 'Écrivez une réponse au client…',
      send: 'Envoyer',
      internalNote: 'Note interne',
      internalNoteNoEmail: 'Les notes internes ne sont jamais envoyées par e-mail',
      uncheckNoEmail: 'Décochez pour ne pas envoyer d\'e-mail au client (il verra toujours la réponse dans son tableau de bord)',
      notifyByEmail: 'Notifier par e-mail',
      enterSendsTpl: '{enter} envoie · {shift} nouvelle ligne',
      ticketContext: 'Contexte du ticket',
      closePanel: 'Fermer le panneau',
      suggestedDraft: 'Brouillon suggéré',
      generatedByAi: 'Généré par l\'IA',
      aiBadge: 'IA',
      useReply: 'Utiliser la réponse',
      copy: 'Copier',
      discard: 'Ignorer',
      customer: 'Client',
      agent: 'Agent',
      aiAssistant: 'Assistant IA',
      internalBadge: 'interne',
      ezdocuCustomer: 'Client EZDocuAI',
      anonymousSender: 'Expéditeur anonyme',
      copyUserId: 'Copier l\'ID utilisateur',
      userSessionsPosthog: 'Sessions dans PostHog',
      userSessionsPosthogTitle: 'Voir les enregistrements de cet utilisateur dans PostHog',
      visitorBadge: 'Visiteur (non inscrit sur EZDocuAI)',
      lastActivity: 'Dernière activité :',
      lastLogin: 'Dernière connexion :',
      lastPage: 'Dernière page :',
      timezone: 'Fuseau horaire :',
      signupDate: 'Inscription :',
      purchasesTitle: 'Achats et commandes',
      statTotal: 'Total',
      statCompleted: 'Terminées',
      statInProgress: 'En cours',
      statCredits: 'Crédits',
      accountName: 'Nom',
      legalName: 'Raison sociale',
      taxId: 'Identifiant fiscal',
      website: 'Site web',
      accountStatus: 'Statut du compte',
      yes: 'Oui',
      no: 'Non',
      dateFormat: 'Format de date',
      accountCreated: 'Compte créé',
      owner: 'Propriétaire',
      accountDetails: 'Détails du compte',
      membersTitle: 'Membres du compte',
      noMembers: 'Aucun membre.',
      inactive: 'Inactif',
      pending: 'En attente',
      aiAssist: 'Assistance IA',
      intentTpl: 'intention · {intent}',
      suggestedTags: 'Étiquettes suggérées',
      sessionReplay: 'Enregistrement de la session',
      sessionReplayDesc: 'Voyez exactement ce que l\'utilisateur a fait avant d\'ouvrir le ticket (clics, navigation, requêtes réseau).',
      openPosthog: 'Ouvrir dans PostHog →',
      relatedOrder: 'Commande liée',
      goToOrder: 'Voir le détail de la commande →',
      relatedDocument: 'Document concerné',
      openDocument: 'Ouvrir le document →',
      unassigned: 'Non assigné',
      detailTags: 'Étiquettes',
      noTags: 'Aucune étiquette',
      detailLanguage: 'Langue',
      detailFirstResponse: '1re réponse',
      detailResolved: 'Résolu',
      detailSlaBreached: 'SLA dépassé',
      pastConversations: 'Conversations précédentes',
      firstTime: 'C\'est la première fois que ce client écrit.',
      activityLog: 'Journal d\'activité',
      noEvents: 'Aucun événement.',
      relToday: 'aujourd\'hui',
      relDaysTpl: '{n} j',
      relWeeksTpl: '{n} sem.',
      relMonthsTpl: '{n} mois',
      actorSystem: 'Système',
      actorSomeone: 'Quelqu\'un',
      actCreated: 'a créé le ticket',
      actAssigned: 'a assigné le ticket',
      actUnassigned: 'a retiré l\'assignation du ticket',
      actStatusChanged: 'a changé le statut',
      actPriorityChanged: 'a changé la priorité',
      actTagAdded: 'a ajouté une étiquette',
      actTagRemoved: 'a retiré une étiquette',
      actReplySent: 'a envoyé une réponse',
      actNoteAdded: 'a ajouté une note interne',
      actResolved: 'a résolu le ticket',
      actReopened: 'a rouvert le ticket',
      actSnoozed: 'a reporté le ticket',
      actMerged: 'a fusionné le ticket',
      viewWidgetConversation: 'Voir la conversation du widget',
      widgetConversation: 'Conversation du widget',
      messagesOne: '{n} message',
      messagesOther: '{n} messages',
      attachedImage: 'Image jointe',
      attachment: 'Pièce jointe',
      attachedFile: 'Fichier joint',
      fileFallback: 'fichier',
      loading: 'Chargement…',
    },
  },
  adminPayments: {
    title: 'Paiements',
    transactionsOne: '{n} transaction',
    transactionsOther: '{n} transactions',
    subtitle: 'achats de plan, packs de crédits, renouvellements et rechargements automatiques',
    refresh: 'Actualiser',
    exportExcel: 'Exporter en Excel',
    exporting: 'Export en cours…',
    exportError: 'Impossible d\'exporter. Veuillez réessayer.',
    searchPlaceholder: 'Rechercher par client, e-mail, compte, plan ou ID Stripe…',
    countOf: '{n} sur {total}',
    loading: 'Chargement…',
    empty: 'Aucun paiement enregistré pour le moment.',
    emptyFiltered: 'Aucun paiement ne correspond à ces filtres.',
    viewAccount: 'Voir le compte',
    staleBackend: 'Le serveur n\'applique pas encore ces filtres : le tableau ne filtre que les 200 paiements les plus récents et les totaux portent sur tous les paiements. Le fichier Excel, lui, est complet et filtré.',
    filters: {
      period: 'Période',
      type: 'Type',
      status: 'Statut',
      from: 'Du',
      to: 'Au',
      clear: 'Effacer les filtres',
      sinceDate: 'Depuis le {date}',
      untilDate: 'Jusqu\'au {date}',
    },
    periods: {
      all: 'Tout',
      thisMonth: 'Ce mois-ci',
      lastMonth: 'Mois dernier',
      last30Days: '30 derniers jours',
      thisYear: 'Cette année',
      custom: 'Personnalisé',
    },
    categories: {
      all: 'Tous',
      plan: 'Plans',
      credits: 'Packs de crédits',
      autoRecharge: 'Rechargements automatiques',
      refund: 'Remboursements',
    },
    statusAll: 'Tous',
    statuses: {
      active: 'Actif',
      trial: 'À l\'essai',
      cancelsAtEnd: 'Annulation prévue',
      canceled: 'Annulé',
      unpaid: 'Impayé',
      incomplete: 'Incomplet',
      unknown: 'Sans donnée',
      paid: 'Payé',
      refund: 'Remboursement',
    },
    statusHelp: {
      active: 'Abonnement actif : il sera renouvelé automatiquement.',
      cancelsAtEnd: 'Annulé par le client : il ne sera pas renouvelé à la fin de la période.',
      unpaid: 'Stripe n\'a pas pu encaisser le renouvellement.',
      unknown: 'Impossible de consulter Stripe ; le prochain prélèvement est une estimation.',
    },
    cycles: {
      yearly: 'Annuel',
      monthly: 'Mensuel',
    },
    items: {
      plan: 'Plan',
      creditPack: 'Pack de crédits',
      autoRecharge: 'Rechargement automatique',
      refund: 'Remboursement',
    },
    cards: {
      revenue: 'Chiffre d\'affaires',
      total: 'Total',
      netAndRefunds: 'Net {net} · remboursements {refunds}',
      customersOne: '{n} client',
      customersOther: '{n} clients',
      thisMonth: 'Ce mois-ci',
      plans: 'Plans',
      paymentsOne: '{n} paiement',
      paymentsOther: '{n} paiements',
      creditPacks: 'Packs de crédits',
      purchasesOne: '{n} achat',
      purchasesOther: '{n} achats',
      activeSubscriptions: 'Abonnements actifs',
      today: 'Aujourd\'hui',
      mrr: 'MRR {usd}',
      cancelling: '{n} en cours d\'annulation',
      unpaid: '{n} en impayé',
      unknown: '{n} sans donnée',
      creditsSold: 'Crédits vendus',
    },
    columns: {
      date: 'Date',
      customer: 'Client',
      account: 'Compte',
      item: 'Article',
      cycle: 'Cycle',
      status: 'Statut',
      nextCharge: 'Proch. prélèvement',
      description: 'Description',
      credits: 'Crédits',
      amount: 'Montant',
      stripeId: 'ID Stripe',
      mode: 'Mode',
    },
    excel: {
      sheet: 'Paiements',
      date: 'Date',
      customer: 'Client',
      email: 'E-mail',
      account: 'Compte',
      type: 'Type',
      cycle: 'Cycle',
      status: 'Statut',
      nextCharge: 'Prochain prélèvement',
      description: 'Description',
      credits: 'Crédits',
      amountUsd: 'Montant USD',
      stripeId: 'ID Stripe',
      mode: 'Mode',
    },
  },
  adminAiCosts: {
    title: 'Coûts IA',
    subtitle: "Ce qu'EZDocu dépense en IA, avec Claude (Anthropic) et Gemini (Google), par processus, modèle, jour et compte.",
    refresh: 'Actualiser',
    exportExcel: 'Excel',
    exporting: 'Export en cours…',
    exportError: "Impossible de générer le fichier Excel. Veuillez réessayer.",
    exportTruncated: 'Le fichier Excel ne contient que les {n} premières lignes. Réduisez la période pour voir le reste.',
    exportEmpty: "Aucune ligne à exporter pour cette période.",
    updatedAt: 'Mis à jour à {time}',
    envSwitchLabel: 'Environnement',
    envBadge: { production: 'Production', staging: 'Staging', qa: 'QA', local: 'Local' },
    filters: {
      period: 'Période',
      provider: 'Fournisseur',
      allProviders: 'Tous',
      from: 'Du',
      to: 'Au',
      apply: 'Appliquer',
      rangeTooLong: 'La période ne peut pas dépasser {n} jours.',
      rangeIncomplete: 'Choisissez les deux dates.',
    },
    periods: {
      today: "Aujourd'hui",
      last7: '7 derniers jours',
      thisMonth: 'Ce mois-ci',
      lastMonth: 'Mois précédent',
      last30: '30 derniers jours',
      last90: '90 derniers jours',
      custom: 'Personnalisée',
    },
    kpis: {
      totalAi: 'Dépense IA totale',
      platform: 'Plateforme',
      callcenter: "Centre d'appels",
      claude: 'Claude',
      gemini: 'Gemini',
      perPage: 'Coût par page',
      perOrder: 'Par commande {usd}',
      ofTotal: '{pct} du total',
      callsOne: '{n} appel',
      callsOther: '{n} appels',
      pagesOne: '{n} page',
      pagesOther: '{n} pages',
      ordersOne: '{n} commande',
      ordersOther: '{n} commandes',
      vsPrevious: 'Par rapport à {range}',
      noPrevious: 'Pas de période précédente comparable',
      platformDeltaNote: "La variation ne compare que la plateforme : le centre d'appels ne fournit pas la période précédente.",
      savingsShort: 'Économie est. {usd}',
      more: 'Dépense en hausse',
      less: 'Dépense en baisse',
    },
    charts: {
      byDay: 'Dépense par jour',
      byDayHint: 'US$ par jour, empilés par fournisseur',
      byProcess: 'Par processus',
      byProcessHint: 'Les 7 processus qui dépensent le plus',
      others: 'Autres',
      usd: 'US$',
      calls: 'Appels',
      total: 'Total',
    },
    savings: {
      title: 'Économie estimée avec Gemini',
      note: "Ce qu'auraient coûté avec Claude les appels traités par Gemini, moins ce qu'ils ont coûté. Les tests en mode fantôme sont présentés à part.",
      geminiCost: 'Coût avec Gemini',
      claudeEstimate: 'Aurait coûté avec Claude',
      savings: 'Économie',
      shadow: 'Tests en mode fantôme',
      none: "Aucun processus n'a utilisé Gemini sur cette période.",
      process: 'Processus',
    },
    tables: {
      byModel: 'Par modèle',
      byProcess: 'Par processus',
      model: 'Modèle',
      process: 'Processus',
      provider: 'Fournisseur',
      calls: 'Appels',
      tokensIn: 'Entrée',
      cacheRead: 'Cache en lecture',
      cacheWrite: 'Cache en écriture',
      cacheSplit: 'L {read} · É {write}',
      tokensOut: 'Sortie',
      reasoning: 'Raisonnement',
      avgSeconds: 'Durée moy.',
      usd: 'US$',
      share: '% de la dépense',
      failed: 'Échecs',
      fallbacks: 'Repli',
      stages: 'Étapes',
      models: 'Modèles',
      providers: 'Fournisseurs',
      unknownPriceOne: '{n} appel a utilisé un modèle sans tarif : il a été facturé au tarif le plus élevé.',
      unknownPriceOther: '{n} appels ont utilisé un modèle sans tarif : ils ont été facturés au tarif le plus élevé.',
    },
    top: {
      accounts: 'Comptes qui dépensent le plus',
      orders: 'Commandes qui dépensent le plus',
      account: 'Compte',
      order: 'Commande',
      ordersCount: 'Commandes',
      pages: 'Pages',
      usdPerPage: 'US$/page',
      noAccount: "Compte d'un autre environnement",
      processes: 'Processus',
      empty: 'Aucune dépense liée à des comptes sur cette période.',
    },
    environments: {
      title: 'Par environnement',
      hint: 'Chaque environnement a sa propre clé et son propre solde.',
      unavailable: 'Aucune donnée',
      notConfigured: 'Non configuré',
      noRecord: 'Suivi pas encore actif',
      otherRows: 'Cette base contient aussi {usd} d’appels faits depuis « {env} », qui ne sont pas comptés ici.',
      current: 'Affiché',
    },
    callcenter: {
      title: "Centre d'appels (support)",
      subtitle: "Chat du widget et tickets de support d'EZDocu, avec le coût de leur IA.",
      cost: 'Coût IA',
      conversations: 'Conversations',
      messages: 'Messages',
      tickets: 'Tickets',
      autoReplied: 'Réponses automatiques',
      escalated: 'Escaladés',
      byDay: 'Dépense par jour',
      byProcessModel: 'Par processus et modèle',
      noCostBefore: 'Aucun suivi des coûts avant le {date}. Les conversations, les messages et les tickets sont tout de même comptés.',
      onlyProd: "Le centre d'appels sert la production : son coût ne s'ajoute au total qu'avec Production.",
      unavailable: "La consommation du centre d'appels n'est pas disponible : {reason}.",
      empty: "Le centre d'appels n'a pas utilisé d'IA sur cette période.",
      motivos: {
        'no-configurado': "la clé de consommation n'est pas configurée sur la passerelle",
        timeout: "le centre d'appels a mis plus de 5 s à répondre",
        'no-autorizado': "le centre d'appels a refusé la clé de consommation",
        'rango-invalido': "le centre d'appels n'accepte pas cette période",
        http: "le centre d'appels a répondu avec l'erreur {code}",
        red: "impossible de se connecter au centre d'appels",
        'respuesta-invalida': "le centre d'appels a répondu dans un format inattendu",
      },
    },
    states: {
      loading: 'Chargement…',
      empty: "Aucun appel à l'IA sur cette période",
      emptyHint: 'Essayez une période plus large.',
      noTable: "Le suivi des coûts n'est pas encore actif dans cet environnement : la migration 030 de processing-ms doit encore être appliquée à la main.",
      error: 'Impossible de charger les coûts IA ({reason}).',
      retry: 'Réessayer',
      noRecordBefore: 'Aucun suivi des coûts avant le {date}.',
      backfillNote: "Inclut {usd} d'historique estimé, antérieur au suivi en direct.",
      notConfigured: "Cet environnement n'est pas configuré sur le serveur.",
    },
    groups: {
      'crear-orden': 'Créer une commande',
      procesar: 'Traiter',
      traducir: 'Traduire',
      revisar: 'Réviser',
      glosario: 'Glossaire',
      formato: 'Format',
      admin: 'Admin',
      latente: 'Inutilisé',
    },
    processes: {
      clasificacion: 'Classification du document',
      'clasificacion-sombra': 'Classification (test fantôme)',
      'giro-texto': 'Rotation de la page',
      'esquinas-foto': 'Recadrage de photo',
      transcripcion: 'Transcription des pages',
      'marcas-bbox': 'Emplacement des tampons et signatures',
      'tablas-validador': 'Détection des tableaux',
      'traduccion-html': 'Traduction page par page',
      'traduccion-terminos': 'Liste de termes',
      'traduccion-textos': 'Traduction par textes (Word/ODT/blocs)',
      'post-edicion': 'Post-édition',
      'corpus-correcciones': 'Termes issus des corrections',
      'corpus-extractor': 'Glossaire à partir de paires',
      'glosario-validador': 'Validation des termes',
      'glosario-ingesta': 'Import de dictionnaires',
      'glosario-metadatos': 'Langues du dictionnaire',
      'cierre-formula': 'Formule de clôture',
      'plantilla-nombre': 'Nom du modèle',
      'insights-chat': "Assistant de l'admin",
      'mensaje-compartir': 'Amélioration du message de partage',
      'manuscrito-docx-legacy': 'Manuscrit vers Word (ancien)',
      'escaneo-foto-legacy': 'Numérisation de photo (ancienne)',
      'fusion-parrafos': 'Fusion de paragraphes',
      preanalisis: 'Pré-analyse du document',
      'preproceso-ocr': "Prétraitement de l'OCR",
      'legacy-colores': 'Couleurs (ancien)',
      'legacy-tablas-hoja': 'Tableaux par page (ancien)',
      'legacy-transcripcion-html': 'Transcription HTML (ancienne)',
      traduccion: 'Traduction (historique)',
      'widget-chat': 'Chat du widget',
      autoresponder: 'Réponse automatique aux tickets',
      tagger: 'Étiquetage des tickets',
      summary: 'Résumé des conversations',
      embeddings: 'Embeddings pour la recherche',
    },
    stages: {
      principal: 'Principale',
      precalentado: 'Préchauffage du cache',
      antibucle: 'Anti-boucle',
      'reintento-corte': 'Nouvelle tentative après coupure',
      'sin-contexto': 'Sans contexte',
      backfill: 'Historique estimé',
    },
    providers: { anthropic: 'Claude (Anthropic)', gemini: 'Gemini (Google)', voyage: 'Voyage AI', other: 'Autre' },
    sources: { vivo: 'En direct', backfill: 'Historique estimé' },
    summaryCard: {
      title: 'Coûts IA',
      seeDetail: 'Voir le détail',
      platformOnly: "Plateforme uniquement. Le centre d'appels et la répartition par processus sont dans le détail.",
      noData: 'Aucune donnée de coûts IA pour cette période.',
    },
    excel: {
      sheet: 'Coûts IA',
      date: 'Date',
      environment: 'Environnement',
      provider: 'Fournisseur',
      model: 'Modèle',
      process: 'Processus',
      processId: 'ID du processus',
      stage: 'Étape',
      calls: 'Appels',
      failed: 'Échecs',
      fallbacks: 'Repli',
      shadow: 'Fantôme',
      tokensUncached: "Tokens d'entrée",
      cacheRead: 'Tokens de cache (lecture)',
      cacheWrite: 'Tokens de cache (écriture)',
      tokensOut: 'Tokens de sortie',
      reasoning: 'Tokens de raisonnement',
      usd: 'US$',
      avgSeconds: 'Secondes moyennes',
      source: 'Source',
      yes: 'Oui',
      no: 'Non',
    },
  },
  glossary: {
    title: 'Glossaire global',
    subtitle: 'Terminologie partagée entre tous les comptes. Utilisée dans les traductions automatiques.',
    categoriesBtn: 'Catégories',
    uploadFile: 'Téléverser fichier',
    newTerm: 'Nouveau terme',
    breadcrumbRoot: 'Glossaire',
    categoriesWithDataTpl: 'Catégories avec termes ({n})',
    emptyCategoriesTpl: 'Catégories vides ({n})',
    termsCountOne: '{n} terme',
    termsCountOther: '{n} termes',
    pairsCountOne: '{n} paire',
    pairsCountOther: '{n} paires',
    defsCountTpl: '{n} déf.',
    backToCategories: 'Catégories',
    pairType: 'Paire bilingue',
    definitionType: 'Monolingue (définition)',
    pairTypeDescTpl: 'Terme + traduction. {n} entrées.',
    definitionTypeDescTpl: 'Terme + définition. {n} entrées.',
    backToTypes: 'Types',
    langComboTermsTpl: '{n} termes · {combo}',
    emptyType: 'Aucune entrée dans ce type.',
    deleteLangTitle: 'Supprimer termes',
    deleteLangBodyTpl: 'Vous allez supprimer {n} termes de {cat} · {combo}.',
    deleteCannotUndo: 'Cette action est irréversible.',
    cancel: 'Annuler',
    deleteCountTpl: 'Supprimer {n}',
    backToLanguages: 'Langues',
    filterByLetter: 'Filtrer par lettre',
    allLetters: 'Toutes',
    search: 'Rechercher',
    searchPlaceholder: 'Rechercher un terme ou une traduction...',
    onlyVerified: 'Vérifiés uniquement',
    refresh: 'Actualiser',
    downloadPdf: 'Télécharger PDF',
    generatingPdf: 'Génération…',
    downloadPdfTipFiltered: 'Le téléchargement respecte les filtres actifs',
    downloadPdfTipAll: 'Télécharger TOUT le glossaire de cette catégorie/type',
    selectFilterCountTpl: 'Sélectionner les {n} termes du filtre',
    selectedCountTpl: '{n} sélectionnés',
    allFilter: '(tout le filtre)',
    verify: 'Vérifier',
    unverify: 'Dévérifier',
    clear: 'Effacer',
    pageXofYTpl: 'page {p} / {t}',
    letterLabelTpl: 'lettre {l}',
    otherLetter: 'autres',
    noTerms: 'Aucun terme avec ces filtres.',
    previous: '← Précédent',
    next: 'Suivant →',
    term: 'Terme',
    translation: 'Traduction',
    definition: 'Définition',
    source: 'Source',
    actions: 'Actions',
    verifiedTitle: 'Vérifié · cliquez pour dévérifier',
    unverifiedTitle: 'Non vérifié · cliquez pour approuver',
    selectPage: 'Sélectionner cette page',
    entryNewTitle: 'Nouveau terme',
    entryEditTitle: 'Modifier terme',
    fieldCategory: 'Catégorie',
    fieldCategoryHelp: 'Regroupe les termes par domaine (juridique, médical, technique...). Utilisé pour suggérer le bon glossaire lors de la traduction.',
    fieldType: 'Type',
    fieldTypeHelp: 'Paire de traduction = terme source + terme cible dans une autre langue. Définition (monolingue) = terme + explication dans la même langue.',
    fieldSourceTerm: 'Terme source',
    fieldSourceTermHelp: 'Le mot ou la phrase tels qu\'ils apparaissent dans le document original. Stocké en minuscules pour une recherche insensible à la casse.',
    fieldLang: 'Langue',
    fieldSourceLangHelp: 'Langue du terme source en code ISO-639-1 (es, en, pt, fr, it, de).',
    fieldTranslation: 'Traduction',
    fieldTranslationHelp: 'Comment le terme source doit être traduit dans la langue cible. Utilisé comme référence préférentielle.',
    fieldTargetLangHelp: 'Langue du terme traduit (ISO-639-1).',
    fieldDefinition: 'Définition',
    fieldDefinitionHelp: 'Explication du terme dans la même langue que la source. Utile pour les termes techniques/juridiques sans traduction directe.',
    fieldContext: 'Contexte (facultatif)',
    fieldContextHelp: 'Notes sur quand ce terme s\'applique (pays, sous-domaine, registre). Guide pour le réviseur uniquement.',
    fieldPriority: 'Priorité (0-100)',
    fieldPriorityHelp: 'Parmi les doublons, la priorité la plus élevée l\'emporte. 0 = normal, 50+ = préféré, 100 = toujours forcer.',
    fieldVerified: 'Vérifié',
    fieldVerifiedHelp: 'Marque les termes examinés par un humain. Les vérifiés priment sur les non-vérifiés lors de la traduction.',
    fieldSourceKind: 'Type de source',
    fieldSourceKindHelp: 'D\'où vient le terme : Manuel, PDF/CSV/TXT, IA (Claude), Web (page publique), Client (document privé).',
    fieldSourceLabel: 'Nom / référence',
    fieldSourceLabelHelp: 'Nom lisible de la source pour l\'audit. Apparaît dans la colonne Source du tableau.',
    fieldSourceUrl: 'URL (si vient du web)',
    fieldSourceUrlHelp: 'Lien canonique vers la page originale. Si vide, aucun lien n\'est affiché dans le tableau.',
    fieldSourceUrlHint: 'Ex : https://www.justicia.ar/herramientas/glosario',
    provenanceTitle: 'Source / Provenance',
    selectPlaceholder: '— Sélectionner —',
    entryPairOption: 'Paire de traduction',
    entryDefinitionOption: 'Définition (monolingue)',
    save: 'Enregistrer',
    sourceTermPlaceholder: 'Ex : acte de naissance',
    translationPlaceholder: 'Ex : birth certificate',
    definitionPlaceholder: 'Définition du terme dans la même langue que la source...',
    contextPlaceholder: 'Ex : utilisé dans les documents juridiques en Colombie',
    sourceLabelPlaceholder: 'Ex : Cabanellas 2023 / Client ACME',
    originalFile: 'Fichier original',
    sourceManual: 'Manuel',
    sourcePdf: 'PDF',
    sourceCsv: 'CSV',
    sourceTxt: 'TXT',
    sourceAi: 'IA',
    sourceLearning: 'Traduction',
    sourceWeb: 'Web',
    sourceClient: 'Client',
    uploadTitle: 'Envoyer glossaire',
    uploadConfirmTitle: 'Confirmer les données',
    tabFile: 'Fichier',
    tabUrl: 'URL',
    tabPaste: 'Coller texte',
    uploadClickToSelect: 'Cliquer pour sélectionner un fichier',
    uploadHint: 'PDF, CSV ou TXT · sans limite de taille',
    uploadAnalyzing: 'Claude analyse le fichier…',
    urlFieldLabel: 'URL du glossaire',
    urlFieldHint: 'Ex : https://www.justicia.ar/herramientas/glosario',
    analyzeUrl: 'Analyser URL',
    readingPage: 'Lecture de la page…',
    pageTitleLabel: 'Titre',
    pasteFieldLabel: 'Contenu (coller depuis Claude Max, Excel, web, etc.)',
    pasteFieldHint: 'Détecté comme CSV si virgules + retours à la ligne ; sinon traité comme texte libre',
    pastePlaceholder: 'source_term,source_lang,target_term,target_lang,entry_type\nacte de naissance,fr,birth certificate,en,pair\n...',
    sourceName: 'Nom de la source',
    sourceNamePlaceholder: 'Ex : Claude Max — Glossaire juridique',
    originalUrlOptional: 'URL originale (facultatif)',
    analyzeText: 'Analyser texte',
    analyzing: 'Analyse…',
    claudeHelpTitle: '💡 Ce que Claude fait à l\'envoi :',
    claudeHelpDetectLangs: 'Détecte les langues (source / cible)',
    claudeHelpDetectType: 'Détecte le type (paire bilingue ou monolingue)',
    claudeHelpSuggestCategory: 'Suggère une catégorie appropriée',
    claudeHelpSaveSource: 'Enregistre la source (fichier / URL / label) sur chaque terme',
    claudeAnalyzedTpl: 'Claude a analysé {file} ({chars} chars). Vérifiez et corrigez si nécessaire.',
    destCategory: 'Catégorie de destination',
    contentType: 'Type de contenu',
    pairOption: 'Paire bilingue',
    monolingualOption: 'Monolingue',
    srcLang: 'Langue source',
    tgtLang: 'Langue cible',
    savedSource: 'Source enregistrée sur chaque terme',
    changeSource: '← Changer source',
    process: 'Traiter',
    urlInvalid: 'URL invalide',
    urlEmpty: 'Saisir une URL',
    urlNoText: 'La page n\'a pas renvoyé assez de texte',
    pasteTooShort: 'Coller au moins 200 caractères de contenu',
    urlErrorGeneric: 'Erreur lors de l\'analyse de l\'URL',
    detectError: 'Impossible de détecter les métadonnées',
    uploadErrorGeneric: 'Erreur d\'envoi',
    confSure: 'sûr',
    confProbable: 'probable',
    confUnsure: 'incertain',
    msgTermCreated: 'Terme créé',
    msgTermUpdated: 'Terme mis à jour',
    msgTermDeleted: 'Terme supprimé',
    msgSaveError: 'Erreur de sauvegarde',
    msgBulkVerifiedTpl: '{n} termes vérifiés',
    msgBulkUnverifiedTpl: '{n} termes dévérifiés',
    msgVerifyError: 'Erreur de vérification',
    msgBulkDeletedTpl: '{n} termes supprimés',
    msgDeleteError: 'Erreur de suppression',
    msgPdfDownloadedTpl: 'PDF téléchargé ({n} entrées)',
    msgPdfError: 'Erreur d\'exportation PDF',
    errorFetchEntries: 'Erreur lors de la récupération des entrées',
    helpAria: 'Aide',
    langNameEs: 'Espagnol',
    langNameEn: 'Anglais',
    langNamePt: 'Portugais',
    langNameFr: 'Français',
    langNameIt: 'Italien',
    langNameDe: 'Allemand',
    fileReadError: 'Impossible de lire le fichier',
    urlReadErrorTpl: 'Impossible de lire {url}',
    pasteLabelCsv: 'Texte collé (CSV)',
    pasteLabelText: 'Texte collé',
    noContent: 'Aucun contenu à importer',
    charsCountTpl: '{n} caractères',
    jobTitle: 'Traitement du fichier',
    jobSuccess: 'Import terminé',
    jobResultTpl: '{imported} termes importés · {duplicated} doublons ignorés',
    jobTokensIn: 'Tokens en entrée',
    jobTokensOut: 'Tokens en sortie',
    jobCacheHit: 'Lectures en cache',
    jobCostUsd: 'Coût USD',
    jobMethodModelTpl: 'Méthode : {method} · Modèle : {model}',
    jobError: 'Erreur lors du traitement du fichier',
    jobPreviewTpl: 'Aperçu : {n} termes extraits',
    jobColSource: 'Source',
    jobColTarget: 'Cible / définition',
    jobShowingTpl: '200 sur {n} affichés. La confirmation les importe tous.',
    jobDiscard: 'Abandonner',
    jobConfirm: 'Confirmer l\'import',
    jobClose: 'Fermer',
    stageQueued: 'En file d\'attente',
    stageExtracting: 'Extraction du texte',
    stageParsing: 'Analyse en cours',
    stageParsedTpl: '{done}/{total} blocs analysés',
    stageAwaiting: 'En attente de confirmation de l\'admin',
    stageInserting: 'Enregistrement des termes',
    stageDone: 'Terminé',
    stageCancelled: 'Annulé',
    stageError: 'Erreur',
    catBackToGlossaries: 'Glossaires',
    catTitle: 'Catégories de documents',
    catSubtitle: 'Types de document qui classent les termes du glossaire global. Les catégories système ne peuvent pas être supprimées.',
    catNew: 'Nouvelle catégorie',
    catEdit: 'Modifier la catégorie',
    catCreated: 'Catégorie créée',
    catUpdated: 'Catégorie mise à jour',
    catDeleted: 'Catégorie supprimée',
    catCannotDelete: 'Suppression impossible : la catégorie contient des termes.',
    catConfirmDeleteTpl: 'Supprimer la catégorie « {name} » ? Possible uniquement si elle ne contient aucun terme.',
    catShowInactive: 'Afficher les inactives',
    catCountOne: '{n} catégorie',
    catCountOther: '{n} catégories',
    catColKey: 'Clé',
    catColName: 'Nom (5 langues)',
    catColTerms: 'Termes',
    catColActive: 'Active',
    catColActions: 'Actions',
    catSystemTitle: 'Catégorie système : ne peut pas être supprimée',
    catSystemBadge: 'système',
    catActivate: 'Activer',
    catDeactivate: 'Désactiver',
    catEditBtn: 'Modifier',
    catDeleteBtn: 'Supprimer',
    catEmpty: 'Aucune catégorie pour l\'instant. Créez la première pour commencer.',
    catFieldKey: 'Clé (slug)',
    catFieldKeyHint: 'Minuscules, tirets ou _. Non modifiable ensuite.',
    catKeyPlaceholder: 'ex. : medical_lab',
    catFieldNameTpl: 'Nom {lang}',
    catFieldDescription: 'Description (facultative)',
    catFieldIcon: 'Icône (facultative)',
    catFieldIconHint: 'Emoji ou nom',
    catFieldOrder: 'Ordre',
    catActiveLabel: 'Active (disponible pour classer les termes)',
    catSave: 'Enregistrer',
  },
  sharedComponents: {
    notificationBell: {
      ariaLabel: 'Notifications',
    },
    languageSelector: {
      tooltip: 'Changer de langue',
    },
    professionalProfile: {
      associationSearchHint: 'Recherchez parmi 85+ associations vérifiées ou tapez « Autre »',
      associationSearchPlaceholder: 'Rechercher association (ex : ATA, BDÜ, CTPCBA...)',
      noResults: 'Aucun résultat',
    },
  },
  verifyPublic: {
    humanVerified: 'Vérifié par humain',
    kmsSigned: 'Signé par KMS',
    translationOnRecord: 'Traduction enregistrée',
    statusHashing: 'Vérification du fichier…',
    statusPurgedWithHash: 'Cette traduction a été réalisée et signée par le traducteur ci-dessus. Le fichier original n\'est plus stocké sur nos serveurs, mais vous pouvez téléverser votre copie ci-dessous pour vérifier que la signature correspond — le fichier est vérifié dans votre navigateur et ne quitte jamais votre appareil.',
    statusWithHash: 'Cette traduction a été réalisée et signée par le traducteur ci-dessus. Pour confirmer que le PDF que vous avez reçu est authentique, téléversez-le ci-dessous — le fichier est vérifié dans votre navigateur et ne quitte jamais votre appareil.',
    statusNoHash: 'Cette traduction a été réalisée et signée par le traducteur ci-dessus. Le contenu signé est stocké sur nos serveurs et n\'a pas été modifié.',
    documentVerifiedTitle: 'Document vérifié',
    documentVerifiedDesc: 'Le fichier téléversé correspond exactement à la traduction signée. Ce document n\'a pas été modifié.',
    fileMismatchTitle: 'Fichier non correspondant',
    fileMismatchDesc: 'Le fichier téléversé ne correspond pas à la traduction signée. Même des actions mineures comme la sauvegarde ou la compression peuvent provoquer une divergence. Veuillez demander le fichier signé et réessayer.',
    documentDetailsLabel: 'Détails du document',
    documentField: 'Document',
    orderField: 'Commande',
    languagesField: 'Langues',
    pagesField: 'Pages',
    verifiedByField: 'Vérifié par',
    verifiedOnField: 'Vérifié le',
    verifyIntegrityLabel: 'Vérifier l\'intégrité du document',
    computingHash: 'Calcul du hash…',
    dropzoneTitlePurged: 'Téléversez votre copie du PDF signé',
    dropzoneTitle: 'Téléversez le PDF fourni par le traducteur',
    dropzoneHintPurged: 'Le fichier n\'est plus sur nos serveurs. Son hash reste signé dans notre base de données et est comparé au vôtre uniquement dans votre navigateur.',
    dropzoneHint: 'Le fichier est vérifié uniquement dans votre navigateur. Il ne quitte jamais votre appareil.',
    fileNotAvailableBox: 'La comparaison directe de fichier n\'est pas disponible pour cet enregistrement. Le contenu de la traduction a été signé cryptographiquement lors de la vérification et reste inchangé sur nos serveurs.',
    disclaimerPurged: 'Zero-knowledge par conception : le fichier signé n\'est plus sur nos serveurs, mais son empreinte cryptographique est stockée de manière permanente. Téléversez votre copie pour prouver qu\'elle correspond au fichier signé par le traducteur.',
    disclaimerWithHash: 'Cette page confirme à elle seule qu\'une traduction est enregistrée auprès de ce professionnel. Elle ne valide pas le fichier en votre possession tant que vous ne le téléversez pas pour comparaison.',
    disclaimerNoHash: 'Cette page confirme qu\'une traduction est enregistrée auprès de ce professionnel. La comparaison par téléversement n\'est pas disponible pour cet enregistrement ; l\'intégrité est garantie au niveau du contenu.',
    saveBtn: 'Enregistrer cette vérification',
    verificationResultLabel: 'Résultat de la vérification',
    exactMatchTitle: 'Correspondance exacte confirmée',
    exactMatchDesc: 'Le fichier téléversé est identique à la traduction signée.',
    certificationStatementLabel: 'Déclaration de certification',
    defaultCertStatement: 'Je certifie par la présente qu\'il s\'agit d\'une traduction fidèle et exacte du document original, au mieux de mes connaissances et capacités.',
    verifiedDisclaimer: 'Le fichier téléversé correspond exactement à la traduction signée émise par le traducteur. EZDocuAI vérifie uniquement l\'intégrité du fichier. Le traducteur est seul responsable du contenu et de l\'exactitude de cette traduction.',
    reverifyBtn: 'Re-vérifier',
    fileMismatchResultTitle: 'Divergence de fichier détectée',
    fileMismatchResultDesc: 'Le fichier téléversé ne correspond pas à la traduction signée.',
    mismatchDisclaimer: 'EZDocuAI n\'analyse pas ce qui a changé. Il vérifie seulement si le fichier téléversé est identique à la traduction signée.',
    inspectedCannotConfirmTitle: 'Nous ne pouvons pas confirmer ce fichier',
    inspectedCannotConfirmDesc: 'Aucun hash de fichier n\'a été enregistré pour cette vérification, nous ne pouvons donc pas confirmer si le PDF que vous avez téléversé est celui signé par le traducteur. Demandez le fichier signé directement au traducteur.',
    yourFileHashLabel: 'Hash de votre fichier (SHA-256)',
    inspectedDisclaimer: 'Votre fichier n\'a jamais quitté votre navigateur — nous avons seulement calculé le SHA-256 localement et l\'avons gardé à l\'écran à titre de preuve. Un verdict définitif de correspondance ou non n\'est possible que pour les vérifications ayant enregistré le hash du PDF signé au moment de la signature.',
    tryAgainBtn: 'Réessayer',
    contactTranslatorBtn: 'Contacter le traducteur',
    mailtoSubject: 'Divergence de vérification – {order}',
    mailtoBody: 'Cher/Chère {translator},\n\nJ\'ai essayé de vérifier une traduction via EZDocuAI et le fichier téléversé ne correspondait pas à la version signée enregistrée.\n\nCommande : {order}\nDocument : {document}\n\nPourriez-vous me fournir une nouvelle copie numérique certifiée ?\n\nMerci.',
    cryptographicDetails: 'Détails cryptographiques',
    verificationIdLabel: 'ID de vérification',
    documentHashLabel: 'Hash du document (SHA-256)',
    contentHashLabel: 'Hash du contenu (SHA-256)',
    localVerificationNote: 'Vérification locale : le fichier est vérifié dans votre navigateur et jamais envoyé sur aucun serveur.',
    verificationIssuedAt: 'Vérification émise le {date} à {time} UTC',
    poweredBy: 'Propulsé par',
    footerDisclaimer: 'EZDocuAI est exclusivement un fournisseur de technologie. Nous n\'évaluons pas le contenu des documents, l\'exactitude des traductions ou la conformité légale. Cette page confirme uniquement l\'intégrité technique du fichier numérique.',
    zeroKnowledgeEncrypted: 'Chiffrement Zero Knowledge',
    notFoundTitle: 'Vérification introuvable',
    notFoundDesc: 'Le certificat de vérification de traduction que vous recherchez n\'existe pas ou l\'ID est invalide.',
    goToHome: 'Aller à EZDocuAI',
  },
};
